import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export type Asset = {
  __typename?: 'Asset';
  aspectRatio?: Maybe<Scalars['String']>;
  assetIngestFlow?: Maybe<AssetIngestFlow>;
  contentIdentifier?: Maybe<ContentIdentifier>;
  count?: Maybe<Scalars['Int']>;
  creatorSid?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Float']>;
  errorCause?: Maybe<Scalars['String']>;
  errorCode?: Maybe<Scalars['Int']>;
  fileNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  folderSid?: Maybe<Scalars['String']>;
  footageSid?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['Boolean']>;
  genres?: Maybe<Array<Maybe<Scalars['String']>>>;
  height?: Maybe<Scalars['Int']>;
  insertTime?: Maybe<Scalars['Float']>;
  insoundzSessionId?: Maybe<Scalars['String']>;
  insoundzSucceeded?: Maybe<Scalars['Boolean']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isReadyFormatted_1_1?: Maybe<Scalars['Boolean']>;
  isReadyFormatted_9_16?: Maybe<Scalars['Boolean']>;
  isReadyFormatted_16_9?: Maybe<Scalars['Boolean']>;
  isReadyResized_1_1?: Maybe<Scalars['Boolean']>;
  isReadyResized_9_16?: Maybe<Scalars['Boolean']>;
  isReadyResized_16_9?: Maybe<Scalars['Boolean']>;
  languageCode?: Maybe<Scalars['String']>;
  list?: Maybe<Array<Maybe<Asset>>>;
  moods?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  noWords?: Maybe<Scalars['Boolean']>;
  objectType?: Maybe<Scalars['String']>;
  orgSid?: Maybe<Scalars['String']>;
  ownerSid?: Maybe<Scalars['String']>;
  parentSid?: Maybe<Scalars['String']>;
  pathFormatted_1_1?: Maybe<Scalars['String']>;
  pathFormatted_9_16?: Maybe<Scalars['String']>;
  pathFormatted_16_9?: Maybe<Scalars['String']>;
  pathResized_1_1?: Maybe<Scalars['String']>;
  pathResized_9_16?: Maybe<Scalars['String']>;
  pathResized_16_9?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  sid?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  sourcePath?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  systemId?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  transcripted?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  userSid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
};


export type AssetCountArgs = {
  filter?: InputMaybe<AssetFilter>;
};


export type AssetListArgs = {
  filter?: InputMaybe<AssetFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type AssetActions = {
  __typename?: 'AssetActions';
  add?: Maybe<Asset>;
  addDenoisedAudioContent?: Maybe<Scalars['Boolean']>;
  approve?: Maybe<Scalars['Boolean']>;
  assetIngestFlow?: Maybe<AssetIngestFlowActions>;
  contentIdentifier?: Maybe<ContentIdentifierActions>;
  publish?: Maybe<Scalars['Boolean']>;
  remove?: Maybe<Scalars['Boolean']>;
  setOwner?: Maybe<Scalars['Boolean']>;
  unarchive?: Maybe<Scalars['Boolean']>;
  unpublish?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Asset>;
};


export type AssetActionsAddArgs = {
  values?: InputMaybe<AssetAdd>;
};


export type AssetActionsAddDenoisedAudioContentArgs = {
  denoisedAudioKey?: InputMaybe<Scalars['String']>;
};


export type AssetActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type AssetActionsSetOwnerArgs = {
  sid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
};


export type AssetActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<AssetUpdate>;
};

export type AssetAdd = {
  creatorSid?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fileNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  folderSid?: InputMaybe<Scalars['String']>;
  footageSid?: InputMaybe<Scalars['String']>;
  genres?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  height?: InputMaybe<Scalars['Int']>;
  insoundzSucceeded?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isReadyFormatted_1_1?: InputMaybe<Scalars['Boolean']>;
  isReadyFormatted_9_16?: InputMaybe<Scalars['Boolean']>;
  isReadyFormatted_16_9?: InputMaybe<Scalars['Boolean']>;
  isReadyResized_1_1?: InputMaybe<Scalars['Boolean']>;
  isReadyResized_9_16?: InputMaybe<Scalars['Boolean']>;
  isReadyResized_16_9?: InputMaybe<Scalars['Boolean']>;
  languageCode?: InputMaybe<Scalars['String']>;
  moods?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  orgSid?: InputMaybe<Scalars['String']>;
  parentSid?: InputMaybe<Scalars['String']>;
  pathFormatted_1_1?: InputMaybe<Scalars['String']>;
  pathFormatted_9_16?: InputMaybe<Scalars['String']>;
  pathFormatted_16_9?: InputMaybe<Scalars['String']>;
  pathResized_1_1?: InputMaybe<Scalars['String']>;
  pathResized_9_16?: InputMaybe<Scalars['String']>;
  pathResized_16_9?: InputMaybe<Scalars['String']>;
  sourcePath?: InputMaybe<Scalars['String']>;
  systemId?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textContent?: InputMaybe<Scalars['String']>;
  transcripted?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['Int']>;
  userSid?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type AssetFilter = {
  folderSidEqual?: InputMaybe<Scalars['String']>;
  folderSidIsNull?: InputMaybe<Scalars['Boolean']>;
  footageSidEqual?: InputMaybe<Scalars['String']>;
  footageSidIsNull?: InputMaybe<Scalars['Boolean']>;
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  insoundzSessionIdEqual?: InputMaybe<Scalars['String']>;
  isDefaultEqual?: InputMaybe<Scalars['Boolean']>;
  ownerSidEqual?: InputMaybe<Scalars['String']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  systemIdEqual?: InputMaybe<Scalars['String']>;
  typeEqual?: InputMaybe<Scalars['Int']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
  userSidEqual?: InputMaybe<Scalars['String']>;
};

export type AssetIngestFlow = {
  __typename?: 'AssetIngestFlow';
  denoiseTimeoutJobId?: Maybe<Scalars['String']>;
  denoiseTimeoutJobQueueName?: Maybe<Scalars['String']>;
  insertTime?: Maybe<Scalars['Float']>;
  objectType?: Maybe<Scalars['String']>;
  rootJobId?: Maybe<Scalars['String']>;
  rootJobQueueName?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};

export type AssetIngestFlowActions = {
  __typename?: 'AssetIngestFlowActions';
  void?: Maybe<Scalars['Boolean']>;
};

export type AssetKeyInput = {
  assetSid: Scalars['String'];
  footageId: Scalars['String'];
};

export type AssetUpdate = {
  fileNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  folderSid?: InputMaybe<Scalars['String']>;
  footageSid?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  insoundzSessionId?: InputMaybe<Scalars['String']>;
  insoundzSucceeded?: InputMaybe<Scalars['Boolean']>;
  languageCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  systemId?: InputMaybe<Scalars['String']>;
  textContent?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type AssetUsage = {
  __typename?: 'AssetUsage';
  assetSid?: Maybe<Scalars['String']>;
  boldFileName?: Maybe<Scalars['String']>;
  fileNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  insertTime?: Maybe<Scalars['Float']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  objectType?: Maybe<Scalars['String']>;
  regularFileName?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  usageType?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

export type AssetUsageActions = {
  __typename?: 'AssetUsageActions';
  void?: Maybe<Scalars['Boolean']>;
};

export type AssetUsageAdd = {
  assetSid?: InputMaybe<Scalars['String']>;
  boldFileName?: InputMaybe<Scalars['String']>;
  fileNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  regularFileName?: InputMaybe<Scalars['String']>;
  usageType?: InputMaybe<Scalars['Int']>;
};

export type AssetUsageUpdate = {
  assetSid?: InputMaybe<Scalars['String']>;
  boldFileName?: InputMaybe<Scalars['String']>;
  fileNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  regularFileName?: InputMaybe<Scalars['String']>;
  usageType?: InputMaybe<Scalars['Int']>;
};

export type AutomationData = {
  __typename?: 'AutomationData';
  editRules?: Maybe<EditRules>;
  externalPresetSid: Scalars['String'];
};

export type AutomationDataEmbeddedInput = {
  editRules?: InputMaybe<EditRulesEmbeddedInput>;
  externalPresetSid: Scalars['String'];
};

export type AutomationDataInput = {
  editRules?: InputMaybe<EditRulesInput>;
  externalPresetSid: Scalars['String'];
};

export enum AvailabilityType {
  Exists = 'exists',
  NotExists = 'notExists',
  NotExistsAndNoBalance = 'notExistsAndNoBalance'
}

export type BackgroundJob = {
  __typename?: 'BackgroundJob';
  audioSid?: Maybe<Scalars['String']>;
  insertTime?: Maybe<Scalars['Float']>;
  objectType?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['Float']>;
  subType?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};

export type BackgroundJobActions = {
  __typename?: 'BackgroundJobActions';
  void?: Maybe<Scalars['Boolean']>;
};

export type Board = {
  __typename?: 'Board';
  boardIds?: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  footageIds?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  ownerSid: Scalars['String'];
  ownerType: OwnerType;
  parentBoardIds?: Maybe<Array<Scalars['String']>>;
  updatedAt: Scalars['DateTime'];
};

export type BoardConnection = {
  __typename?: 'BoardConnection';
  /** Array of nodes. */
  nodes: Array<Board>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type BoardDeleteResponse = {
  __typename?: 'BoardDeleteResponse';
  boardIds?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  footageIds?: Maybe<Array<Scalars['String']>>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  ownerSid?: Maybe<Scalars['String']>;
  ownerType?: Maybe<OwnerType>;
  parentBoardIds?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BoardFilter = {
  and?: InputMaybe<Array<BoardFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdBy?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<BoardFilter>>;
  ownerSid?: InputMaybe<StringFieldComparison>;
  ownerType?: InputMaybe<OwnerTypeFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type BoardInput = {
  boardIds?: InputMaybe<Array<Scalars['String']>>;
  footageIds?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  parentBoardIds?: InputMaybe<Array<Scalars['String']>>;
};

export type BoardNonEmbeddedInput = {
  boardIds?: InputMaybe<Array<Scalars['String']>>;
  footageIds?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  parentBoardIds?: InputMaybe<Array<Scalars['String']>>;
};

export type BoardSort = {
  direction: SortDirection;
  field: BoardSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum BoardSortFields {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Id = 'id',
  Name = 'name',
  OwnerSid = 'ownerSid',
  OwnerType = 'ownerType',
  UpdatedAt = 'updatedAt'
}

export type BoardUpdate = {
  boardIds?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  parentBoardIds?: InputMaybe<Array<Scalars['String']>>;
};

export type BooleanFieldComparison = {
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
};

export type BulkOfWordsUpdate = {
  arrayOfArrays?: InputMaybe<Array<Array<V2_WordInput>>>;
  removeWords?: InputMaybe<Array<RemoveWordsInput>>;
};

export type Chapter = {
  __typename?: 'Chapter';
  aspectRatio?: Maybe<Scalars['String']>;
  assetSid?: Maybe<Scalars['String']>;
  audio?: Maybe<Content>;
  cid?: Maybe<Scalars['String']>;
  clipFrom?: Maybe<Scalars['Float']>;
  configurationTime?: Maybe<Scalars['Float']>;
  contentVersion?: Maybe<Scalars['Int']>;
  cuePointSid?: Maybe<Scalars['String']>;
  cuePointType?: Maybe<Scalars['Int']>;
  detections?: Maybe<Array<Maybe<Detection>>>;
  disabled?: Maybe<Scalars['Boolean']>;
  duration?: Maybe<Scalars['Float']>;
  externalId?: Maybe<Scalars['String']>;
  externalVendor?: Maybe<Scalars['String']>;
  faceDetected?: Maybe<Scalars['Boolean']>;
  fit?: Maybe<Content>;
  fitted?: Maybe<Scalars['Boolean']>;
  formated?: Maybe<Scalars['Boolean']>;
  generatingTime?: Maybe<Scalars['Float']>;
  greenScreenColor?: Maybe<Array<Maybe<Scalars['Int']>>>;
  highlighted?: Maybe<Scalars['Boolean']>;
  image?: Maybe<Scalars['Boolean']>;
  index?: Maybe<Scalars['Int']>;
  insertTime?: Maybe<Scalars['Float']>;
  key?: Maybe<Scalars['String']>;
  keyFramed?: Maybe<Scalars['Boolean']>;
  linkSid?: Maybe<Scalars['String']>;
  mask?: Maybe<Content>;
  maskPreview?: Maybe<Content>;
  masked?: Maybe<Scalars['Boolean']>;
  mute?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  noiseReducted?: Maybe<Scalars['Boolean']>;
  noiseReductedSuccessfully?: Maybe<Scalars['Boolean']>;
  objectType?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Float']>;
  resize?: Maybe<Content>;
  resized?: Maybe<Scalars['Boolean']>;
  sid?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  srcDuration?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Int']>;
  thumbnailVersion?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  transcripted?: Maybe<Scalars['Boolean']>;
  updateTime?: Maybe<Scalars['Float']>;
  verified?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['Int']>;
};

export type ChapterActions = {
  __typename?: 'ChapterActions';
  void?: Maybe<Scalars['Boolean']>;
};

export type ChapterAdd = {
  aspectRatio?: InputMaybe<Scalars['String']>;
  assetSid?: InputMaybe<Scalars['String']>;
  cid?: InputMaybe<Scalars['String']>;
  clipFrom?: InputMaybe<Scalars['Float']>;
  cuePointType?: InputMaybe<Scalars['Int']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  duration?: InputMaybe<Scalars['Float']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalToken?: InputMaybe<Scalars['String']>;
  externalVendor?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['Boolean']>;
  index?: InputMaybe<Scalars['Int']>;
  mute?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Float']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ChapterOrder = {
  cid?: InputMaybe<Scalars['String']>;
  clipFrom?: InputMaybe<Scalars['Float']>;
  duration?: InputMaybe<Scalars['Float']>;
  index?: InputMaybe<Scalars['Int']>;
  linkSid?: InputMaybe<Scalars['String']>;
  mute?: InputMaybe<Scalars['Boolean']>;
  sid?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ChapterUpdate = {
  aspectRatio?: InputMaybe<Scalars['String']>;
  assetSid?: InputMaybe<Scalars['String']>;
  cid?: InputMaybe<Scalars['String']>;
  clipFrom?: InputMaybe<Scalars['Float']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  duration?: InputMaybe<Scalars['Float']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalVendor?: InputMaybe<Scalars['String']>;
  index?: InputMaybe<Scalars['Int']>;
  mute?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Float']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Clip = {
  __typename?: 'Clip';
  assetSid?: Maybe<Scalars['String']>;
  clipFrom: Scalars['Float'];
  cuttingPoints?: Maybe<Array<ClipCuttingPoints>>;
  duration: Scalars['Float'];
  id: Scalars['ID'];
  sequences?: Maybe<Array<ClipSequence>>;
  status: ClipStatus;
  title: Scalars['String'];
  type: ClipType;
};

export type ClipByTimeInput = {
  clipFrom: Scalars['Float'];
  duration: Scalars['Float'];
  title: Scalars['String'];
};

export type ClipByTimestampsInput = {
  aspectRatios: Array<Scalars['String']>;
  clips: Array<ClipByTimeInput>;
  concat: Scalars['Boolean'];
  footageId: Scalars['String'];
};

export type ClipCuttingPoints = {
  __typename?: 'ClipCuttingPoints';
  clipFrom: Scalars['Float'];
  duration: Scalars['Float'];
  id: Scalars['ID'];
};

export type ClipCuttingPointsEmbeddedInput = {
  clipFrom: Scalars['Float'];
  duration: Scalars['Float'];
};

export type ClipCuttingPointsInput = {
  clipFrom: Scalars['Float'];
  duration: Scalars['Float'];
};

export type ClipEmbeddedInput = {
  assetSid?: InputMaybe<Scalars['String']>;
  clipFrom: Scalars['Float'];
  cuttingPoints?: InputMaybe<Array<ClipCuttingPointsEmbeddedInput>>;
  duration: Scalars['Float'];
  sequences?: InputMaybe<Array<ClipSequenceEmbeddedInput>>;
  status: ClipStatus;
  title: Scalars['String'];
  type: ClipType;
};

export type ClipInput = {
  clipFrom: Scalars['Float'];
  cuttingPoints?: InputMaybe<Array<ClipCuttingPointsInput>>;
  duration: Scalars['Float'];
  sequences: Array<ClipSequenceInput>;
  status: ClipStatus;
  title: Scalars['String'];
  type: ClipType;
};

export type ClipSequence = {
  __typename?: 'ClipSequence';
  downloadedAt?: Maybe<Scalars['DateTime']>;
  editedAt?: Maybe<Scalars['DateTime']>;
  externalSequenceId?: Maybe<Scalars['String']>;
  favorite?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  languageCode: Scalars['String'];
  openedAt?: Maybe<Scalars['DateTime']>;
  ratio: Scalars['String'];
  sequenceUserJunctions?: Maybe<Array<SequenceUserJunction>>;
  status: ClipSequenceStatus;
  title: Scalars['String'];
  type: ClipSequenceType;
};

export type ClipSequenceCloneInput = {
  ratio: Scalars['String'];
};

export type ClipSequenceEmbeddedInput = {
  downloadedAt?: InputMaybe<Scalars['DateTime']>;
  editedAt?: InputMaybe<Scalars['DateTime']>;
  externalSequenceId?: InputMaybe<Scalars['String']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  languageCode: Scalars['String'];
  openedAt?: InputMaybe<Scalars['DateTime']>;
  ratio: Scalars['String'];
  sequenceUserJunctions?: InputMaybe<Array<SequenceUserJunctionNonEmbeddedInput>>;
  status: ClipSequenceStatus;
  title: Scalars['String'];
  type: ClipSequenceType;
};

export type ClipSequenceInput = {
  externalSequenceId?: InputMaybe<Scalars['String']>;
  languageCode: Scalars['String'];
  ratio: Scalars['String'];
  status: ClipSequenceStatus;
  title: Scalars['String'];
  type: ClipSequenceType;
};

export type ClipSequenceRenameInput = {
  title: Scalars['String'];
};

export enum ClipSequenceStatus {
  Failure = 'failure',
  Pending = 'pending',
  Placeholder = 'placeholder',
  Ready = 'ready'
}

export type ClipSequenceTranslateInput = {
  languageCode: Scalars['String'];
};

export enum ClipSequenceType {
  CustomSnippets = 'CUSTOM_SNIPPETS',
  Highlight = 'HIGHLIGHT',
  Manual = 'MANUAL',
  Original = 'ORIGINAL'
}

export type ClipSequenceUpdate = {
  downloadedAt?: InputMaybe<Scalars['DateTime']>;
  editedAt?: InputMaybe<Scalars['DateTime']>;
  externalSequenceId?: InputMaybe<Scalars['String']>;
  languageCode?: InputMaybe<Scalars['String']>;
  openedAt?: InputMaybe<Scalars['DateTime']>;
  ratio?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ClipSequenceStatus>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ClipSequenceType>;
};

export enum ClipStatus {
  Completed = 'completed',
  Failure = 'failure',
  Pending = 'pending',
  Ready = 'ready'
}

export enum ClipType {
  Source = 'SOURCE',
  Topic = 'TOPIC',
  TopicByTime = 'TOPIC_BY_TIME',
  TopicByTimeConcated = 'TOPIC_BY_TIME_CONCATED'
}

export type ClipUpdate = {
  assetSid?: InputMaybe<Scalars['String']>;
  clipFrom?: InputMaybe<Scalars['Float']>;
  cuttingPoints?: InputMaybe<Array<ClipCuttingPointsInput>>;
  duration?: InputMaybe<Scalars['Float']>;
  sequences?: InputMaybe<Array<ClipSequenceUpdate>>;
  status?: InputMaybe<ClipStatus>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ClipType>;
};

export type CloneClosedCaption = {
  aspectRatio?: InputMaybe<Scalars['String']>;
  destChapterSid: Scalars['String'];
  destSequenceSid: Scalars['String'];
  languageCode?: InputMaybe<Scalars['String']>;
  srcChapterSid: Scalars['String'];
  srcSequenceSid: Scalars['String'];
};

export type ClosedCaption = {
  __typename?: 'ClosedCaption';
  aspectRatio?: Maybe<Scalars['String']>;
  assetSid?: Maybe<Scalars['String']>;
  channelTag?: Maybe<Scalars['String']>;
  chapterSid?: Maybe<Scalars['String']>;
  configurationTime?: Maybe<Scalars['Float']>;
  contentVersion?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Float']>;
  endTime?: Maybe<Scalars['Int']>;
  generatingTime?: Maybe<Scalars['Float']>;
  insertTime?: Maybe<Scalars['Float']>;
  key?: Maybe<Scalars['String']>;
  linkSid?: Maybe<Scalars['String']>;
  list?: Maybe<Array<Maybe<ClosedCaption>>>;
  listWords?: Maybe<Array<Maybe<Word>>>;
  objectType?: Maybe<Scalars['String']>;
  overlayed?: Maybe<Scalars['Boolean']>;
  sequenceSid?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  srcDuration?: Maybe<Scalars['Float']>;
  srcEndTime?: Maybe<Scalars['Int']>;
  srcStartTime?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  thumbnailVersion?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
  words?: Maybe<Array<Maybe<Word>>>;
};


export type ClosedCaptionCountArgs = {
  filter?: InputMaybe<ClosedCaptionFilter>;
};


export type ClosedCaptionListArgs = {
  filter?: InputMaybe<ClosedCaptionFilter>;
  pager?: InputMaybe<PagerAdd>;
};


export type ClosedCaptionListWordsArgs = {
  chapterSid?: InputMaybe<Scalars['String']>;
  sequenceSid?: InputMaybe<Scalars['String']>;
};

export type ClosedCaptionActions = {
  __typename?: 'ClosedCaptionActions';
  add?: Maybe<ClosedCaption>;
  deleteWords?: Maybe<Scalars['Boolean']>;
  remove?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ClosedCaption>;
  updateWords?: Maybe<Scalars['Boolean']>;
};


export type ClosedCaptionActionsAddArgs = {
  values?: InputMaybe<ClosedCaptionAdd>;
};


export type ClosedCaptionActionsDeleteWordsArgs = {
  sequenceSid?: InputMaybe<Scalars['String']>;
  words?: InputMaybe<Array<InputMaybe<WordUpdate>>>;
};


export type ClosedCaptionActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type ClosedCaptionActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<ClosedCaptionUpdate>;
};


export type ClosedCaptionActionsUpdateWordsArgs = {
  sequenceSid?: InputMaybe<Scalars['String']>;
  words?: InputMaybe<Array<InputMaybe<WordUpdate>>>;
};

export type ClosedCaptionAdd = {
  assetSid?: InputMaybe<Scalars['String']>;
  channelTag?: InputMaybe<Scalars['String']>;
  chapterSid?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Float']>;
  endTime?: InputMaybe<Scalars['Int']>;
  sequenceSid?: InputMaybe<Scalars['String']>;
  srcEndTime?: InputMaybe<Scalars['Int']>;
  srcStartTime?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
  words?: InputMaybe<Array<InputMaybe<WordAdd>>>;
};

export type ClosedCaptionFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  sequenceSidEqual?: InputMaybe<Scalars['String']>;
  sidEqual?: InputMaybe<Scalars['String']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type ClosedCaptionListWords = {
  __typename?: 'ClosedCaptionListWords';
  words?: Maybe<Array<ClosedCaptionWordOutput>>;
};

export type ClosedCaptionMetaData = {
  __typename?: 'ClosedCaptionMetaData';
  aspectRatio: Scalars['String'];
  contentVersion: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  externalChapterSid: Scalars['String'];
  externalSequenceSid: Scalars['String'];
  footageId: Scalars['String'];
  id: Scalars['ID'];
  languageCode: Scalars['String'];
  ownerSid: Scalars['String'];
  ownerType: OwnerType;
  syncWithTranscript: Scalars['Boolean'];
  transcriptEndTime: Scalars['Int'];
  transcriptStartTime: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type ClosedCaptionSyncStatus = {
  __typename?: 'ClosedCaptionSyncStatus';
  syncWithTranscript: Scalars['Boolean'];
};

export type ClosedCaptionUpdate = {
  assetSid?: InputMaybe<Scalars['String']>;
  channelTag?: InputMaybe<Scalars['String']>;
  chapterSid?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Float']>;
  endTime?: InputMaybe<Scalars['Int']>;
  srcEndTime?: InputMaybe<Scalars['Int']>;
  srcStartTime?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  words?: InputMaybe<Array<InputMaybe<WordUpdate>>>;
};

export type ClosedCaptionUpdateMetaData = {
  chapterSid: Scalars['String'];
  footageId?: InputMaybe<Scalars['String']>;
  sequenceSid: Scalars['String'];
  transcriptEndTime?: InputMaybe<Scalars['Int']>;
  transcriptStartTime?: InputMaybe<Scalars['Int']>;
};

export type ClosedCaptionV2 = {
  __typename?: 'ClosedCaptionV2';
  aspectRatio: Scalars['String'];
  contentVersion: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  externalChapterSid: Scalars['String'];
  externalSequenceSid: Scalars['String'];
  footageId: Scalars['String'];
  id: Scalars['ID'];
  languageCode: Scalars['String'];
  ownerSid: Scalars['String'];
  ownerType: OwnerType;
  syncWithTranscript: Scalars['Boolean'];
  transcriptEndTime: Scalars['Int'];
  transcriptStartTime: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  words?: Maybe<Array<ClosedCaptionWord>>;
  wordsText?: Maybe<Scalars['String']>;
};

export type ClosedCaptionV2DeleteResponse = {
  __typename?: 'ClosedCaptionV2DeleteResponse';
  aspectRatio?: Maybe<Scalars['String']>;
  contentVersion?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  externalChapterSid?: Maybe<Scalars['String']>;
  externalSequenceSid?: Maybe<Scalars['String']>;
  footageId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  languageCode?: Maybe<Scalars['String']>;
  ownerSid?: Maybe<Scalars['String']>;
  ownerType?: Maybe<OwnerType>;
  syncWithTranscript?: Maybe<Scalars['Boolean']>;
  transcriptEndTime?: Maybe<Scalars['Int']>;
  transcriptStartTime?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  words?: Maybe<Array<ClosedCaptionWord>>;
  wordsText?: Maybe<Scalars['String']>;
};

export type ClosedCaptionV2Input = {
  aspectRatio: Scalars['String'];
  assetSid: Scalars['String'];
  chapterSid: Scalars['String'];
  footageId: Scalars['String'];
  languageCode?: InputMaybe<Scalars['String']>;
  sequenceSid: Scalars['String'];
  syncWithTranscript?: InputMaybe<Scalars['Boolean']>;
  words?: InputMaybe<Array<ClosedCaptionWordInput>>;
};

export type ClosedCaptionV2NonEmbeddedInput = {
  aspectRatio: Scalars['String'];
  footageId: Scalars['String'];
  languageCode: Scalars['String'];
  transcriptEndTime: Scalars['Int'];
  transcriptStartTime: Scalars['Int'];
  words?: InputMaybe<Array<ClosedCaptionWordEmbeddedInput>>;
  wordsText?: InputMaybe<Scalars['String']>;
};

export type ClosedCaptionV2Update = {
  chapterSid: Scalars['String'];
  replace?: InputMaybe<Scalars['Boolean']>;
  sequenceSid: Scalars['String'];
  words: Array<ClosedCaptionWordInput>;
};

export type ClosedCaptionWord = {
  __typename?: 'ClosedCaptionWord';
  endTime: Scalars['Int'];
  flags?: Maybe<Scalars['Int']>;
  highlight?: Maybe<Scalars['Boolean']>;
  newLine?: Maybe<Scalars['Boolean']>;
  positionX?: Maybe<Scalars['Float']>;
  positionY?: Maybe<Scalars['Float']>;
  startTime: Scalars['Int'];
  word: Scalars['String'];
};

export type ClosedCaptionWordEmbeddedInput = {
  endTime: Scalars['Int'];
  flags?: InputMaybe<Scalars['Int']>;
  highlight?: InputMaybe<Scalars['Boolean']>;
  newLine?: InputMaybe<Scalars['Boolean']>;
  positionX?: InputMaybe<Scalars['Float']>;
  positionY?: InputMaybe<Scalars['Float']>;
  startTime: Scalars['Int'];
  word: Scalars['String'];
};

export type ClosedCaptionWordInput = {
  endTime: Scalars['Int'];
  flags?: InputMaybe<Scalars['Int']>;
  highlight?: InputMaybe<Scalars['Boolean']>;
  newLine?: InputMaybe<Scalars['Boolean']>;
  positionX?: InputMaybe<Scalars['Float']>;
  positionY?: InputMaybe<Scalars['Float']>;
  startTime: Scalars['Int'];
  word: Scalars['String'];
};

export type ClosedCaptionWordOutput = {
  __typename?: 'ClosedCaptionWordOutput';
  chapterSid: Scalars['String'];
  endTime: Scalars['Int'];
  flags?: Maybe<Scalars['Int']>;
  highlight?: Maybe<Scalars['Boolean']>;
  newLine?: Maybe<Scalars['Boolean']>;
  positionX?: Maybe<Scalars['Float']>;
  positionY?: Maybe<Scalars['Float']>;
  startTime: Scalars['Int'];
  word: Scalars['String'];
};

export type ClosedCaptionsOutput = {
  __typename?: 'ClosedCaptionsOutput';
  contentVersion: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  externalChapterSid: Scalars['String'];
  externalSequenceSid: Scalars['String'];
  id: Scalars['String'];
  ownerSid: Scalars['String'];
  ownerType: OwnerType;
  syncWithTranscript: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  words?: Maybe<Array<ClosedCaptionWordOutput>>;
};

export type Color = {
  __typename?: 'Color';
  brightness?: Maybe<Scalars['Int']>;
  brightnessIndex?: Maybe<Scalars['Int']>;
  color?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  dominancy?: Maybe<Scalars['Int']>;
  grayness?: Maybe<Scalars['Float']>;
  insertTime?: Maybe<Scalars['Float']>;
  list?: Maybe<Array<Maybe<Color>>>;
  objectType?: Maybe<Scalars['String']>;
  percent?: Maybe<Scalars['Int']>;
  rgb?: Maybe<Array<Maybe<Scalars['Int']>>>;
  sid?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};


export type ColorCountArgs = {
  filter?: InputMaybe<ColorFilter>;
};


export type ColorListArgs = {
  filter?: InputMaybe<ColorFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type ColorActions = {
  __typename?: 'ColorActions';
  add?: Maybe<Color>;
  remove?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Color>;
};


export type ColorActionsAddArgs = {
  values?: InputMaybe<ColorAdd>;
};


export type ColorActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type ColorActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<ColorUpdate>;
};

export type ColorAdd = {
  color?: InputMaybe<Scalars['String']>;
  dominancy?: InputMaybe<Scalars['Int']>;
  grayness?: InputMaybe<Scalars['Float']>;
  percent?: InputMaybe<Scalars['Int']>;
};

export type ColorFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type ColorUpdate = {
  color?: InputMaybe<Scalars['String']>;
  dominancy?: InputMaybe<Scalars['Int']>;
  grayness?: InputMaybe<Scalars['Float']>;
  percent?: InputMaybe<Scalars['Int']>;
};

export type Content = {
  __typename?: 'Content';
  aspectRatio?: Maybe<Scalars['String']>;
  assetSid?: Maybe<Scalars['String']>;
  configurationTime?: Maybe<Scalars['Float']>;
  contentVersion?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Float']>;
  filePath: Scalars['String'];
  generatingTime?: Maybe<Scalars['Float']>;
  insertTime?: Maybe<Scalars['Float']>;
  key?: Maybe<Scalars['String']>;
  linkSid?: Maybe<Scalars['String']>;
  list?: Maybe<Array<Maybe<Content>>>;
  objectType?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  srcDuration?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Int']>;
  thumbnailVersion?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};


export type ContentCountArgs = {
  filter?: InputMaybe<ContentFilter>;
};


export type ContentListArgs = {
  filter?: InputMaybe<ContentFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type ContentActions = {
  __typename?: 'ContentActions';
  add?: Maybe<Content>;
  remove?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Content>;
};


export type ContentActionsAddArgs = {
  values?: InputMaybe<ContentAdd>;
};


export type ContentActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type ContentActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<ContentUpdate>;
};

export type ContentAdd = {
  assetSid?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Float']>;
  thumbnail?: InputMaybe<Scalars['String']>;
};

export type ContentEmbeddedInput = {
  filePath: Scalars['String'];
};

export type ContentFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type ContentIdentifier = {
  __typename?: 'ContentIdentifier';
  aspectRatio?: Maybe<Scalars['String']>;
  insertTime?: Maybe<Scalars['Float']>;
  key?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  thumbnailVersion?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};

export type ContentIdentifierActions = {
  __typename?: 'ContentIdentifierActions';
  void?: Maybe<Scalars['Boolean']>;
};

export type ContentInput = {
  filePath: Scalars['String'];
};

export type ContentUpdate = {
  assetSid?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Float']>;
  filePath: Scalars['String'];
  thumbnail?: InputMaybe<Scalars['String']>;
};

export type Coupon = {
  __typename?: 'Coupon';
  count?: Maybe<Scalars['Int']>;
  countLimit?: Maybe<Scalars['Int']>;
  countUsed?: Maybe<Scalars['Int']>;
  discounts?: Maybe<Array<Maybe<Discount>>>;
  expiryTime?: Maybe<Scalars['Float']>;
  insertTime?: Maybe<Scalars['Float']>;
  list?: Maybe<Array<Maybe<Coupon>>>;
  maxRecurringCharges?: Maybe<Scalars['Int']>;
  objectType?: Maybe<Scalars['String']>;
  plans?: Maybe<Array<Maybe<Scalars['String']>>>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};


export type CouponCountArgs = {
  filter?: InputMaybe<CouponFilter>;
};


export type CouponListArgs = {
  filter?: InputMaybe<CouponFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type CouponActions = {
  __typename?: 'CouponActions';
  add?: Maybe<Coupon>;
  remove?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Coupon>;
};


export type CouponActionsAddArgs = {
  values?: InputMaybe<CouponAdd>;
};


export type CouponActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type CouponActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<CouponUpdate>;
};

export type CouponAdd = {
  countLimit?: InputMaybe<Scalars['Int']>;
  discounts?: InputMaybe<Array<InputMaybe<DiscountAdd>>>;
  expiryTime?: InputMaybe<Scalars['Float']>;
  maxRecurringCharges?: InputMaybe<Scalars['Int']>;
  plans?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CouponFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type CouponUpdate = {
  countLimit?: InputMaybe<Scalars['Int']>;
  discounts?: InputMaybe<Array<InputMaybe<DiscountUpdate>>>;
  expiryTime?: InputMaybe<Scalars['Float']>;
  maxRecurringCharges?: InputMaybe<Scalars['Int']>;
  plans?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CreateJoinedTranscriptInput = {
  srcKeys: Array<AssetKeyInput>;
  tarFootageId: Scalars['String'];
};

export type CreateManyCropDetailsInput = {
  /** Array of records to create */
  cropDetails: Array<CropDetailInput>;
};

export type CreateManyDownloadInfosInput = {
  /** Array of records to create */
  downloadInfos: Array<DownloadInfoInput>;
};

export type CreateManyFootagesInput = {
  /** Array of records to create */
  footages: Array<FootageInput>;
};

export type CreateManyTranscriptsInput = {
  /** Array of records to create */
  transcripts: Array<TranscriptInput>;
};

export type CreateOneBoardInput = {
  /** The record to create */
  board: BoardInput;
};

export type CreateOneCropDetailInput = {
  /** The record to create */
  cropDetail: CropDetailInput;
};

export type CreateOneDownloadInfoInput = {
  /** The record to create */
  downloadInfo: DownloadInfoInput;
};

export type CreateOneFootageInput = {
  /** The record to create */
  footage: FootageInput;
};

export type CreateOneTranscriptInput = {
  /** The record to create */
  transcript: TranscriptInput;
};

export type Crop = {
  __typename?: 'Crop';
  height: Scalars['Float'];
  topx: Scalars['Float'];
  topy: Scalars['Float'];
  width: Scalars['Float'];
};

export type CropData = {
  __typename?: 'CropData';
  crop: Crop;
  draw: Draw;
  end: Scalars['Float'];
  start: Scalars['Float'];
};

export type CropDataEmbeddedInput = {
  crop: CropEmbeddedInput;
  draw: DrawEmbeddedInput;
  end: Scalars['Float'];
  start: Scalars['Float'];
};

export type CropDataInput = {
  crop: CropInput;
  draw: DrawInput;
  end: Scalars['Float'];
  start: Scalars['Float'];
};

export type CropDataUpdate = {
  crop: CropUpdate;
  draw: DrawUpdate;
  end: Scalars['Float'];
  start: Scalars['Float'];
};

export type CropDetail = {
  __typename?: 'CropDetail';
  blur: Scalars['Boolean'];
  brandColorIndex?: Maybe<Scalars['Int']>;
  color: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  cropData?: Maybe<Array<CropData>>;
  externalAssetSid: Scalars['String'];
  externalSequenceSid: Scalars['String'];
  footageId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  originalAspectRatio: Scalars['String'];
  outputAspectRatio: Scalars['String'];
  outputHeight: Scalars['Float'];
  outputWidth: Scalars['Float'];
  ownerSid: Scalars['String'];
  ownerType: OwnerType;
  updatedAt: Scalars['DateTime'];
};

export type CropDetailConnection = {
  __typename?: 'CropDetailConnection';
  /** Array of nodes. */
  nodes: Array<CropDetail>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type CropDetailDeleteFilter = {
  and?: InputMaybe<Array<CropDetailDeleteFilter>>;
  blur?: InputMaybe<BooleanFieldComparison>;
  color?: InputMaybe<StringFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdBy?: InputMaybe<StringFieldComparison>;
  externalAssetSid?: InputMaybe<StringFieldComparison>;
  externalSequenceSid?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<CropDetailDeleteFilter>>;
  originalAspectRatio?: InputMaybe<StringFieldComparison>;
  outputAspectRatio?: InputMaybe<StringFieldComparison>;
  outputHeight?: InputMaybe<NumberFieldComparison>;
  outputWidth?: InputMaybe<NumberFieldComparison>;
  ownerSid?: InputMaybe<StringFieldComparison>;
  ownerType?: InputMaybe<OwnerTypeFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type CropDetailDeleteResponse = {
  __typename?: 'CropDetailDeleteResponse';
  blur?: Maybe<Scalars['Boolean']>;
  brandColorIndex?: Maybe<Scalars['Int']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  cropData?: Maybe<Array<CropData>>;
  externalAssetSid?: Maybe<Scalars['String']>;
  externalSequenceSid?: Maybe<Scalars['String']>;
  footageId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  originalAspectRatio?: Maybe<Scalars['String']>;
  outputAspectRatio?: Maybe<Scalars['String']>;
  outputHeight?: Maybe<Scalars['Float']>;
  outputWidth?: Maybe<Scalars['Float']>;
  ownerSid?: Maybe<Scalars['String']>;
  ownerType?: Maybe<OwnerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CropDetailFilter = {
  and?: InputMaybe<Array<CropDetailFilter>>;
  blur?: InputMaybe<BooleanFieldComparison>;
  color?: InputMaybe<StringFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdBy?: InputMaybe<StringFieldComparison>;
  externalAssetSid?: InputMaybe<StringFieldComparison>;
  externalSequenceSid?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<CropDetailFilter>>;
  originalAspectRatio?: InputMaybe<StringFieldComparison>;
  outputAspectRatio?: InputMaybe<StringFieldComparison>;
  outputHeight?: InputMaybe<NumberFieldComparison>;
  outputWidth?: InputMaybe<NumberFieldComparison>;
  ownerSid?: InputMaybe<StringFieldComparison>;
  ownerType?: InputMaybe<OwnerTypeFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type CropDetailInput = {
  blur: Scalars['Boolean'];
  brandColorIndex?: InputMaybe<Scalars['Int']>;
  color: Scalars['String'];
  cropData: Array<CropDataInput>;
  externalAssetSid: Scalars['String'];
  externalSequenceId: Scalars['String'];
  footageId: Scalars['String'];
  originalAspectRatio: Scalars['String'];
  outputAspectRatio: Scalars['String'];
  outputHeight: Scalars['Float'];
  outputWidth: Scalars['Float'];
};

export type CropDetailNonEmbeddedInput = {
  blur: Scalars['Boolean'];
  brandColorIndex?: InputMaybe<Scalars['Int']>;
  color: Scalars['String'];
  cropData?: InputMaybe<Array<CropDataEmbeddedInput>>;
  externalAssetSid: Scalars['String'];
  externalSequenceSid: Scalars['String'];
  footageId?: InputMaybe<Scalars['String']>;
  originalAspectRatio: Scalars['String'];
  outputAspectRatio: Scalars['String'];
  outputHeight: Scalars['Float'];
  outputWidth: Scalars['Float'];
};

export type CropDetailSort = {
  direction: SortDirection;
  field: CropDetailSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum CropDetailSortFields {
  Blur = 'blur',
  Color = 'color',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  ExternalAssetSid = 'externalAssetSid',
  ExternalSequenceSid = 'externalSequenceSid',
  Id = 'id',
  OriginalAspectRatio = 'originalAspectRatio',
  OutputAspectRatio = 'outputAspectRatio',
  OutputHeight = 'outputHeight',
  OutputWidth = 'outputWidth',
  OwnerSid = 'ownerSid',
  OwnerType = 'ownerType',
  UpdatedAt = 'updatedAt'
}

export type CropDetailUpdate = {
  blur: Scalars['Boolean'];
  brandColorIndex?: InputMaybe<Scalars['Int']>;
  color: Scalars['String'];
  cropData: Array<CropDataUpdate>;
};

export type CropDetailUpdateFilter = {
  and?: InputMaybe<Array<CropDetailUpdateFilter>>;
  blur?: InputMaybe<BooleanFieldComparison>;
  color?: InputMaybe<StringFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdBy?: InputMaybe<StringFieldComparison>;
  externalAssetSid?: InputMaybe<StringFieldComparison>;
  externalSequenceSid?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<CropDetailUpdateFilter>>;
  originalAspectRatio?: InputMaybe<StringFieldComparison>;
  outputAspectRatio?: InputMaybe<StringFieldComparison>;
  outputHeight?: InputMaybe<NumberFieldComparison>;
  outputWidth?: InputMaybe<NumberFieldComparison>;
  ownerSid?: InputMaybe<StringFieldComparison>;
  ownerType?: InputMaybe<OwnerTypeFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type CropEmbeddedInput = {
  height: Scalars['Float'];
  topx: Scalars['Float'];
  topy: Scalars['Float'];
  width: Scalars['Float'];
};

export type CropInput = {
  height: Scalars['Float'];
  topx: Scalars['Float'];
  topy: Scalars['Float'];
  width: Scalars['Float'];
};

export type CropUpdate = {
  height: Scalars['Float'];
  topx: Scalars['Float'];
  topy: Scalars['Float'];
  width: Scalars['Float'];
};

export type CuePoint = {
  __typename?: 'CuePoint';
  aspectRatio?: Maybe<Scalars['String']>;
  assetSid?: Maybe<Scalars['String']>;
  chapterSid?: Maybe<Scalars['String']>;
  configurationTime?: Maybe<Scalars['Float']>;
  contentVersion?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Float']>;
  endTime?: Maybe<Scalars['Int']>;
  generatingTime?: Maybe<Scalars['Float']>;
  insertTime?: Maybe<Scalars['Float']>;
  key?: Maybe<Scalars['String']>;
  linkSid?: Maybe<Scalars['String']>;
  list?: Maybe<Array<Maybe<CuePoint>>>;
  objectType?: Maybe<Scalars['String']>;
  overlayed?: Maybe<Scalars['Boolean']>;
  sequenceSid?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  srcDuration?: Maybe<Scalars['Float']>;
  srcEndTime?: Maybe<Scalars['Int']>;
  srcStartTime?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  thumbnailVersion?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};


export type CuePointCountArgs = {
  filter?: InputMaybe<CuePointFilter>;
};


export type CuePointListArgs = {
  filter?: InputMaybe<CuePointFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type CuePointActions = {
  __typename?: 'CuePointActions';
  activate?: Maybe<Scalars['Boolean']>;
  add?: Maybe<CuePoint>;
  deactivate?: Maybe<Scalars['Boolean']>;
  remove?: Maybe<Scalars['Boolean']>;
  reoverlay?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CuePoint>;
};


export type CuePointActionsAddArgs = {
  values?: InputMaybe<CuePointAdd>;
};


export type CuePointActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type CuePointActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<CuePointUpdate>;
};

export type CuePointAdd = {
  assetSid?: InputMaybe<Scalars['String']>;
  chapterSid?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Float']>;
  endTime?: InputMaybe<Scalars['Int']>;
  sequenceSid?: InputMaybe<Scalars['String']>;
  srcEndTime?: InputMaybe<Scalars['Int']>;
  srcStartTime?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Int']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
};

export type CuePointFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  sequenceSidEqual?: InputMaybe<Scalars['String']>;
  sidEqual?: InputMaybe<Scalars['String']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type CuePointUpdate = {
  assetSid?: InputMaybe<Scalars['String']>;
  chapterSid?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Float']>;
  endTime?: InputMaybe<Scalars['Int']>;
  srcEndTime?: InputMaybe<Scalars['Int']>;
  srcStartTime?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Int']>;
  thumbnail?: InputMaybe<Scalars['String']>;
};

export type DateFieldComparison = {
  between?: InputMaybe<DateFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  notBetween?: InputMaybe<DateFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateFieldComparisonBetween = {
  lower: Scalars['DateTime'];
  upper: Scalars['DateTime'];
};

export type DeleteManyCropDetailsInput = {
  /** Filter to find records to delete */
  filter: CropDetailDeleteFilter;
};

export type DeleteManyDownloadInfosInput = {
  /** Filter to find records to delete */
  filter: DownloadInfoDeleteFilter;
};

export type DeleteManyResponse = {
  __typename?: 'DeleteManyResponse';
  /** The number of records deleted. */
  deletedCount: Scalars['Int'];
};

export type DeleteManyTranscriptsInput = {
  /** Filter to find records to delete */
  filter: TranscriptDeleteFilter;
};

export type DeleteOneBoardInput = {
  /** The id of the record to delete. */
  id: Scalars['ID'];
};

export type DeleteOneClosedCaptionV2Input = {
  /** The id of the record to delete. */
  id: Scalars['ID'];
};

export type DeleteOneCropDetailInput = {
  /** The id of the record to delete. */
  id: Scalars['ID'];
};

export type DeleteOneDownloadInfoInput = {
  /** The id of the record to delete. */
  id: Scalars['ID'];
};

export type DeleteOneFootageInput = {
  /** The id of the record to delete. */
  id: Scalars['ID'];
};

export type DeleteOneTranscriptInput = {
  /** The id of the record to delete. */
  id: Scalars['ID'];
};

export type Detection = {
  __typename?: 'Detection';
  count?: Maybe<Scalars['Int']>;
  end?: Maybe<Scalars['Float']>;
  insertTime?: Maybe<Scalars['Float']>;
  list?: Maybe<Array<Maybe<Detection>>>;
  objectType?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Float']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
  xCenterPercentage?: Maybe<Scalars['Float']>;
  yCenterPercentage?: Maybe<Scalars['Float']>;
};


export type DetectionCountArgs = {
  filter?: InputMaybe<DetectionFilter>;
};


export type DetectionListArgs = {
  filter?: InputMaybe<DetectionFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type DetectionActions = {
  __typename?: 'DetectionActions';
  add?: Maybe<Detection>;
  remove?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Detection>;
};


export type DetectionActionsAddArgs = {
  values?: InputMaybe<DetectionAdd>;
};


export type DetectionActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type DetectionActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<DetectionUpdate>;
};

export type DetectionAdd = {
  end?: InputMaybe<Scalars['Float']>;
  start?: InputMaybe<Scalars['Float']>;
  xCenterPercentage?: InputMaybe<Scalars['Float']>;
  yCenterPercentage?: InputMaybe<Scalars['Float']>;
};

export type DetectionFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type DetectionUpdate = {
  end?: InputMaybe<Scalars['Float']>;
  start?: InputMaybe<Scalars['Float']>;
  xCenterPercentage?: InputMaybe<Scalars['Float']>;
  yCenterPercentage?: InputMaybe<Scalars['Float']>;
};

export type DetectionsInput = {
  end: Scalars['Float'];
  singleDetectionInFrame: Scalars['Boolean'];
  start: Scalars['Float'];
  xCenterPercentage: Scalars['Float'];
  yCenterPercentage: Scalars['Float'];
};

export type Dimention = {
  __typename?: 'Dimention';
  count?: Maybe<Scalars['Int']>;
  insertTime?: Maybe<Scalars['Float']>;
  list?: Maybe<Array<Maybe<Dimention>>>;
  objectType?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};


export type DimentionCountArgs = {
  filter?: InputMaybe<DimentionFilter>;
};


export type DimentionListArgs = {
  filter?: InputMaybe<DimentionFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type DimentionActions = {
  __typename?: 'DimentionActions';
  remove?: Maybe<Scalars['Boolean']>;
};


export type DimentionActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};

export type DimentionFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type Discount = {
  __typename?: 'Discount';
  amount?: Maybe<Scalars['Int']>;
  insertTime?: Maybe<Scalars['Float']>;
  objectType?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};

export type DiscountActions = {
  __typename?: 'DiscountActions';
  void?: Maybe<Scalars['Boolean']>;
};

export type DiscountAdd = {
  amount?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['Int']>;
};

export type DiscountUpdate = {
  amount?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['Int']>;
};

export type DownloadAnimation = {
  __typename?: 'DownloadAnimation';
  count?: Maybe<Scalars['Int']>;
  insertTime?: Maybe<Scalars['Float']>;
  list?: Maybe<Array<Maybe<DownloadAnimation>>>;
  objectType?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};


export type DownloadAnimationCountArgs = {
  filter?: InputMaybe<DownloadAnimationFilter>;
};


export type DownloadAnimationListArgs = {
  filter?: InputMaybe<DownloadAnimationFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type DownloadAnimationActions = {
  __typename?: 'DownloadAnimationActions';
  remove?: Maybe<Scalars['Boolean']>;
};


export type DownloadAnimationActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};

export type DownloadAnimationFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type DownloadAvailability = {
  __typename?: 'DownloadAvailability';
  availability: AvailabilityType;
};

export type DownloadInfo = {
  __typename?: 'DownloadInfo';
  contentPath?: Maybe<Scalars['String']>;
  contentVersion: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  downloadFlowRootJob?: Maybe<FlowJob>;
  durationInSec?: Maybe<Scalars['Float']>;
  externalSequenceEndVersion?: Maybe<Scalars['Int']>;
  externalSequenceId: Scalars['String'];
  externalSequenceStartVersion: Scalars['Int'];
  externalSequenceTitle: Scalars['String'];
  footageId: Scalars['String'];
  generationEndTime?: Maybe<Scalars['DateTime']>;
  generationStartTime: Scalars['DateTime'];
  hitCounter: Scalars['Float'];
  id: Scalars['ID'];
  ownerSid: Scalars['String'];
  ownerType: OwnerType;
  status: DownloadStatus;
  updatedAt: Scalars['DateTime'];
};

export type DownloadInfoConnection = {
  __typename?: 'DownloadInfoConnection';
  /** Array of nodes. */
  nodes: Array<DownloadInfo>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type DownloadInfoDeleteFilter = {
  and?: InputMaybe<Array<DownloadInfoDeleteFilter>>;
  contentVersion?: InputMaybe<IntFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdBy?: InputMaybe<StringFieldComparison>;
  externalSequenceId?: InputMaybe<StringFieldComparison>;
  externalSequenceStartVersion?: InputMaybe<IntFieldComparison>;
  externalSequenceTitle?: InputMaybe<StringFieldComparison>;
  footageId?: InputMaybe<StringFieldComparison>;
  generationStartTime?: InputMaybe<DateFieldComparison>;
  hitCounter?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DownloadInfoDeleteFilter>>;
  ownerSid?: InputMaybe<StringFieldComparison>;
  ownerType?: InputMaybe<OwnerTypeFilterComparison>;
  status?: InputMaybe<DownloadStatusFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type DownloadInfoDeleteResponse = {
  __typename?: 'DownloadInfoDeleteResponse';
  contentPath?: Maybe<Scalars['String']>;
  contentVersion?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  downloadFlowRootJob?: Maybe<FlowJob>;
  durationInSec?: Maybe<Scalars['Float']>;
  externalSequenceEndVersion?: Maybe<Scalars['Int']>;
  externalSequenceId?: Maybe<Scalars['String']>;
  externalSequenceStartVersion?: Maybe<Scalars['Int']>;
  externalSequenceTitle?: Maybe<Scalars['String']>;
  footageId?: Maybe<Scalars['String']>;
  generationEndTime?: Maybe<Scalars['DateTime']>;
  generationStartTime?: Maybe<Scalars['DateTime']>;
  hitCounter?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  ownerSid?: Maybe<Scalars['String']>;
  ownerType?: Maybe<OwnerType>;
  status?: Maybe<DownloadStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DownloadInfoFilter = {
  and?: InputMaybe<Array<DownloadInfoFilter>>;
  contentVersion?: InputMaybe<IntFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdBy?: InputMaybe<StringFieldComparison>;
  externalSequenceId?: InputMaybe<StringFieldComparison>;
  externalSequenceStartVersion?: InputMaybe<IntFieldComparison>;
  externalSequenceTitle?: InputMaybe<StringFieldComparison>;
  footageId?: InputMaybe<StringFieldComparison>;
  generationStartTime?: InputMaybe<DateFieldComparison>;
  hitCounter?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DownloadInfoFilter>>;
  ownerSid?: InputMaybe<StringFieldComparison>;
  ownerType?: InputMaybe<OwnerTypeFilterComparison>;
  status?: InputMaybe<DownloadStatusFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type DownloadInfoInput = {
  externalSequenceId: Scalars['String'];
  externalSequenceStartVersion: Scalars['Int'];
  externalSequenceTitle: Scalars['String'];
  footageId: Scalars['String'];
  generationStartTime: Scalars['DateTime'];
};

export type DownloadInfoNonEmbeddedInput = {
  contentPath?: InputMaybe<Scalars['String']>;
  contentVersion: Scalars['Int'];
  downloadFlowRootJob?: InputMaybe<FlowJobEmbeddedInput>;
  durationInSec?: InputMaybe<Scalars['Float']>;
  externalSequenceEndVersion?: InputMaybe<Scalars['Int']>;
  externalSequenceId: Scalars['String'];
  externalSequenceStartVersion: Scalars['Int'];
  externalSequenceTitle: Scalars['String'];
  footageId: Scalars['String'];
  generationEndTime?: InputMaybe<Scalars['DateTime']>;
  generationStartTime: Scalars['DateTime'];
  hitCounter: Scalars['Float'];
  status: DownloadStatus;
};

export type DownloadInfoSort = {
  direction: SortDirection;
  field: DownloadInfoSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum DownloadInfoSortFields {
  ContentVersion = 'contentVersion',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  ExternalSequenceId = 'externalSequenceId',
  ExternalSequenceStartVersion = 'externalSequenceStartVersion',
  ExternalSequenceTitle = 'externalSequenceTitle',
  FootageId = 'footageId',
  GenerationStartTime = 'generationStartTime',
  HitCounter = 'hitCounter',
  Id = 'id',
  OwnerSid = 'ownerSid',
  OwnerType = 'ownerType',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type DownloadInfoUpdate = {
  contentPath?: InputMaybe<Scalars['String']>;
  contentVersion?: InputMaybe<Scalars['Int']>;
  downloadFlowRootJob?: InputMaybe<FlowJobInput>;
  durationInSec?: InputMaybe<Scalars['Float']>;
  externalSequenceEndVersion?: InputMaybe<Scalars['Int']>;
  generationEndTime?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<DownloadStatus>;
};

export type DownloadInfoUpdateFilter = {
  and?: InputMaybe<Array<DownloadInfoUpdateFilter>>;
  contentVersion?: InputMaybe<IntFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdBy?: InputMaybe<StringFieldComparison>;
  externalSequenceId?: InputMaybe<StringFieldComparison>;
  externalSequenceStartVersion?: InputMaybe<IntFieldComparison>;
  externalSequenceTitle?: InputMaybe<StringFieldComparison>;
  footageId?: InputMaybe<StringFieldComparison>;
  generationStartTime?: InputMaybe<DateFieldComparison>;
  hitCounter?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DownloadInfoUpdateFilter>>;
  ownerSid?: InputMaybe<StringFieldComparison>;
  ownerType?: InputMaybe<OwnerTypeFilterComparison>;
  status?: InputMaybe<DownloadStatusFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export enum DownloadStatus {
  Done = 'done',
  Failed = 'failed',
  Processing = 'processing'
}

export type DownloadStatusFilterComparison = {
  eq?: InputMaybe<DownloadStatus>;
  gt?: InputMaybe<DownloadStatus>;
  gte?: InputMaybe<DownloadStatus>;
  iLike?: InputMaybe<DownloadStatus>;
  in?: InputMaybe<Array<DownloadStatus>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<DownloadStatus>;
  lt?: InputMaybe<DownloadStatus>;
  lte?: InputMaybe<DownloadStatus>;
  neq?: InputMaybe<DownloadStatus>;
  notILike?: InputMaybe<DownloadStatus>;
  notIn?: InputMaybe<Array<DownloadStatus>>;
  notLike?: InputMaybe<DownloadStatus>;
};

export type DownloadsBalance = {
  __typename?: 'DownloadsBalance';
  periodEndTime: Scalars['DateTime'];
  periodLeftDownloads?: Maybe<Scalars['Int']>;
  periodMaxDownloads: Scalars['Int'];
  periodStartTime: Scalars['DateTime'];
};

export type DownloadsCount = {
  __typename?: 'DownloadsCount';
  periodDoneDownloads: Scalars['Int'];
};

export type Draw = {
  __typename?: 'Draw';
  height: Scalars['Float'];
  topx: Scalars['Float'];
  topy: Scalars['Float'];
  width: Scalars['Float'];
};

export type DrawEmbeddedInput = {
  height: Scalars['Float'];
  topx: Scalars['Float'];
  topy: Scalars['Float'];
  width: Scalars['Float'];
};

export type DrawInput = {
  height: Scalars['Float'];
  topx: Scalars['Float'];
  topy: Scalars['Float'];
  width: Scalars['Float'];
};

export type DrawUpdate = {
  height: Scalars['Float'];
  topx: Scalars['Float'];
  topy: Scalars['Float'];
  width: Scalars['Float'];
};

export type EditRules = {
  __typename?: 'EditRules';
  count?: Maybe<Scalars['Int']>;
  insertTime?: Maybe<Scalars['Float']>;
  list?: Maybe<Array<Maybe<EditRules>>>;
  name: Scalars['String'];
  noContentVolume?: Maybe<Scalars['Float']>;
  objectType?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  useFrame: Scalars['Boolean'];
  useHighlight: Scalars['Boolean'];
  useIcons: Scalars['Boolean'];
  useImages: Scalars['Boolean'];
  useIntro: Scalars['Boolean'];
  useLogo: Scalars['Boolean'];
  useMusic: Scalars['Boolean'];
  useOutro: Scalars['Boolean'];
  useSlides: Scalars['Boolean'];
  useSpeakers: Scalars['Boolean'];
  useTexts: Scalars['Boolean'];
  useVideos: Scalars['Boolean'];
  version?: Maybe<Scalars['Int']>;
  volume?: Maybe<Scalars['Float']>;
};


export type EditRulesCountArgs = {
  filter?: InputMaybe<EditRulesFilter>;
};


export type EditRulesListArgs = {
  filter?: InputMaybe<EditRulesFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type EditRulesActions = {
  __typename?: 'EditRulesActions';
  add?: Maybe<EditRules>;
  remove?: Maybe<Scalars['Boolean']>;
  update?: Maybe<EditRules>;
};


export type EditRulesActionsAddArgs = {
  values?: InputMaybe<EditRulesAdd>;
};


export type EditRulesActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type EditRulesActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<EditRulesUpdate>;
};

export type EditRulesAdd = {
  name?: InputMaybe<Scalars['String']>;
  noContentVolume?: InputMaybe<Scalars['Float']>;
  useFrame?: InputMaybe<Scalars['Boolean']>;
  useHighlight?: InputMaybe<Scalars['Boolean']>;
  useIcons?: InputMaybe<Scalars['Boolean']>;
  useImages?: InputMaybe<Scalars['Boolean']>;
  useIntro?: InputMaybe<Scalars['Boolean']>;
  useLogo?: InputMaybe<Scalars['Boolean']>;
  useMusic?: InputMaybe<Scalars['Boolean']>;
  useOutro?: InputMaybe<Scalars['Boolean']>;
  useSlides?: InputMaybe<Scalars['Boolean']>;
  useSpeakers?: InputMaybe<Scalars['Boolean']>;
  useTexts?: InputMaybe<Scalars['Boolean']>;
  useVideos?: InputMaybe<Scalars['Boolean']>;
  volume?: InputMaybe<Scalars['Float']>;
};

export type EditRulesEmbeddedInput = {
  name: Scalars['String'];
  useFrame: Scalars['Boolean'];
  useHighlight: Scalars['Boolean'];
  useIcons: Scalars['Boolean'];
  useImages: Scalars['Boolean'];
  useIntro: Scalars['Boolean'];
  useLogo: Scalars['Boolean'];
  useMusic: Scalars['Boolean'];
  useOutro: Scalars['Boolean'];
  useSlides: Scalars['Boolean'];
  useSpeakers: Scalars['Boolean'];
  useTexts: Scalars['Boolean'];
  useVideos: Scalars['Boolean'];
};

export type EditRulesFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type EditRulesInput = {
  name: Scalars['String'];
  useFrame: Scalars['Boolean'];
  useHighlight: Scalars['Boolean'];
  useIcons: Scalars['Boolean'];
  useImages: Scalars['Boolean'];
  useIntro: Scalars['Boolean'];
  useLogo: Scalars['Boolean'];
  useMusic: Scalars['Boolean'];
  useOutro: Scalars['Boolean'];
  useSlides: Scalars['Boolean'];
  useSpeakers: Scalars['Boolean'];
  useTexts: Scalars['Boolean'];
  useVideos: Scalars['Boolean'];
};

export type EditRulesUpdate = {
  name?: InputMaybe<Scalars['String']>;
  noContentVolume?: InputMaybe<Scalars['Float']>;
  useFrame?: InputMaybe<Scalars['Boolean']>;
  useHighlight?: InputMaybe<Scalars['Boolean']>;
  useIcons?: InputMaybe<Scalars['Boolean']>;
  useImages?: InputMaybe<Scalars['Boolean']>;
  useIntro?: InputMaybe<Scalars['Boolean']>;
  useLogo?: InputMaybe<Scalars['Boolean']>;
  useMusic?: InputMaybe<Scalars['Boolean']>;
  useOutro?: InputMaybe<Scalars['Boolean']>;
  useSlides?: InputMaybe<Scalars['Boolean']>;
  useSpeakers?: InputMaybe<Scalars['Boolean']>;
  useTexts?: InputMaybe<Scalars['Boolean']>;
  useVideos?: InputMaybe<Scalars['Boolean']>;
  volume?: InputMaybe<Scalars['Float']>;
};

export type Effect = {
  __typename?: 'Effect';
  direction?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Float']>;
  enableX?: Maybe<Scalars['Boolean']>;
  enableY?: Maybe<Scalars['Boolean']>;
  insertTime?: Maybe<Scalars['Float']>;
  objectType?: Maybe<Scalars['String']>;
  opacity?: Maybe<Scalars['Float']>;
  sid?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['Float']>;
  velocityType?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

export type EffectActions = {
  __typename?: 'EffectActions';
  void?: Maybe<Scalars['Boolean']>;
};

export type EffectAdd = {
  direction?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Float']>;
  enableX?: InputMaybe<Scalars['Boolean']>;
  enableY?: InputMaybe<Scalars['Boolean']>;
  opacity?: InputMaybe<Scalars['Float']>;
  start?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
  velocityType?: InputMaybe<Scalars['String']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type EffectUpdate = {
  direction?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Float']>;
  enableX?: InputMaybe<Scalars['Boolean']>;
  enableY?: InputMaybe<Scalars['Boolean']>;
  opacity?: InputMaybe<Scalars['Float']>;
  start?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
  velocityType?: InputMaybe<Scalars['String']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type Feature = {
  __typename?: 'Feature';
  count?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  insertTime?: Maybe<Scalars['Float']>;
  list?: Maybe<Array<Maybe<Feature>>>;
  name?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  tier?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};


export type FeatureCountArgs = {
  filter?: InputMaybe<FeatureFilter>;
};


export type FeatureListArgs = {
  filter?: InputMaybe<FeatureFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type FeatureActions = {
  __typename?: 'FeatureActions';
  add?: Maybe<Feature>;
  remove?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Feature>;
};


export type FeatureActionsAddArgs = {
  values?: InputMaybe<FeatureAdd>;
};


export type FeatureActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type FeatureActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<FeatureUpdate>;
};

export type FeatureAdd = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  tier?: InputMaybe<Scalars['Int']>;
};

export type FeatureFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type FeatureUpdate = {
  description?: InputMaybe<Scalars['String']>;
  tier?: InputMaybe<Scalars['Int']>;
};

export type FilesPaths = {
  __typename?: 'FilesPaths';
  formattedFootage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  previewFootage?: Maybe<Scalars['String']>;
};

export type FilesPathsEmbeddedInput = {
  formattedFootage?: InputMaybe<Scalars['String']>;
  previewFootage?: InputMaybe<Scalars['String']>;
};

export type FlowJob = {
  __typename?: 'FlowJob';
  jobId?: Maybe<Scalars['String']>;
  queueName: Scalars['String'];
};

export type FlowJobEmbeddedInput = {
  jobId?: InputMaybe<Scalars['String']>;
  queueName: Scalars['String'];
};

export type FlowJobInput = {
  jobId: Scalars['String'];
  queueName: Scalars['String'];
};

export type FolderStructure = {
  __typename?: 'FolderStructure';
  count?: Maybe<Scalars['Int']>;
  insertTime?: Maybe<Scalars['Float']>;
  list?: Maybe<Array<Maybe<FolderStructure>>>;
  name?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  ownerType?: Maybe<Scalars['Int']>;
  parentSid?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  systemId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  userSid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};


export type FolderStructureCountArgs = {
  filter?: InputMaybe<FolderStructureFilter>;
};


export type FolderStructureListArgs = {
  filter?: InputMaybe<FolderStructureFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type FolderStructureActions = {
  __typename?: 'FolderStructureActions';
  add?: Maybe<FolderStructure>;
  remove?: Maybe<Scalars['Boolean']>;
  update?: Maybe<FolderStructure>;
};


export type FolderStructureActionsAddArgs = {
  values?: InputMaybe<FolderStructureAdd>;
};


export type FolderStructureActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type FolderStructureActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<FolderStructureUpdate>;
};

export type FolderStructureAdd = {
  name?: InputMaybe<Scalars['String']>;
  parentSid?: InputMaybe<Scalars['String']>;
  systemId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
};

export type FolderStructureFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  parentSidEqual?: InputMaybe<Scalars['String']>;
  parentSidIsNull?: InputMaybe<Scalars['Boolean']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  systemIdEqual?: InputMaybe<Scalars['String']>;
  typeEqual?: InputMaybe<Scalars['Int']>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type FolderStructureUpdate = {
  name?: InputMaybe<Scalars['String']>;
  parentSid?: InputMaybe<Scalars['String']>;
  systemId?: InputMaybe<Scalars['String']>;
};

export type Footage = {
  __typename?: 'Footage';
  audio?: Maybe<Content>;
  automationData?: Maybe<AutomationData>;
  cachePath?: Maybe<Scalars['String']>;
  clips?: Maybe<Array<Clip>>;
  contentPath?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  filename: Scalars['String'];
  filesPaths?: Maybe<FilesPaths>;
  flowJobs?: Maybe<Array<FlowJob>>;
  id: Scalars['ID'];
  ingestFlowRootJob?: Maybe<FlowJob>;
  languageCode?: Maybe<Scalars['String']>;
  mailedAt?: Maybe<Scalars['DateTime']>;
  mediainfo?: Maybe<MediaInfo>;
  origin: FootageOrigin;
  originalFootageId?: Maybe<Scalars['String']>;
  ownerSid: Scalars['String'];
  ownerType: OwnerType;
  status: FootageStatus;
  thumbnail?: Maybe<Content>;
  transcriptId?: Maybe<Scalars['String']>;
  transcriptRef?: Maybe<Transcript>;
  updatedAt: Scalars['DateTime'];
  youtubeId?: Maybe<Scalars['String']>;
};

export type FootageConnection = {
  __typename?: 'FootageConnection';
  /** Array of nodes. */
  nodes: Array<Footage>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type FootageFilter = {
  and?: InputMaybe<Array<FootageFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdBy?: InputMaybe<StringFieldComparison>;
  filename?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<FootageFilter>>;
  origin?: InputMaybe<FootageOriginFilterComparison>;
  ownerSid?: InputMaybe<StringFieldComparison>;
  ownerType?: InputMaybe<OwnerTypeFilterComparison>;
  status?: InputMaybe<FootageStatusFilterComparison>;
  transcriptRef?: InputMaybe<FootageFilterTranscriptFilter>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type FootageFilterTranscriptFilter = {
  and?: InputMaybe<Array<FootageFilterTranscriptFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdBy?: InputMaybe<StringFieldComparison>;
  footageId?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  lastVersion?: InputMaybe<NumberFieldComparison>;
  or?: InputMaybe<Array<FootageFilterTranscriptFilter>>;
  ownerSid?: InputMaybe<StringFieldComparison>;
  ownerType?: InputMaybe<OwnerTypeFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type FootageInput = {
  audio?: InputMaybe<ContentInput>;
  automationData?: InputMaybe<AutomationDataInput>;
  cachePath?: InputMaybe<Scalars['String']>;
  contentPath?: InputMaybe<Scalars['String']>;
  filename: Scalars['String'];
  languageCode?: InputMaybe<Scalars['String']>;
  mailedAt?: InputMaybe<Scalars['DateTime']>;
  mediainfo?: InputMaybe<MediaInfoInput>;
  origin: FootageOrigin;
  originalFootageId?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<ContentInput>;
  youtubeId?: InputMaybe<Scalars['String']>;
};

export type FootageNonEmbeddedInput = {
  audio?: InputMaybe<ContentEmbeddedInput>;
  automationData?: InputMaybe<AutomationDataEmbeddedInput>;
  cachePath?: InputMaybe<Scalars['String']>;
  clips?: InputMaybe<Array<ClipEmbeddedInput>>;
  contentPath?: InputMaybe<Scalars['String']>;
  filename: Scalars['String'];
  filesPaths?: InputMaybe<FilesPathsEmbeddedInput>;
  flowJobs?: InputMaybe<Array<FlowJobEmbeddedInput>>;
  ingestFlowRootJob?: InputMaybe<FlowJobEmbeddedInput>;
  languageCode?: InputMaybe<Scalars['String']>;
  mailedAt?: InputMaybe<Scalars['DateTime']>;
  mediainfo?: InputMaybe<MediaInfoEmbeddedInput>;
  origin: FootageOrigin;
  originalFootageId?: InputMaybe<Scalars['String']>;
  status: FootageStatus;
  thumbnail?: InputMaybe<ContentEmbeddedInput>;
  transcriptId?: InputMaybe<Scalars['String']>;
  transcriptRef?: InputMaybe<TranscriptNonEmbeddedInput>;
  youtubeId?: InputMaybe<Scalars['String']>;
};

export type FootageOffsetConnection = {
  __typename?: 'FootageOffsetConnection';
  /** Array of nodes. */
  nodes: Array<Footage>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export enum FootageOrigin {
  Archive = 'archive',
  CreateProjectManually = 'createProjectManually',
  ExampleProject = 'exampleProject',
  UserUpload = 'userUpload',
  Youtube = 'youtube'
}

export type FootageOriginFilterComparison = {
  eq?: InputMaybe<FootageOrigin>;
  gt?: InputMaybe<FootageOrigin>;
  gte?: InputMaybe<FootageOrigin>;
  iLike?: InputMaybe<FootageOrigin>;
  in?: InputMaybe<Array<FootageOrigin>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<FootageOrigin>;
  lt?: InputMaybe<FootageOrigin>;
  lte?: InputMaybe<FootageOrigin>;
  neq?: InputMaybe<FootageOrigin>;
  notILike?: InputMaybe<FootageOrigin>;
  notIn?: InputMaybe<Array<FootageOrigin>>;
  notLike?: InputMaybe<FootageOrigin>;
};

export type FootageRenameUpdate = {
  filename: Scalars['String'];
};

export type FootageSort = {
  direction: SortDirection;
  field: FootageSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum FootageSortFields {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Filename = 'filename',
  Id = 'id',
  Origin = 'origin',
  OwnerSid = 'ownerSid',
  OwnerType = 'ownerType',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export enum FootageStatus {
  Completed = 'completed',
  CreatingAssets = 'creatingAssets',
  Deleted = 'deleted',
  FailedAndDeleted = 'failedAndDeleted',
  Failure = 'failure',
  IngestingFootage = 'ingestingFootage',
  Ready = 'ready',
  Uploading = 'uploading',
  UploadingAndDeleted = 'uploadingAndDeleted'
}

export type FootageStatusFilterComparison = {
  eq?: InputMaybe<FootageStatus>;
  gt?: InputMaybe<FootageStatus>;
  gte?: InputMaybe<FootageStatus>;
  iLike?: InputMaybe<FootageStatus>;
  in?: InputMaybe<Array<FootageStatus>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<FootageStatus>;
  lt?: InputMaybe<FootageStatus>;
  lte?: InputMaybe<FootageStatus>;
  neq?: InputMaybe<FootageStatus>;
  notILike?: InputMaybe<FootageStatus>;
  notIn?: InputMaybe<Array<FootageStatus>>;
  notLike?: InputMaybe<FootageStatus>;
};

export type FootageUpdate = {
  audio?: InputMaybe<ContentUpdate>;
  automationData?: InputMaybe<AutomationDataInput>;
  cachePath?: InputMaybe<Scalars['String']>;
  clips?: InputMaybe<Array<ClipUpdate>>;
  contentPath?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  ingestFlowRootJob?: InputMaybe<FlowJobInput>;
  languageCode?: InputMaybe<Scalars['String']>;
  mailedAt?: InputMaybe<Scalars['DateTime']>;
  mediainfo?: InputMaybe<MediaInfoUpdate>;
  origin?: InputMaybe<FootageOrigin>;
  status?: InputMaybe<FootageStatus>;
  thumbnail?: InputMaybe<ContentUpdate>;
  youtubeId?: InputMaybe<Scalars['String']>;
};

export type FootageUpdateFilter = {
  and?: InputMaybe<Array<FootageUpdateFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdBy?: InputMaybe<StringFieldComparison>;
  filename?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<FootageUpdateFilter>>;
  origin?: InputMaybe<FootageOriginFilterComparison>;
  ownerSid?: InputMaybe<StringFieldComparison>;
  ownerType?: InputMaybe<OwnerTypeFilterComparison>;
  status?: InputMaybe<FootageStatusFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type FrameCuePoint = {
  __typename?: 'FrameCuePoint';
  alignment?: Maybe<Scalars['String']>;
  animations?: Maybe<Array<Maybe<GraphicAnimation>>>;
  aspectRatio?: Maybe<Scalars['String']>;
  assetSid?: Maybe<Scalars['String']>;
  assets?: Maybe<Array<Maybe<GraphicAsset>>>;
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundColorIndex?: Maybe<Scalars['Int']>;
  bottom?: Maybe<Scalars['Float']>;
  chapterSid?: Maybe<Scalars['String']>;
  colors?: Maybe<Array<Maybe<GraphicColor>>>;
  configurationTime?: Maybe<Scalars['Float']>;
  contentVersion?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Float']>;
  endTime?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  generatingTime?: Maybe<Scalars['Float']>;
  grayscale?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  insertTime?: Maybe<Scalars['Float']>;
  key?: Maybe<Scalars['String']>;
  left?: Maybe<Scalars['Float']>;
  linkSid?: Maybe<Scalars['String']>;
  list?: Maybe<Array<Maybe<FrameCuePoint>>>;
  logoScale?: Maybe<Scalars['Float']>;
  objectType?: Maybe<Scalars['String']>;
  opacity?: Maybe<Scalars['Float']>;
  overlayed?: Maybe<Scalars['Boolean']>;
  right?: Maybe<Scalars['Float']>;
  sequenceSid?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  srcDuration?: Maybe<Scalars['Float']>;
  srcEndTime?: Maybe<Scalars['Int']>;
  srcStartTime?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  thumbnailVersion?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  top?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Float']>;
  zIndex?: Maybe<Scalars['Int']>;
};


export type FrameCuePointCountArgs = {
  filter?: InputMaybe<FrameCuePointFilter>;
};


export type FrameCuePointListArgs = {
  filter?: InputMaybe<FrameCuePointFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type FrameCuePointActions = {
  __typename?: 'FrameCuePointActions';
  activate?: Maybe<Scalars['Boolean']>;
  add?: Maybe<FrameCuePoint>;
  deactivate?: Maybe<Scalars['Boolean']>;
  remove?: Maybe<Scalars['Boolean']>;
  reoverlay?: Maybe<Scalars['Boolean']>;
  update?: Maybe<FrameCuePoint>;
};


export type FrameCuePointActionsAddArgs = {
  values?: InputMaybe<FrameCuePointAdd>;
};


export type FrameCuePointActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type FrameCuePointActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<FrameCuePointUpdate>;
};

export type FrameCuePointAdd = {
  alignment?: InputMaybe<Scalars['String']>;
  animations?: InputMaybe<Array<InputMaybe<GraphicAnimationAdd>>>;
  assetSid?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<Array<InputMaybe<GraphicAssetAdd>>>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  backgroundColorIndex?: InputMaybe<Scalars['Int']>;
  bottom?: InputMaybe<Scalars['Float']>;
  chapterSid?: InputMaybe<Scalars['String']>;
  colors?: InputMaybe<Array<InputMaybe<GraphicColorAdd>>>;
  duration?: InputMaybe<Scalars['Float']>;
  endTime?: InputMaybe<Scalars['Int']>;
  externalId?: InputMaybe<Scalars['String']>;
  grayscale?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  left?: InputMaybe<Scalars['Float']>;
  logoScale?: InputMaybe<Scalars['Float']>;
  opacity?: InputMaybe<Scalars['Float']>;
  right?: InputMaybe<Scalars['Float']>;
  sequenceSid?: InputMaybe<Scalars['String']>;
  srcEndTime?: InputMaybe<Scalars['Int']>;
  srcStartTime?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Int']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  top?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Float']>;
  zIndex?: InputMaybe<Scalars['Int']>;
};

export type FrameCuePointFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  sequenceSidEqual?: InputMaybe<Scalars['String']>;
  sidEqual?: InputMaybe<Scalars['String']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type FrameCuePointUpdate = {
  alignment?: InputMaybe<Scalars['String']>;
  animations?: InputMaybe<Array<InputMaybe<GraphicAnimationUpdate>>>;
  assetSid?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<Array<InputMaybe<GraphicAssetUpdate>>>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  backgroundColorIndex?: InputMaybe<Scalars['Int']>;
  bottom?: InputMaybe<Scalars['Float']>;
  chapterSid?: InputMaybe<Scalars['String']>;
  colors?: InputMaybe<Array<InputMaybe<GraphicColorUpdate>>>;
  duration?: InputMaybe<Scalars['Float']>;
  endTime?: InputMaybe<Scalars['Int']>;
  externalId?: InputMaybe<Scalars['String']>;
  grayscale?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  left?: InputMaybe<Scalars['Float']>;
  logoScale?: InputMaybe<Scalars['Float']>;
  opacity?: InputMaybe<Scalars['Float']>;
  right?: InputMaybe<Scalars['Float']>;
  srcEndTime?: InputMaybe<Scalars['Int']>;
  srcStartTime?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Int']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  top?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
  zIndex?: InputMaybe<Scalars['Int']>;
};

export type GraphicAnimation = {
  __typename?: 'GraphicAnimation';
  duration?: Maybe<Scalars['Int']>;
  easing?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['Int']>;
  endValue?: Maybe<Scalars['Float']>;
  endX?: Maybe<Scalars['Float']>;
  endY?: Maybe<Scalars['Float']>;
  insertTime?: Maybe<Scalars['Float']>;
  kind?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  sid?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  startValue?: Maybe<Scalars['Float']>;
  startX?: Maybe<Scalars['Float']>;
  startY?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};

export type GraphicAnimationActions = {
  __typename?: 'GraphicAnimationActions';
  void?: Maybe<Scalars['Boolean']>;
};

export type GraphicAnimationAdd = {
  duration?: InputMaybe<Scalars['Int']>;
  easing?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Int']>;
  endValue?: InputMaybe<Scalars['Float']>;
  endX?: InputMaybe<Scalars['Float']>;
  endY?: InputMaybe<Scalars['Float']>;
  kind?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int']>;
  startValue?: InputMaybe<Scalars['Float']>;
  startX?: InputMaybe<Scalars['Float']>;
  startY?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
};

export type GraphicAnimationUpdate = {
  duration?: InputMaybe<Scalars['Int']>;
  easing?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Int']>;
  endValue?: InputMaybe<Scalars['Float']>;
  endX?: InputMaybe<Scalars['Float']>;
  endY?: InputMaybe<Scalars['Float']>;
  kind?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int']>;
  startValue?: InputMaybe<Scalars['Float']>;
  startX?: InputMaybe<Scalars['Float']>;
  startY?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
};

export type GraphicAsset = {
  __typename?: 'GraphicAsset';
  assetSid?: Maybe<Scalars['String']>;
  className?: Maybe<Scalars['String']>;
  insertTime?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};

export type GraphicAssetActions = {
  __typename?: 'GraphicAssetActions';
  void?: Maybe<Scalars['Boolean']>;
};

export type GraphicAssetAdd = {
  assetSid?: InputMaybe<Scalars['String']>;
  className?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
};

export type GraphicAssetUpdate = {
  assetSid?: InputMaybe<Scalars['String']>;
  className?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
};

export type GraphicColor = {
  __typename?: 'GraphicColor';
  className?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorIndex?: Maybe<Scalars['Int']>;
  insertTime?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};

export type GraphicColorActions = {
  __typename?: 'GraphicColorActions';
  void?: Maybe<Scalars['Boolean']>;
};

export type GraphicColorAdd = {
  className?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  colorIndex?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
};

export type GraphicColorUpdate = {
  className?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  colorIndex?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
};

export type GraphicCuePoint = {
  __typename?: 'GraphicCuePoint';
  alignment?: Maybe<Scalars['String']>;
  animations?: Maybe<Array<Maybe<GraphicAnimation>>>;
  aspectRatio?: Maybe<Scalars['String']>;
  assetSid?: Maybe<Scalars['String']>;
  assets?: Maybe<Array<Maybe<GraphicAsset>>>;
  bottom?: Maybe<Scalars['Float']>;
  chapterSid?: Maybe<Scalars['String']>;
  colors?: Maybe<Array<Maybe<GraphicColor>>>;
  configurationTime?: Maybe<Scalars['Float']>;
  contentVersion?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Float']>;
  endTime?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  generatingTime?: Maybe<Scalars['Float']>;
  grayscale?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  insertTime?: Maybe<Scalars['Float']>;
  key?: Maybe<Scalars['String']>;
  left?: Maybe<Scalars['Float']>;
  linkSid?: Maybe<Scalars['String']>;
  list?: Maybe<Array<Maybe<GraphicCuePoint>>>;
  logoScale?: Maybe<Scalars['Float']>;
  objectType?: Maybe<Scalars['String']>;
  opacity?: Maybe<Scalars['Float']>;
  overlayed?: Maybe<Scalars['Boolean']>;
  right?: Maybe<Scalars['Float']>;
  sequenceSid?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  srcDuration?: Maybe<Scalars['Float']>;
  srcEndTime?: Maybe<Scalars['Int']>;
  srcStartTime?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  thumbnailVersion?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  top?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Float']>;
  zIndex?: Maybe<Scalars['Int']>;
};


export type GraphicCuePointCountArgs = {
  filter?: InputMaybe<GraphicCuePointFilter>;
};


export type GraphicCuePointListArgs = {
  filter?: InputMaybe<GraphicCuePointFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type GraphicCuePointActions = {
  __typename?: 'GraphicCuePointActions';
  activate?: Maybe<Scalars['Boolean']>;
  add?: Maybe<GraphicCuePoint>;
  deactivate?: Maybe<Scalars['Boolean']>;
  remove?: Maybe<Scalars['Boolean']>;
  reoverlay?: Maybe<Scalars['Boolean']>;
  update?: Maybe<GraphicCuePoint>;
};


export type GraphicCuePointActionsAddArgs = {
  values?: InputMaybe<GraphicCuePointAdd>;
};


export type GraphicCuePointActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type GraphicCuePointActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<GraphicCuePointUpdate>;
};

export type GraphicCuePointAdd = {
  alignment?: InputMaybe<Scalars['String']>;
  animations?: InputMaybe<Array<InputMaybe<GraphicAnimationAdd>>>;
  assetSid?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<Array<InputMaybe<GraphicAssetAdd>>>;
  bottom?: InputMaybe<Scalars['Float']>;
  chapterSid?: InputMaybe<Scalars['String']>;
  colors?: InputMaybe<Array<InputMaybe<GraphicColorAdd>>>;
  duration?: InputMaybe<Scalars['Float']>;
  endTime?: InputMaybe<Scalars['Int']>;
  externalId?: InputMaybe<Scalars['String']>;
  grayscale?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  left?: InputMaybe<Scalars['Float']>;
  logoScale?: InputMaybe<Scalars['Float']>;
  opacity?: InputMaybe<Scalars['Float']>;
  right?: InputMaybe<Scalars['Float']>;
  sequenceSid?: InputMaybe<Scalars['String']>;
  srcEndTime?: InputMaybe<Scalars['Int']>;
  srcStartTime?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Int']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  top?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Float']>;
  zIndex?: InputMaybe<Scalars['Int']>;
};

export type GraphicCuePointFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  sequenceSidEqual?: InputMaybe<Scalars['String']>;
  sidEqual?: InputMaybe<Scalars['String']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type GraphicCuePointUpdate = {
  alignment?: InputMaybe<Scalars['String']>;
  animations?: InputMaybe<Array<InputMaybe<GraphicAnimationUpdate>>>;
  assetSid?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<Array<InputMaybe<GraphicAssetUpdate>>>;
  bottom?: InputMaybe<Scalars['Float']>;
  chapterSid?: InputMaybe<Scalars['String']>;
  colors?: InputMaybe<Array<InputMaybe<GraphicColorUpdate>>>;
  duration?: InputMaybe<Scalars['Float']>;
  endTime?: InputMaybe<Scalars['Int']>;
  externalId?: InputMaybe<Scalars['String']>;
  grayscale?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  left?: InputMaybe<Scalars['Float']>;
  logoScale?: InputMaybe<Scalars['Float']>;
  opacity?: InputMaybe<Scalars['Float']>;
  right?: InputMaybe<Scalars['Float']>;
  srcEndTime?: InputMaybe<Scalars['Int']>;
  srcStartTime?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Int']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  top?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
  zIndex?: InputMaybe<Scalars['Int']>;
};

export type IdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']>;
  gt?: InputMaybe<Scalars['ID']>;
  gte?: InputMaybe<Scalars['ID']>;
  iLike?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['ID']>;
  lt?: InputMaybe<Scalars['ID']>;
  lte?: InputMaybe<Scalars['ID']>;
  neq?: InputMaybe<Scalars['ID']>;
  notILike?: InputMaybe<Scalars['ID']>;
  notIn?: InputMaybe<Array<Scalars['ID']>>;
  notLike?: InputMaybe<Scalars['ID']>;
};

export type Image = {
  __typename?: 'Image';
  count?: Maybe<Scalars['Int']>;
  credit?: Maybe<Scalars['String']>;
  creditRequired?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  insertTime?: Maybe<Scalars['Float']>;
  isSource?: Maybe<Scalars['Boolean']>;
  list?: Maybe<Array<Maybe<Image>>>;
  objectType?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  thumbUrl?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
};


export type ImageCountArgs = {
  filter?: InputMaybe<ImageFilter>;
};


export type ImageListArgs = {
  filter?: InputMaybe<ImageFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type ImageActions = {
  __typename?: 'ImageActions';
  add?: Maybe<Image>;
  remove?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Image>;
};


export type ImageActionsAddArgs = {
  values?: InputMaybe<ImageAdd>;
};


export type ImageActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type ImageActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<ImageUpdate>;
};

export type ImageAdd = {
  credit?: InputMaybe<Scalars['String']>;
  creditRequired?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  isSource?: InputMaybe<Scalars['Boolean']>;
  thumbUrl?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type ImageFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type ImageUpdate = {
  credit?: InputMaybe<Scalars['String']>;
  creditRequired?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  isSource?: InputMaybe<Scalars['Boolean']>;
  thumbUrl?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type Income = {
  __typename?: 'Income';
  catalogNum?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  insertTime?: Maybe<Scalars['Float']>;
  objectType?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};

export type IncomeActions = {
  __typename?: 'IncomeActions';
  void?: Maybe<Scalars['Boolean']>;
};

export type IncomeAdd = {
  catalogNum?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
};

export type IncomeUpdate = {
  catalogNum?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
};

export type IntFieldComparison = {
  between?: InputMaybe<IntFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  notBetween?: InputMaybe<IntFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntFieldComparisonBetween = {
  lower: Scalars['Int'];
  upper: Scalars['Int'];
};

export type Invoice = {
  __typename?: 'Invoice';
  amount?: Maybe<Scalars['Float']>;
  creationDate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  income?: Maybe<Array<Maybe<Income>>>;
  insertTime?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Int']>;
  objectType?: Maybe<Scalars['String']>;
  payment?: Maybe<Array<Maybe<Payment>>>;
  sid?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};

export type InvoiceActions = {
  __typename?: 'InvoiceActions';
  void?: Maybe<Scalars['Boolean']>;
};

export type InvoiceAdd = {
  amount?: InputMaybe<Scalars['Float']>;
  creationDate?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  income?: InputMaybe<Array<InputMaybe<IncomeAdd>>>;
  number?: InputMaybe<Scalars['Int']>;
  payment?: InputMaybe<Array<InputMaybe<PaymentAdd>>>;
};

export type InvoiceList = {
  __typename?: 'InvoiceList';
  count?: Maybe<Scalars['Int']>;
  insertTime?: Maybe<Scalars['Float']>;
  items?: Maybe<Array<Maybe<Invoice>>>;
  list?: Maybe<Array<Maybe<InvoiceList>>>;
  objectType?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  pages?: Maybe<Scalars['Int']>;
  sid?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};


export type InvoiceListCountArgs = {
  filter?: InputMaybe<InvoiceListFilter>;
};


export type InvoiceListListArgs = {
  filter?: InputMaybe<InvoiceListFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type InvoiceListActions = {
  __typename?: 'InvoiceListActions';
  add?: Maybe<InvoiceList>;
  remove?: Maybe<Scalars['Boolean']>;
  update?: Maybe<InvoiceList>;
};


export type InvoiceListActionsAddArgs = {
  values?: InputMaybe<InvoiceListAdd>;
};


export type InvoiceListActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type InvoiceListActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<InvoiceListUpdate>;
};

export type InvoiceListAdd = {
  items?: InputMaybe<Array<InputMaybe<InvoiceAdd>>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  pages?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['Int']>;
};

export type InvoiceListFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type InvoiceListUpdate = {
  items?: InputMaybe<Array<InputMaybe<InvoiceUpdate>>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  pages?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['Int']>;
};

export type InvoiceUpdate = {
  amount?: InputMaybe<Scalars['Float']>;
  creationDate?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  income?: InputMaybe<Array<InputMaybe<IncomeUpdate>>>;
  number?: InputMaybe<Scalars['Int']>;
  payment?: InputMaybe<Array<InputMaybe<PaymentUpdate>>>;
};

export type Logo = {
  __typename?: 'Logo';
  assetSid?: Maybe<Scalars['String']>;
  bottom?: Maybe<Scalars['Float']>;
  crop?: Maybe<Scalars['Boolean']>;
  insertTime?: Maybe<Scalars['Float']>;
  key?: Maybe<Scalars['String']>;
  left?: Maybe<Scalars['Float']>;
  linkSid?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  opacity?: Maybe<Scalars['Float']>;
  removeWhiteBackground?: Maybe<Scalars['Boolean']>;
  right?: Maybe<Scalars['Float']>;
  sid?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  srcHeight?: Maybe<Scalars['Int']>;
  srcWidth?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  thumbnailVersion?: Maybe<Scalars['Int']>;
  top?: Maybe<Scalars['Float']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};

export type LogoActions = {
  __typename?: 'LogoActions';
  void?: Maybe<Scalars['Boolean']>;
};

export type LogoAdd = {
  assetSid?: InputMaybe<Scalars['String']>;
  bottom?: InputMaybe<Scalars['Float']>;
  crop?: InputMaybe<Scalars['Boolean']>;
  left?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  opacity?: InputMaybe<Scalars['Float']>;
  removeWhiteBackground?: InputMaybe<Scalars['Boolean']>;
  right?: InputMaybe<Scalars['Float']>;
  size?: InputMaybe<Scalars['Float']>;
  srcHeight?: InputMaybe<Scalars['Int']>;
  srcWidth?: InputMaybe<Scalars['Int']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  top?: InputMaybe<Scalars['Float']>;
};

export type LogoEffect = {
  __typename?: 'LogoEffect';
  direction?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Float']>;
  enableX?: Maybe<Scalars['Boolean']>;
  enableY?: Maybe<Scalars['Boolean']>;
  height?: Maybe<Scalars['Float']>;
  insertTime?: Maybe<Scalars['Float']>;
  objectType?: Maybe<Scalars['String']>;
  opacity?: Maybe<Scalars['Float']>;
  sid?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['Float']>;
  velocityType?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Float']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

export type LogoEffectActions = {
  __typename?: 'LogoEffectActions';
  void?: Maybe<Scalars['Boolean']>;
};

export type LogoEffectAdd = {
  direction?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Float']>;
  enableX?: InputMaybe<Scalars['Boolean']>;
  enableY?: InputMaybe<Scalars['Boolean']>;
  height?: InputMaybe<Scalars['Float']>;
  opacity?: InputMaybe<Scalars['Float']>;
  start?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
  velocityType?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type LogoEffectUpdate = {
  direction?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Float']>;
  enableX?: InputMaybe<Scalars['Boolean']>;
  enableY?: InputMaybe<Scalars['Boolean']>;
  height?: InputMaybe<Scalars['Float']>;
  opacity?: InputMaybe<Scalars['Float']>;
  start?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
  velocityType?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type LogoUpdate = {
  assetSid?: InputMaybe<Scalars['String']>;
  bottom?: InputMaybe<Scalars['Float']>;
  crop?: InputMaybe<Scalars['Boolean']>;
  left?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  opacity?: InputMaybe<Scalars['Float']>;
  removeWhiteBackground?: InputMaybe<Scalars['Boolean']>;
  right?: InputMaybe<Scalars['Float']>;
  size?: InputMaybe<Scalars['Float']>;
  srcHeight?: InputMaybe<Scalars['Int']>;
  srcWidth?: InputMaybe<Scalars['Int']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  top?: InputMaybe<Scalars['Float']>;
};

export type MediaInfo = {
  __typename?: 'MediaInfo';
  aspectRatio?: Maybe<Scalars['String']>;
  duration: Scalars['Float'];
};

export type MediaInfoEmbeddedInput = {
  aspectRatio?: InputMaybe<Scalars['String']>;
  duration: Scalars['Float'];
};

export type MediaInfoInput = {
  aspectRatio: Scalars['String'];
  duration: Scalars['Float'];
};

export type MediaInfoUpdate = {
  aspectRatio: Scalars['String'];
  duration: Scalars['Float'];
};

export type Music = {
  __typename?: 'Music';
  aspectRatio?: Maybe<Scalars['String']>;
  assetSid?: Maybe<Scalars['String']>;
  configurationTime?: Maybe<Scalars['Float']>;
  contentVersion?: Maybe<Scalars['Int']>;
  credit?: Maybe<Scalars['String']>;
  creditRequired?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  downloadDate?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  enabled?: Maybe<Scalars['Boolean']>;
  externalId?: Maybe<Scalars['String']>;
  generatingTime?: Maybe<Scalars['Float']>;
  insertTime?: Maybe<Scalars['Float']>;
  key?: Maybe<Scalars['String']>;
  linkSid?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  noContentVolume?: Maybe<Scalars['Float']>;
  objectType?: Maybe<Scalars['String']>;
  overrideVolume?: Maybe<Scalars['Boolean']>;
  sid?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  srcDuration?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Int']>;
  thumbnailVersion?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
  volume?: Maybe<Scalars['Float']>;
};

export type MusicActions = {
  __typename?: 'MusicActions';
  void?: Maybe<Scalars['Boolean']>;
};

export type MusicAdd = {
  assetSid?: InputMaybe<Scalars['String']>;
  credit?: InputMaybe<Scalars['String']>;
  creditRequired?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  downloadDate?: InputMaybe<Scalars['Float']>;
  duration?: InputMaybe<Scalars['Float']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  noContentVolume?: InputMaybe<Scalars['Float']>;
  overrideVolume?: InputMaybe<Scalars['Boolean']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  volume?: InputMaybe<Scalars['Float']>;
};

export type MusicUpdate = {
  assetSid?: InputMaybe<Scalars['String']>;
  credit?: InputMaybe<Scalars['String']>;
  creditRequired?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  downloadDate?: InputMaybe<Scalars['Float']>;
  duration?: InputMaybe<Scalars['Float']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  noContentVolume?: InputMaybe<Scalars['Float']>;
  overrideVolume?: InputMaybe<Scalars['Boolean']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  volume?: InputMaybe<Scalars['Float']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addClipSequence: ClipSequence;
  addClipSequenceFavorite: ClipSequence;
  addClips: Array<Clip>;
  addFootageFlowJob: Footage;
  addOneClip: Clip;
  asset?: Maybe<AssetActions>;
  cloneClipSequence: ClipSequence;
  cloneClosedCaptions: Scalars['String'];
  cloneCropDetails: Scalars['Int'];
  cloneExampleFootage: Footage;
  closedCaption?: Maybe<ClosedCaptionActions>;
  color?: Maybe<ColorActions>;
  content?: Maybe<ContentActions>;
  coupon?: Maybe<CouponActions>;
  createClosedCaptions: ClosedCaptionsOutput;
  createCropDetailsDefaultValues: CropDetail;
  createJoinedTranscript: Transcript;
  createManyCropDetails: Array<CropDetail>;
  createManyDownloadInfos: Array<DownloadInfo>;
  createManyFootages: Array<Footage>;
  createManyTranscripts: Array<Transcript>;
  createOneBoard: Board;
  createOneCropDetail: CropDetail;
  createOneDownloadInfo: DownloadInfo;
  createOneFootage: Footage;
  createOneTranscript: Transcript;
  cuePoint?: Maybe<CuePointActions>;
  deleteClipSequence: ClipSequence;
  deleteClipSequenceFavorite: ClipSequence;
  deleteManyCropDetails: DeleteManyResponse;
  deleteManyDownloadInfos: DeleteManyResponse;
  deleteManyTranscripts: DeleteManyResponse;
  deleteOneBoard: BoardDeleteResponse;
  deleteOneClosedCaptionV2: ClosedCaptionV2DeleteResponse;
  deleteOneCropDetail: CropDetailDeleteResponse;
  deleteOneDownloadInfo: DownloadInfoDeleteResponse;
  deleteOneFootage: Footage;
  deleteOneTranscript: TranscriptDeleteResponse;
  detection?: Maybe<DetectionActions>;
  dimention?: Maybe<DimentionActions>;
  downloadAnimation?: Maybe<DownloadAnimationActions>;
  editRules?: Maybe<EditRulesActions>;
  feature?: Maybe<FeatureActions>;
  folderStructure?: Maybe<FolderStructureActions>;
  frameCuePoint?: Maybe<FrameCuePointActions>;
  generateUploadUrl: Scalars['String'];
  graphicAnimation?: Maybe<GraphicAnimationActions>;
  graphicAsset?: Maybe<GraphicAssetActions>;
  graphicColor?: Maybe<GraphicColorActions>;
  graphicCuePoint?: Maybe<GraphicCuePointActions>;
  highlightClosedCaptions: Scalars['Boolean'];
  image?: Maybe<ImageActions>;
  interactClipSequence: ClipSequence;
  invoiceList?: Maybe<InvoiceListActions>;
  moveFootageToBoard: Scalars['Boolean'];
  org?: Maybe<OrgActions>;
  pager?: Maybe<PagerActions>;
  plan?: Maybe<PlanActions>;
  preset?: Maybe<PresetActions>;
  regenerateClosedCaptions: ClosedCaptionListWords;
  removeFootageFromBoard: Scalars['Boolean'];
  renameClipSequence: ClipSequence;
  renameOneFootage: Footage;
  replaceExampleClipSequence: ClipSequence;
  role?: Maybe<RoleActions>;
  sequence?: Maybe<SequenceActions>;
  sequenceAccess?: Maybe<SequenceAccessActions>;
  serverError?: Maybe<ServerErrorActions>;
  shopper?: Maybe<ShopperActions>;
  speaker?: Maybe<SpeakerActions>;
  speakerCuePoint?: Maybe<SpeakerCuePointActions>;
  splitFootageByUserTimestamps: Scalars['Int'];
  subscription?: Maybe<SubscriptionActions>;
  teamType?: Maybe<TeamTypeActions>;
  titleCuePoint?: Maybe<TitleCuePointActions>;
  track?: Maybe<TrackActions>;
  translateClipSequence: ClipSequence;
  unsyncClosedCaptionsWithTranscript: ClosedCaptionSyncStatus;
  updateAssetCropData: CropDetail;
  updateBackgroundDesign: Scalars['Int'];
  updateBulkOfWordsInTranscript: Transcript;
  updateByFootageId: Transcript;
  updateClip: Clip;
  updateClipSequence: ClipSequence;
  updateClipSequenceByExternalId: ClipSequence;
  updateClipSequenceNoAsset: ClipSequence;
  updateClosedCaptions: ClosedCaptionsOutput;
  updateClosedCaptionsMetaData: Array<ClosedCaptionMetaData>;
  updateManyCropDetails: UpdateManyResponse;
  updateManyDownloadInfos: UpdateManyResponse;
  updateManyFootages: UpdateManyResponse;
  updateManyTranscripts: UpdateManyResponse;
  updateOneBoard: Board;
  updateOneCropDetail: CropDetail;
  updateOneDownloadInfo: DownloadInfo;
  updateOneFootage: Footage;
  updateOneTranscript: Transcript;
  user?: Maybe<UserActions>;
  userAction?: Maybe<UserActionActions>;
  userBase?: Maybe<UserBaseActions>;
  userCoupon?: Maybe<UserCouponActions>;
  video?: Maybe<VideoActions>;
  videoType?: Maybe<VideoTypeActions>;
};


export type MutationAddClipSequenceArgs = {
  clipId: Scalars['String'];
  footageId: Scalars['String'];
  input: ClipSequenceInput;
};


export type MutationAddClipSequenceFavoriteArgs = {
  clipId: Scalars['String'];
  footageId: Scalars['String'];
  id: Scalars['String'];
};


export type MutationAddClipsArgs = {
  footageId: Scalars['String'];
  update: Array<ClipInput>;
};


export type MutationAddFootageFlowJobArgs = {
  flowJob: FlowJobInput;
  id: Scalars['String'];
};


export type MutationAddOneClipArgs = {
  footageId: Scalars['String'];
  update: ClipInput;
};


export type MutationAssetArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationCloneClipSequenceArgs = {
  clipId: Scalars['String'];
  footageId: Scalars['String'];
  id: Scalars['String'];
  input: ClipSequenceCloneInput;
};


export type MutationCloneClosedCaptionsArgs = {
  input: Array<CloneClosedCaption>;
};


export type MutationCloneCropDetailsArgs = {
  dstExternalSequenceSid: Scalars['String'];
  outputAspectRatio: Scalars['String'];
  srcExternalSequenceSid: Scalars['String'];
};


export type MutationCloneExampleFootageArgs = {
  externalPresetSid: Scalars['String'];
  footageId: Scalars['String'];
};


export type MutationClosedCaptionArgs = {
  sequenceSid?: InputMaybe<Scalars['String']>;
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationColorArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationContentArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationCouponArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationCreateClosedCaptionsArgs = {
  input: ClosedCaptionV2Input;
};


export type MutationCreateCropDetailsDefaultValuesArgs = {
  detections: Array<DetectionsInput>;
  duration: Scalars['Float'];
  externalAssetSid: Scalars['String'];
  externalSequenceSid: Scalars['String'];
  footageId?: InputMaybe<Scalars['String']>;
  originalAspectRatio: Scalars['String'];
  outputAspectRatio: Scalars['String'];
  sourceHeight: Scalars['Float'];
  sourceWidth: Scalars['Float'];
};


export type MutationCreateJoinedTranscriptArgs = {
  input: CreateJoinedTranscriptInput;
};


export type MutationCreateManyCropDetailsArgs = {
  input: CreateManyCropDetailsInput;
};


export type MutationCreateManyDownloadInfosArgs = {
  input: CreateManyDownloadInfosInput;
};


export type MutationCreateManyFootagesArgs = {
  input: CreateManyFootagesInput;
};


export type MutationCreateManyTranscriptsArgs = {
  input: CreateManyTranscriptsInput;
};


export type MutationCreateOneBoardArgs = {
  input: CreateOneBoardInput;
};


export type MutationCreateOneCropDetailArgs = {
  input: CreateOneCropDetailInput;
};


export type MutationCreateOneDownloadInfoArgs = {
  input: CreateOneDownloadInfoInput;
};


export type MutationCreateOneFootageArgs = {
  input: CreateOneFootageInput;
};


export type MutationCreateOneTranscriptArgs = {
  input: CreateOneTranscriptInput;
};


export type MutationCuePointArgs = {
  sequenceSid?: InputMaybe<Scalars['String']>;
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteClipSequenceArgs = {
  clipId: Scalars['String'];
  footageId: Scalars['String'];
  id: Scalars['String'];
};


export type MutationDeleteClipSequenceFavoriteArgs = {
  clipId: Scalars['String'];
  footageId: Scalars['String'];
  id: Scalars['String'];
};


export type MutationDeleteManyCropDetailsArgs = {
  input: DeleteManyCropDetailsInput;
};


export type MutationDeleteManyDownloadInfosArgs = {
  input: DeleteManyDownloadInfosInput;
};


export type MutationDeleteManyTranscriptsArgs = {
  input: DeleteManyTranscriptsInput;
};


export type MutationDeleteOneBoardArgs = {
  input: DeleteOneBoardInput;
};


export type MutationDeleteOneClosedCaptionV2Args = {
  input: DeleteOneClosedCaptionV2Input;
};


export type MutationDeleteOneCropDetailArgs = {
  input: DeleteOneCropDetailInput;
};


export type MutationDeleteOneDownloadInfoArgs = {
  input: DeleteOneDownloadInfoInput;
};


export type MutationDeleteOneFootageArgs = {
  input: DeleteOneFootageInput;
};


export type MutationDeleteOneTranscriptArgs = {
  input: DeleteOneTranscriptInput;
};


export type MutationDetectionArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationDimentionArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationDownloadAnimationArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationEditRulesArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationFeatureArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationFolderStructureArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationFrameCuePointArgs = {
  sequenceSid?: InputMaybe<Scalars['String']>;
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationGenerateUploadUrlArgs = {
  id: Scalars['String'];
};


export type MutationGraphicAnimationArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationGraphicAssetArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationGraphicColorArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationGraphicCuePointArgs = {
  sequenceSid?: InputMaybe<Scalars['String']>;
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationHighlightClosedCaptionsArgs = {
  input: ClosedCaptionV2Update;
};


export type MutationImageArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationInteractClipSequenceArgs = {
  externalSequenceId: Scalars['String'];
  footageId: Scalars['String'];
  sequenceInteraction: SequenceInteraction;
};


export type MutationInvoiceListArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationMoveFootageToBoardArgs = {
  boardId: Scalars['String'];
  footageId: Scalars['String'];
};


export type MutationOrgArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationPagerArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationPlanArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationPresetArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationRegenerateClosedCaptionsArgs = {
  chapterSid?: InputMaybe<Scalars['String']>;
  sequenceSid: Scalars['String'];
};


export type MutationRemoveFootageFromBoardArgs = {
  footageId: Scalars['String'];
};


export type MutationRenameClipSequenceArgs = {
  clipId: Scalars['String'];
  footageId: Scalars['String'];
  id: Scalars['String'];
  input: ClipSequenceRenameInput;
};


export type MutationRenameOneFootageArgs = {
  id: Scalars['String'];
  update: FootageRenameUpdate;
};


export type MutationReplaceExampleClipSequenceArgs = {
  clipId: Scalars['String'];
  footageId: Scalars['String'];
  id: Scalars['String'];
};


export type MutationRoleArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationSequenceArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationSequenceAccessArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationServerErrorArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationShopperArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationSpeakerArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationSpeakerCuePointArgs = {
  sequenceSid?: InputMaybe<Scalars['String']>;
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationSplitFootageByUserTimestampsArgs = {
  input: ClipByTimestampsInput;
};


export type MutationSubscriptionArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationTeamTypeArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationTitleCuePointArgs = {
  sequenceSid?: InputMaybe<Scalars['String']>;
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationTrackArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationTranslateClipSequenceArgs = {
  clipId: Scalars['String'];
  footageId: Scalars['String'];
  id: Scalars['String'];
  input: ClipSequenceTranslateInput;
};


export type MutationUnsyncClosedCaptionsWithTranscriptArgs = {
  sequenceSid: Scalars['String'];
};


export type MutationUpdateAssetCropDataArgs = {
  cropData: Array<CropDataUpdate>;
  externalAssetSid: Scalars['String'];
  externalSequenceSid: Scalars['String'];
  outputAspectRatio: Scalars['String'];
};


export type MutationUpdateBackgroundDesignArgs = {
  blur: Scalars['Boolean'];
  brandColorIndex?: InputMaybe<Scalars['Int']>;
  color: Scalars['String'];
  externalSequenceSid: Scalars['String'];
};


export type MutationUpdateBulkOfWordsInTranscriptArgs = {
  footageId: Scalars['String'];
  update: BulkOfWordsUpdate;
};


export type MutationUpdateByFootageIdArgs = {
  footageId: Scalars['String'];
  update: TranscriptUpdate;
};


export type MutationUpdateClipArgs = {
  footageId: Scalars['String'];
  id: Scalars['String'];
  update: ClipUpdate;
};


export type MutationUpdateClipSequenceArgs = {
  clipId: Scalars['String'];
  footageId: Scalars['String'];
  id: Scalars['String'];
  update: ClipSequenceUpdate;
};


export type MutationUpdateClipSequenceByExternalIdArgs = {
  clipIndex: Scalars['Int'];
  externalSequenceId: Scalars['String'];
  footageId: Scalars['String'];
  update: ClipSequenceUpdate;
};


export type MutationUpdateClipSequenceNoAssetArgs = {
  externalSequenceId: Scalars['String'];
  footageId: Scalars['String'];
  update: ClipSequenceUpdate;
};


export type MutationUpdateClosedCaptionsArgs = {
  input: ClosedCaptionV2Update;
};


export type MutationUpdateClosedCaptionsMetaDataArgs = {
  input: Array<ClosedCaptionUpdateMetaData>;
};


export type MutationUpdateManyCropDetailsArgs = {
  input: UpdateManyCropDetailsInput;
};


export type MutationUpdateManyDownloadInfosArgs = {
  input: UpdateManyDownloadInfosInput;
};


export type MutationUpdateManyFootagesArgs = {
  input: UpdateManyFootagesInput;
};


export type MutationUpdateManyTranscriptsArgs = {
  input: UpdateManyTranscriptsInput;
};


export type MutationUpdateOneBoardArgs = {
  input: UpdateOneBoardInput;
};


export type MutationUpdateOneCropDetailArgs = {
  input: UpdateOneCropDetailInput;
};


export type MutationUpdateOneDownloadInfoArgs = {
  input: UpdateOneDownloadInfoInput;
};


export type MutationUpdateOneFootageArgs = {
  input: UpdateOneFootageInput;
};


export type MutationUpdateOneTranscriptArgs = {
  input: UpdateOneTranscriptInput;
};


export type MutationUserArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationUserActionArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationUserBaseArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationUserCouponArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationVideoArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type MutationVideoTypeArgs = {
  sid?: InputMaybe<Scalars['String']>;
};

export type NumberFieldComparison = {
  between?: InputMaybe<NumberFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  neq?: InputMaybe<Scalars['Float']>;
  notBetween?: InputMaybe<NumberFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NumberFieldComparisonBetween = {
  lower: Scalars['Float'];
  upper: Scalars['Float'];
};

export type OffsetPageInfo = {
  __typename?: 'OffsetPageInfo';
  /** true if paging forward and there are more records. */
  hasNextPage?: Maybe<Scalars['Boolean']>;
  /** true if paging backwards and there are more records. */
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
};

export type OffsetPaging = {
  /** Limit the number of records returned */
  limit?: InputMaybe<Scalars['Int']>;
  /** Offset to start returning records from */
  offset?: InputMaybe<Scalars['Int']>;
};

export type Org = {
  __typename?: 'Org';
  count?: Maybe<Scalars['Int']>;
  fontFamily?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  insertTime?: Maybe<Scalars['Float']>;
  list?: Maybe<Array<Maybe<Org>>>;
  name?: Maybe<Scalars['String']>;
  numOfEmpolyees?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  thumbUrl?: Maybe<Scalars['String']>;
  uiFlags?: Maybe<Scalars['Float']>;
  updateTime?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};


export type OrgCountArgs = {
  filter?: InputMaybe<OrgFilter>;
};


export type OrgListArgs = {
  filter?: InputMaybe<OrgFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type OrgActions = {
  __typename?: 'OrgActions';
  add?: Maybe<Org>;
  addUser?: Maybe<User>;
  remove?: Maybe<Scalars['Boolean']>;
  removeUser?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Org>;
};


export type OrgActionsAddArgs = {
  values?: InputMaybe<OrgAdd>;
};


export type OrgActionsAddUserArgs = {
  values?: InputMaybe<UserAdd>;
};


export type OrgActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type OrgActionsRemoveUserArgs = {
  userSid?: InputMaybe<Scalars['String']>;
};


export type OrgActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<OrgUpdate>;
};

export type OrgAdd = {
  fontFamily?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  numOfEmpolyees?: InputMaybe<Scalars['String']>;
  uiFlags?: InputMaybe<Scalars['Float']>;
  url?: InputMaybe<Scalars['String']>;
};

export type OrgFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type OrgUpdate = {
  fontFamily?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  numOfEmpolyees?: InputMaybe<Scalars['String']>;
  uiFlags?: InputMaybe<Scalars['Float']>;
  url?: InputMaybe<Scalars['String']>;
};

export enum OwnerType {
  Org = 'org',
  User = 'user'
}

export type OwnerTypeFilterComparison = {
  eq?: InputMaybe<OwnerType>;
  gt?: InputMaybe<OwnerType>;
  gte?: InputMaybe<OwnerType>;
  iLike?: InputMaybe<OwnerType>;
  in?: InputMaybe<Array<OwnerType>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<OwnerType>;
  lt?: InputMaybe<OwnerType>;
  lte?: InputMaybe<OwnerType>;
  neq?: InputMaybe<OwnerType>;
  notILike?: InputMaybe<OwnerType>;
  notIn?: InputMaybe<Array<OwnerType>>;
  notLike?: InputMaybe<OwnerType>;
};

export type Pager = {
  __typename?: 'Pager';
  count?: Maybe<Scalars['Int']>;
  insertTime?: Maybe<Scalars['Float']>;
  list?: Maybe<Array<Maybe<Pager>>>;
  objectType?: Maybe<Scalars['String']>;
  pageIndex?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  sid?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};


export type PagerCountArgs = {
  filter?: InputMaybe<PagerFilter>;
};


export type PagerListArgs = {
  filter?: InputMaybe<PagerFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type PagerActions = {
  __typename?: 'PagerActions';
  add?: Maybe<Pager>;
  remove?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Pager>;
};


export type PagerActionsAddArgs = {
  values?: InputMaybe<PagerAdd>;
};


export type PagerActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type PagerActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<PagerUpdate>;
};

export type PagerAdd = {
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type PagerFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type PagerUpdate = {
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type Payment = {
  __typename?: 'Payment';
  amount?: Maybe<Scalars['Float']>;
  cardNum?: Maybe<Scalars['Int']>;
  cardType?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  insertTime?: Maybe<Scalars['Float']>;
  objectType?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};

export type PaymentActions = {
  __typename?: 'PaymentActions';
  void?: Maybe<Scalars['Boolean']>;
};

export type PaymentAdd = {
  amount?: InputMaybe<Scalars['Float']>;
  cardNum?: InputMaybe<Scalars['Int']>;
  cardType?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
};

export type PaymentUpdate = {
  amount?: InputMaybe<Scalars['Float']>;
  cardNum?: InputMaybe<Scalars['Int']>;
  cardType?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Plan = {
  __typename?: 'Plan';
  allowedTierFeatures?: Maybe<Array<Maybe<Scalars['String']>>>;
  annualDiscountPercentage?: Maybe<Scalars['Int']>;
  annualDiscountPrice?: Maybe<Scalars['Int']>;
  annualOverrideRecurringPrice?: Maybe<Scalars['Float']>;
  annualPlanId?: Maybe<Scalars['Int']>;
  annualRecurringPrice?: Maybe<Scalars['Float']>;
  brandsCount?: Maybe<Scalars['Int']>;
  buttonAditionalColor?: Maybe<Scalars['String']>;
  buttonColor?: Maybe<Scalars['String']>;
  chargeOnPlanSwitch?: Maybe<Scalars['Boolean']>;
  count?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  disallowedTierFeatures?: Maybe<Array<Maybe<Scalars['String']>>>;
  features?: Maybe<Array<Maybe<Scalars['String']>>>;
  freeTrial?: Maybe<Scalars['Int']>;
  gracePeriod?: Maybe<Scalars['Int']>;
  hidden?: Maybe<Scalars['Boolean']>;
  icon?: Maybe<Scalars['String']>;
  insertTime?: Maybe<Scalars['Float']>;
  internalName?: Maybe<Scalars['String']>;
  list?: Maybe<Array<Maybe<Plan>>>;
  maxFootageUploadMinutesDuration?: Maybe<Scalars['Int']>;
  maxFootageUploads?: Maybe<Scalars['Int']>;
  maxStorage?: Maybe<Scalars['Int']>;
  maxUsers?: Maybe<Scalars['Int']>;
  maxVideoDuration?: Maybe<Scalars['Int']>;
  maxVideos?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  overrideRecurringPrice?: Maybe<Scalars['Float']>;
  periodMaxDownloads?: Maybe<Scalars['Int']>;
  planId?: Maybe<Scalars['Int']>;
  planType?: Maybe<Scalars['Int']>;
  pricePerSeatAnnually?: Maybe<Scalars['Float']>;
  pricePerSeatMonthly?: Maybe<Scalars['Float']>;
  promptTag?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['Int']>;
  recurringPrice?: Maybe<Scalars['Float']>;
  salesOnly?: Maybe<Scalars['Boolean']>;
  showShutterStockBadge?: Maybe<Scalars['Boolean']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  subHeader?: Maybe<Scalars['String']>;
  tier?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};


export type PlanCountArgs = {
  filter?: InputMaybe<PlanFilter>;
};


export type PlanListArgs = {
  filter?: InputMaybe<PlanFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type PlanActions = {
  __typename?: 'PlanActions';
  add?: Maybe<Plan>;
  disable?: Maybe<Scalars['Boolean']>;
  enable?: Maybe<Scalars['Boolean']>;
  remove?: Maybe<Scalars['Boolean']>;
  select?: Maybe<Subscription>;
  setAsDefault?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Plan>;
};


export type PlanActionsAddArgs = {
  values?: InputMaybe<PlanAdd>;
};


export type PlanActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type PlanActionsSelectArgs = {
  subscriptionDetailts?: InputMaybe<SubscriptionAdd>;
};


export type PlanActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<PlanUpdate>;
};

export type PlanAdd = {
  annualDiscountPercentage?: InputMaybe<Scalars['Int']>;
  annualDiscountPrice?: InputMaybe<Scalars['Int']>;
  annualOverrideRecurringPrice?: InputMaybe<Scalars['Float']>;
  annualPlanId?: InputMaybe<Scalars['Int']>;
  annualRecurringPrice?: InputMaybe<Scalars['Float']>;
  brandsCount?: InputMaybe<Scalars['Int']>;
  buttonAditionalColor?: InputMaybe<Scalars['String']>;
  buttonColor?: InputMaybe<Scalars['String']>;
  chargeOnPlanSwitch?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  features?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  freeTrial?: InputMaybe<Scalars['Int']>;
  gracePeriod?: InputMaybe<Scalars['Int']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  icon?: InputMaybe<Scalars['String']>;
  internalName?: InputMaybe<Scalars['String']>;
  maxFootageUploadMinutesDuration?: InputMaybe<Scalars['Int']>;
  maxFootageUploads?: InputMaybe<Scalars['Int']>;
  maxStorage?: InputMaybe<Scalars['Int']>;
  maxUsers?: InputMaybe<Scalars['Int']>;
  maxVideoDuration?: InputMaybe<Scalars['Int']>;
  maxVideos?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  overrideRecurringPrice?: InputMaybe<Scalars['Float']>;
  periodMaxDownloads?: InputMaybe<Scalars['Int']>;
  planId?: InputMaybe<Scalars['Int']>;
  planType?: InputMaybe<Scalars['Int']>;
  pricePerSeatAnnually?: InputMaybe<Scalars['Float']>;
  pricePerSeatMonthly?: InputMaybe<Scalars['Float']>;
  promptTag?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['Int']>;
  recurringPrice?: InputMaybe<Scalars['Float']>;
  salesOnly?: InputMaybe<Scalars['Boolean']>;
  showShutterStockBadge?: InputMaybe<Scalars['Boolean']>;
  subHeader?: InputMaybe<Scalars['String']>;
  tier?: InputMaybe<Scalars['Int']>;
};

export type PlanChange = {
  __typename?: 'PlanChange';
  insertTime?: Maybe<Scalars['Float']>;
  objectType?: Maybe<Scalars['String']>;
  planSid?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};

export type PlanChangeActions = {
  __typename?: 'PlanChangeActions';
  void?: Maybe<Scalars['Boolean']>;
};

export type PlanChangeAdd = {
  planSid?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['Int']>;
};

export type PlanChangeUpdate = {
  planSid?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['Int']>;
};

export type PlanFilter = {
  hiddenEqual?: InputMaybe<Scalars['Boolean']>;
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  planTypeEqual?: InputMaybe<Scalars['String']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type PlanUpdate = {
  annualDiscountPercentage?: InputMaybe<Scalars['Int']>;
  annualDiscountPrice?: InputMaybe<Scalars['Int']>;
  annualOverrideRecurringPrice?: InputMaybe<Scalars['Float']>;
  annualPlanId?: InputMaybe<Scalars['Int']>;
  brandsCount?: InputMaybe<Scalars['Int']>;
  buttonAditionalColor?: InputMaybe<Scalars['String']>;
  buttonColor?: InputMaybe<Scalars['String']>;
  chargeOnPlanSwitch?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  features?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  freeTrial?: InputMaybe<Scalars['Int']>;
  gracePeriod?: InputMaybe<Scalars['Int']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  icon?: InputMaybe<Scalars['String']>;
  internalName?: InputMaybe<Scalars['String']>;
  maxFootageUploadMinutesDuration?: InputMaybe<Scalars['Int']>;
  maxFootageUploads?: InputMaybe<Scalars['Int']>;
  maxStorage?: InputMaybe<Scalars['Int']>;
  maxUsers?: InputMaybe<Scalars['Int']>;
  maxVideoDuration?: InputMaybe<Scalars['Int']>;
  maxVideos?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  overrideRecurringPrice?: InputMaybe<Scalars['Float']>;
  periodMaxDownloads?: InputMaybe<Scalars['Int']>;
  planId?: InputMaybe<Scalars['Int']>;
  planType?: InputMaybe<Scalars['Int']>;
  pricePerSeatAnnually?: InputMaybe<Scalars['Float']>;
  pricePerSeatMonthly?: InputMaybe<Scalars['Float']>;
  promptTag?: InputMaybe<Scalars['String']>;
  salesOnly?: InputMaybe<Scalars['Boolean']>;
  showShutterStockBadge?: InputMaybe<Scalars['Boolean']>;
  subHeader?: InputMaybe<Scalars['String']>;
  tier?: InputMaybe<Scalars['Int']>;
};

export type Preset = {
  __typename?: 'Preset';
  assets?: Maybe<Array<Maybe<AssetUsage>>>;
  bodyBoldVariant?: Maybe<Scalars['String']>;
  bodyRegularVariant?: Maybe<Scalars['String']>;
  captionsStyling?: Maybe<Scalars['String']>;
  colors?: Maybe<Array<Maybe<Color>>>;
  count?: Maybe<Scalars['Int']>;
  defaultFrameSize?: Maybe<Scalars['Float']>;
  defaultVideoType?: Maybe<Scalars['String']>;
  defaultVisualPackage?: Maybe<Scalars['String']>;
  defaultWatermarkSize?: Maybe<Scalars['Float']>;
  editRules?: Maybe<EditRules>;
  exampleAsset?: Maybe<Scalars['Boolean']>;
  fontFamily?: Maybe<Scalars['String']>;
  headerBoldVariant?: Maybe<Scalars['String']>;
  headerFontFamily?: Maybe<Scalars['String']>;
  headerRegularVariant?: Maybe<Scalars['String']>;
  insertTime?: Maybe<Scalars['Float']>;
  list?: Maybe<Array<Maybe<Preset>>>;
  name?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  secondaryColors?: Maybe<Array<Maybe<Color>>>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  userSid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};


export type PresetCountArgs = {
  filter?: InputMaybe<PresetFilter>;
};


export type PresetListArgs = {
  filter?: InputMaybe<PresetFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type PresetActions = {
  __typename?: 'PresetActions';
  add?: Maybe<Preset>;
  editRules?: Maybe<EditRulesActions>;
  remove?: Maybe<Scalars['Boolean']>;
  setDefault?: Maybe<Preset>;
  update?: Maybe<Preset>;
};


export type PresetActionsAddArgs = {
  values?: InputMaybe<PresetAdd>;
};


export type PresetActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type PresetActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<PresetUpdate>;
};

export type PresetAdd = {
  assets?: InputMaybe<Array<InputMaybe<AssetUsageAdd>>>;
  bodyBoldVariant?: InputMaybe<Scalars['String']>;
  bodyRegularVariant?: InputMaybe<Scalars['String']>;
  captionsStyling?: InputMaybe<Scalars['String']>;
  colors?: InputMaybe<Array<InputMaybe<ColorAdd>>>;
  defaultFrameSize?: InputMaybe<Scalars['Float']>;
  defaultVideoType?: InputMaybe<Scalars['String']>;
  defaultVisualPackage?: InputMaybe<Scalars['String']>;
  defaultWatermarkSize?: InputMaybe<Scalars['Float']>;
  editRules?: InputMaybe<EditRulesAdd>;
  exampleAsset?: InputMaybe<Scalars['Boolean']>;
  fontFamily?: InputMaybe<Scalars['String']>;
  headerBoldVariant?: InputMaybe<Scalars['String']>;
  headerFontFamily?: InputMaybe<Scalars['String']>;
  headerRegularVariant?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  secondaryColors?: InputMaybe<Array<InputMaybe<ColorAdd>>>;
  userSid?: InputMaybe<Scalars['String']>;
};

export type PresetFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
  userSidEqual?: InputMaybe<Scalars['String']>;
};

export type PresetUpdate = {
  assets?: InputMaybe<Array<InputMaybe<AssetUsageUpdate>>>;
  bodyBoldVariant?: InputMaybe<Scalars['String']>;
  bodyRegularVariant?: InputMaybe<Scalars['String']>;
  captionsStyling?: InputMaybe<Scalars['String']>;
  colors?: InputMaybe<Array<InputMaybe<ColorUpdate>>>;
  defaultFrameSize?: InputMaybe<Scalars['Float']>;
  defaultVideoType?: InputMaybe<Scalars['String']>;
  defaultVisualPackage?: InputMaybe<Scalars['String']>;
  defaultWatermarkSize?: InputMaybe<Scalars['Float']>;
  editRules?: InputMaybe<EditRulesUpdate>;
  exampleAsset?: InputMaybe<Scalars['Boolean']>;
  fontFamily?: InputMaybe<Scalars['String']>;
  headerBoldVariant?: InputMaybe<Scalars['String']>;
  headerFontFamily?: InputMaybe<Scalars['String']>;
  headerRegularVariant?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  secondaryColors?: InputMaybe<Array<InputMaybe<ColorUpdate>>>;
  userSid?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  asset?: Maybe<Asset>;
  board: Board;
  boards: BoardConnection;
  closedCaption?: Maybe<ClosedCaption>;
  closedCaptions: Array<ClosedCaptionsOutput>;
  closedCaptionsMetaData: Array<ClosedCaptionMetaData>;
  color?: Maybe<Color>;
  content?: Maybe<Content>;
  coupon?: Maybe<Coupon>;
  cropDetail: CropDetail;
  cropDetails: CropDetailConnection;
  cuePoint?: Maybe<CuePoint>;
  detection?: Maybe<Detection>;
  dimention?: Maybe<Dimention>;
  downloadAnimation?: Maybe<DownloadAnimation>;
  downloadInfo: DownloadInfo;
  downloadInfos: DownloadInfoConnection;
  editRules?: Maybe<EditRules>;
  feature?: Maybe<Feature>;
  folderStructure?: Maybe<FolderStructure>;
  footage: Footage;
  footageUploadsCount: Scalars['Float'];
  footageWithClipSequenceFavorites: Footage;
  footages: FootageConnection;
  frameCuePoint?: Maybe<FrameCuePoint>;
  getDownloadAvailability: DownloadAvailability;
  getDownloadsBalance: DownloadsBalance;
  getDownloadsCount: DownloadsCount;
  getFootagesByBoardId: FootageOffsetConnection;
  getWordsByExternalAssetId: SelectedWords;
  getWordsByTimes: SelectedWords;
  graphicAnimation?: Maybe<GraphicAnimation>;
  graphicAsset?: Maybe<GraphicAsset>;
  graphicColor?: Maybe<GraphicColor>;
  graphicCuePoint?: Maybe<GraphicCuePoint>;
  image?: Maybe<Image>;
  invoiceList?: Maybe<InvoiceList>;
  org?: Maybe<Org>;
  pager?: Maybe<Pager>;
  plan?: Maybe<Plan>;
  preset?: Maybe<Preset>;
  role?: Maybe<Role>;
  sequence?: Maybe<Sequence>;
  sequenceAccess?: Maybe<SequenceAccess>;
  serverError?: Maybe<ServerError>;
  shopper?: Maybe<Shopper>;
  speaker?: Maybe<Speaker>;
  speakerCuePoint?: Maybe<SpeakerCuePoint>;
  subscription?: Maybe<Subscription>;
  teamType?: Maybe<TeamType>;
  titleCuePoint?: Maybe<TitleCuePoint>;
  track?: Maybe<Track>;
  transcript: Transcript;
  transcripts: TranscriptConnection;
  user?: Maybe<User>;
  userAction?: Maybe<UserAction>;
  userBase?: Maybe<UserBase>;
  userCoupon?: Maybe<UserCoupon>;
  video?: Maybe<Video>;
  videoType?: Maybe<VideoType>;
};


export type QueryAssetArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryBoardArgs = {
  id: Scalars['ID'];
};


export type QueryBoardsArgs = {
  filter?: BoardFilter;
  paging?: OffsetPaging;
  sorting?: Array<BoardSort>;
};


export type QueryClosedCaptionArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryClosedCaptionsArgs = {
  query: QueryClosedCaption;
};


export type QueryClosedCaptionsMetaDataArgs = {
  sequenceSid: Scalars['String'];
};


export type QueryColorArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryContentArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryCouponArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryCropDetailArgs = {
  id: Scalars['ID'];
};


export type QueryCropDetailsArgs = {
  filter?: CropDetailFilter;
  paging?: OffsetPaging;
  sorting?: Array<CropDetailSort>;
};


export type QueryCuePointArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryDetectionArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryDimentionArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryDownloadAnimationArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryDownloadInfoArgs = {
  id: Scalars['ID'];
};


export type QueryDownloadInfosArgs = {
  filter?: DownloadInfoFilter;
  paging?: OffsetPaging;
  sorting?: Array<DownloadInfoSort>;
};


export type QueryEditRulesArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryFeatureArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryFolderStructureArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryFootageArgs = {
  id: Scalars['ID'];
};


export type QueryFootageUploadsCountArgs = {
  monthlyPeriodStart: Scalars['DateTime'];
};


export type QueryFootageWithClipSequenceFavoritesArgs = {
  id: Scalars['String'];
};


export type QueryFootagesArgs = {
  filter?: FootageFilter;
  paging?: OffsetPaging;
  sorting?: Array<FootageSort>;
};


export type QueryFrameCuePointArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryGetDownloadAvailabilityArgs = {
  externalSequenceEndVersion: Scalars['Int'];
  externalSequenceId: Scalars['String'];
};


export type QueryGetDownloadsCountArgs = {
  endTime: Scalars['DateTime'];
  startTime: Scalars['DateTime'];
};


export type QueryGetFootagesByBoardIdArgs = {
  boardId: Scalars['String'];
  filter?: FootageFilter;
  paging?: OffsetPaging;
  sorting?: Array<FootageSort>;
};


export type QueryGetWordsByExternalAssetIdArgs = {
  externalAssetSid: Scalars['String'];
  footageId: Scalars['String'];
};


export type QueryGetWordsByTimesArgs = {
  endTime: Scalars['Int'];
  footageId: Scalars['String'];
  startTime: Scalars['Int'];
};


export type QueryGraphicAnimationArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryGraphicAssetArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryGraphicColorArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryGraphicCuePointArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryImageArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryInvoiceListArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryOrgArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryPagerArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryPlanArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryPresetArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryRoleArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QuerySequenceArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QuerySequenceAccessArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryServerErrorArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryShopperArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QuerySpeakerArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QuerySpeakerCuePointArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QuerySubscriptionArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryTeamTypeArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryTitleCuePointArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryTrackArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryTranscriptArgs = {
  id: Scalars['ID'];
};


export type QueryTranscriptsArgs = {
  filter?: TranscriptFilter;
  paging?: OffsetPaging;
  sorting?: Array<TranscriptSort>;
};


export type QueryUserArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryUserActionArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryUserBaseArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryUserCouponArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryVideoArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type QueryVideoTypeArgs = {
  sid?: InputMaybe<Scalars['String']>;
};

export type QueryClosedCaption = {
  chapterSid?: InputMaybe<Scalars['String']>;
  maxEndTime?: InputMaybe<Scalars['Int']>;
  minStartTime?: InputMaybe<Scalars['Int']>;
  sequenceSid: Scalars['String'];
};

export type RemoveWordsInput = {
  endTime: Scalars['Float'];
  startTime: Scalars['Float'];
};

export type Role = {
  __typename?: 'Role';
  adminPermissions?: Maybe<Scalars['String']>;
  apiPermissions?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  insertTime?: Maybe<Scalars['Float']>;
  list?: Maybe<Array<Maybe<Role>>>;
  name?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  permissions?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};


export type RoleCountArgs = {
  filter?: InputMaybe<RoleFilter>;
};


export type RoleListArgs = {
  filter?: InputMaybe<RoleFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type RoleActions = {
  __typename?: 'RoleActions';
  add?: Maybe<Role>;
  remove?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Role>;
};


export type RoleActionsAddArgs = {
  values?: InputMaybe<RoleAdd>;
};


export type RoleActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type RoleActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<RoleUpdate>;
};

export type RoleAdd = {
  adminPermissions?: InputMaybe<Scalars['String']>;
  apiPermissions?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
};

export type RoleFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type RoleUpdate = {
  adminPermissions?: InputMaybe<Scalars['String']>;
  apiPermissions?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Scalars['String']>;
};

export type Scene = Chapter;

export type SceneAdd = {
  aspectRatio?: InputMaybe<Scalars['String']>;
  assetSid?: InputMaybe<Scalars['String']>;
  cid?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  duration?: InputMaybe<Scalars['Float']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalToken?: InputMaybe<Scalars['String']>;
  externalVendor?: InputMaybe<Scalars['String']>;
  index?: InputMaybe<Scalars['Int']>;
  mute?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Float']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type SceneOrder = {
  cid?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Float']>;
  index?: InputMaybe<Scalars['Int']>;
  linkSid?: InputMaybe<Scalars['String']>;
  mute?: InputMaybe<Scalars['Boolean']>;
  sid?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type SceneUpdate = {
  aspectRatio?: InputMaybe<Scalars['String']>;
  assetSid?: InputMaybe<Scalars['String']>;
  cid?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  duration?: InputMaybe<Scalars['Float']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalVendor?: InputMaybe<Scalars['String']>;
  index?: InputMaybe<Scalars['Int']>;
  mute?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Float']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type SelectedWords = {
  __typename?: 'SelectedWords';
  durationMs: Scalars['Int'];
  lastVersion: Scalars['Int'];
  words?: Maybe<Array<V2_Word>>;
};

export type Sequence = {
  __typename?: 'Sequence';
  access?: Maybe<SequenceAccess>;
  accesses?: Maybe<Array<Maybe<SequenceAccess>>>;
  accessesCount?: Maybe<Scalars['Int']>;
  altAspectRatios?: Maybe<Array<Maybe<Scalars['String']>>>;
  aspectRatio?: Maybe<Scalars['String']>;
  audio?: Maybe<Content>;
  audioGenerated?: Maybe<Scalars['Boolean']>;
  backgroundJobs?: Maybe<Array<Maybe<BackgroundJob>>>;
  burnCaptions?: Maybe<Scalars['Boolean']>;
  captionsBackgroundOpacity?: Maybe<Scalars['Float']>;
  chapter?: Maybe<Chapter>;
  chapters?: Maybe<Array<Maybe<Chapter>>>;
  colors?: Maybe<Array<Maybe<Color>>>;
  count?: Maybe<Scalars['Int']>;
  creator?: Maybe<SequenceAccess>;
  duration?: Maybe<Scalars['Float']>;
  editRules?: Maybe<EditRules>;
  editRulesSid?: Maybe<Scalars['String']>;
  errorCause?: Maybe<Scalars['String']>;
  errorCode?: Maybe<Scalars['Int']>;
  folderSid?: Maybe<Scalars['String']>;
  footageSid?: Maybe<Scalars['String']>;
  generatedType?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  highlighted?: Maybe<Scalars['Float']>;
  insertTime?: Maybe<Scalars['Float']>;
  languageCode?: Maybe<Scalars['String']>;
  list?: Maybe<Array<Maybe<Sequence>>>;
  logo?: Maybe<Logo>;
  manuallyCreatedFirstBoard?: Maybe<Scalars['String']>;
  mask?: Maybe<Content>;
  masked?: Maybe<Scalars['Float']>;
  music?: Maybe<Music>;
  musics?: Maybe<Array<Maybe<Track>>>;
  noiseReducted?: Maybe<Scalars['Boolean']>;
  objectType?: Maybe<Scalars['String']>;
  output?: Maybe<Content>;
  presetSid?: Maybe<Scalars['String']>;
  restore?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['Int']>;
  scenes?: Maybe<Array<Maybe<Scene>>>;
  sequenceGenerationFlow?: Maybe<SequenceGenerationFlow>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  style?: Maybe<Style>;
  title?: Maybe<Scalars['String']>;
  transcript?: Maybe<Scalars['Boolean']>;
  transcripted?: Maybe<Scalars['Float']>;
  updateTime?: Maybe<Scalars['Float']>;
  updateTimeStamp?: Maybe<Scalars['Int']>;
  useCaptions?: Maybe<Scalars['Boolean']>;
  useDenoised?: Maybe<Scalars['Boolean']>;
  useFootageForCrop?: Maybe<Scalars['Boolean']>;
  useGreenScreen?: Maybe<Scalars['Boolean']>;
  useTitleCuePoints?: Maybe<Scalars['Boolean']>;
  useV2ClosedCaptions?: Maybe<Scalars['Boolean']>;
  userSid?: Maybe<Scalars['String']>;
  validated?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
  video?: Maybe<Content>;
  visualPackageVersion?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
};


export type SequenceAccessArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type SequenceChapterArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type SequenceCountArgs = {
  filter?: InputMaybe<SequenceFilter>;
};


export type SequenceListArgs = {
  filter?: InputMaybe<SequenceFilter>;
  pager?: InputMaybe<PagerAdd>;
};


export type SequenceMusicsArgs = {
  count?: InputMaybe<Scalars['Int']>;
  sequenceSid?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};


export type SequenceRestoreArgs = {
  force?: InputMaybe<Scalars['Boolean']>;
};


export type SequenceTranscriptArgs = {
  force?: InputMaybe<Scalars['Boolean']>;
};

export type SequenceAccess = {
  __typename?: 'SequenceAccess';
  count?: Maybe<Scalars['Int']>;
  creator?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  insertTime?: Maybe<Scalars['Float']>;
  lastViewed?: Maybe<Scalars['Float']>;
  list?: Maybe<Array<Maybe<SequenceAccess>>>;
  name?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['Int']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  thumbUrl?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  userSid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};


export type SequenceAccessCountArgs = {
  filter?: InputMaybe<SequenceAccessFilter>;
};


export type SequenceAccessListArgs = {
  filter?: InputMaybe<SequenceAccessFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type SequenceAccessActions = {
  __typename?: 'SequenceAccessActions';
  add?: Maybe<SequenceAccess>;
  remove?: Maybe<Scalars['Boolean']>;
  update?: Maybe<SequenceAccess>;
};


export type SequenceAccessActionsAddArgs = {
  values?: InputMaybe<SequenceAccessAdd>;
};


export type SequenceAccessActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type SequenceAccessActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<SequenceAccessUpdate>;
};

export type SequenceAccessAdd = {
  email?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['Int']>;
  userSid?: InputMaybe<Scalars['String']>;
};

export type SequenceAccessFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type SequenceAccessUpdate = {
  role?: InputMaybe<Scalars['Int']>;
};

export type SequenceActions = {
  __typename?: 'SequenceActions';
  accessActions?: Maybe<SequenceAccessActions>;
  add?: Maybe<Sequence>;
  addChapter?: Maybe<Chapter>;
  audio?: Maybe<ContentActions>;
  cancelGenerate?: Maybe<Scalars['Boolean']>;
  chapterActions?: Maybe<ChapterActions>;
  clone?: Maybe<Sequence>;
  cloneChapter?: Maybe<Chapter>;
  createFromTemplate?: Maybe<Sequence>;
  createHighlight?: Maybe<Scalars['Boolean']>;
  deleteChapter?: Maybe<Scalars['Boolean']>;
  editRules?: Maybe<EditRulesActions>;
  generate?: Maybe<Sequence>;
  generateAudio?: Maybe<Scalars['Boolean']>;
  grantAccess?: Maybe<SequenceAccess>;
  logo?: Maybe<LogoActions>;
  mask?: Maybe<ContentActions>;
  music?: Maybe<MusicActions>;
  output?: Maybe<ContentActions>;
  remove?: Maybe<Scalars['Boolean']>;
  reorderScenes?: Maybe<Sequence>;
  revokeAccess?: Maybe<Scalars['Boolean']>;
  sequenceGenerationFlow?: Maybe<SequenceGenerationFlowActions>;
  style?: Maybe<StyleActions>;
  translate?: Maybe<Scalars['String']>;
  update?: Maybe<Sequence>;
  updateAccess?: Maybe<SequenceAccess>;
  updateChapter?: Maybe<Chapter>;
  updatePreset?: Maybe<Sequence>;
  validateInputs?: Maybe<Sequence>;
  video?: Maybe<ContentActions>;
};


export type SequenceActionsAccessActionsArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type SequenceActionsAddArgs = {
  values?: InputMaybe<SequenceAdd>;
};


export type SequenceActionsAddChapterArgs = {
  chapter?: InputMaybe<ChapterAdd>;
};


export type SequenceActionsChapterActionsArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type SequenceActionsCloneArgs = {
  aspectRatio?: InputMaybe<Scalars['String']>;
  footageSid?: InputMaybe<Scalars['String']>;
  languageCode?: InputMaybe<Scalars['String']>;
  sid?: InputMaybe<Scalars['String']>;
  userSid?: InputMaybe<Scalars['String']>;
};


export type SequenceActionsCloneChapterArgs = {
  chapter?: InputMaybe<ChapterUpdate>;
  sid?: InputMaybe<Scalars['String']>;
};


export type SequenceActionsCreateFromTemplateArgs = {
  aspectRatio?: InputMaybe<Scalars['String']>;
  presetSid?: InputMaybe<Scalars['String']>;
  userSid?: InputMaybe<Scalars['String']>;
};


export type SequenceActionsCreateHighlightArgs = {
  assetSids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  userSid?: InputMaybe<Scalars['String']>;
};


export type SequenceActionsDeleteChapterArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type SequenceActionsGenerateArgs = {
  aspectRatio?: InputMaybe<Scalars['String']>;
  force?: InputMaybe<Scalars['Boolean']>;
  sid?: InputMaybe<Scalars['String']>;
};


export type SequenceActionsGrantAccessArgs = {
  access?: InputMaybe<SequenceAccessAdd>;
};


export type SequenceActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type SequenceActionsReorderScenesArgs = {
  scenes?: InputMaybe<Array<InputMaybe<ChapterOrder>>>;
};


export type SequenceActionsRevokeAccessArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type SequenceActionsTranslateArgs = {
  languageCode?: InputMaybe<Scalars['String']>;
  sequenceSid?: InputMaybe<Scalars['String']>;
};


export type SequenceActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<SequenceUpdate>;
};


export type SequenceActionsUpdateAccessArgs = {
  access?: InputMaybe<SequenceAccessUpdate>;
  sid?: InputMaybe<Scalars['String']>;
};


export type SequenceActionsUpdateChapterArgs = {
  chapter?: InputMaybe<ChapterUpdate>;
  sid?: InputMaybe<Scalars['String']>;
};


export type SequenceActionsUpdatePresetArgs = {
  presetSid?: InputMaybe<Scalars['String']>;
  sequenceSid?: InputMaybe<Scalars['String']>;
  userSid?: InputMaybe<Scalars['String']>;
};

export type SequenceAdd = {
  altAspectRatios?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  aspectRatio?: InputMaybe<Scalars['String']>;
  burnCaptions?: InputMaybe<Scalars['Boolean']>;
  captionsBackgroundOpacity?: InputMaybe<Scalars['Float']>;
  colors?: InputMaybe<Array<InputMaybe<ColorAdd>>>;
  editRules?: InputMaybe<EditRulesAdd>;
  editRulesSid?: InputMaybe<Scalars['String']>;
  folderSid?: InputMaybe<Scalars['String']>;
  footageSid?: InputMaybe<Scalars['String']>;
  generatedType?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  languageCode?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<LogoAdd>;
  manuallyCreatedFirstBoard?: InputMaybe<Scalars['String']>;
  music?: InputMaybe<MusicAdd>;
  presetSid?: InputMaybe<Scalars['String']>;
  style?: InputMaybe<StyleAdd>;
  title?: InputMaybe<Scalars['String']>;
  useCaptions?: InputMaybe<Scalars['Boolean']>;
  useDenoised?: InputMaybe<Scalars['Boolean']>;
  useGreenScreen?: InputMaybe<Scalars['Boolean']>;
  useTitleCuePoints?: InputMaybe<Scalars['Boolean']>;
  visualPackageVersion?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type SequenceFilter = {
  folderSidEqual?: InputMaybe<Scalars['String']>;
  folderSidIsNull?: InputMaybe<Scalars['Boolean']>;
  footageSidEqual?: InputMaybe<Scalars['String']>;
  generatedTypeEqual?: InputMaybe<Scalars['String']>;
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  languageCodeEqual?: InputMaybe<Scalars['String']>;
  roleEqual?: InputMaybe<Scalars['Int']>;
  roleIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  roleNotEqual?: InputMaybe<Scalars['Int']>;
  roleNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
  userSidEqual?: InputMaybe<Scalars['String']>;
};

export type SequenceGenerationFlow = {
  __typename?: 'SequenceGenerationFlow';
  insertTime?: Maybe<Scalars['Float']>;
  objectType?: Maybe<Scalars['String']>;
  overlayJobId?: Maybe<Scalars['String']>;
  overlayJobQueueName?: Maybe<Scalars['String']>;
  rootJobId?: Maybe<Scalars['String']>;
  rootJobQueueName?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['Float']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};

export type SequenceGenerationFlowActions = {
  __typename?: 'SequenceGenerationFlowActions';
  void?: Maybe<Scalars['Boolean']>;
};

export enum SequenceInteraction {
  Downloaded = 'downloaded',
  Edited = 'edited',
  Opened = 'opened'
}

export type SequenceUpdate = {
  altAspectRatios?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  aspectRatio?: InputMaybe<Scalars['String']>;
  burnCaptions?: InputMaybe<Scalars['Boolean']>;
  captionsBackgroundOpacity?: InputMaybe<Scalars['Float']>;
  colors?: InputMaybe<Array<InputMaybe<ColorUpdate>>>;
  editRules?: InputMaybe<EditRulesUpdate>;
  editRulesSid?: InputMaybe<Scalars['String']>;
  folderSid?: InputMaybe<Scalars['String']>;
  footageSid?: InputMaybe<Scalars['String']>;
  generatedType?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  languageCode?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<LogoUpdate>;
  music?: InputMaybe<MusicUpdate>;
  presetSid?: InputMaybe<Scalars['String']>;
  style?: InputMaybe<StyleUpdate>;
  title?: InputMaybe<Scalars['String']>;
  updateTimeStamp?: InputMaybe<Scalars['Int']>;
  useCaptions?: InputMaybe<Scalars['Boolean']>;
  useDenoised?: InputMaybe<Scalars['Boolean']>;
  useGreenScreen?: InputMaybe<Scalars['Boolean']>;
  useTitleCuePoints?: InputMaybe<Scalars['Boolean']>;
  visualPackageVersion?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type SequenceUserJunction = {
  __typename?: 'SequenceUserJunction';
  clipSequenceId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  externalUserSid: Scalars['String'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type SequenceUserJunctionNonEmbeddedInput = {
  clipSequenceId: Scalars['String'];
  externalUserSid: Scalars['String'];
};

export type ServerError = {
  __typename?: 'ServerError';
  code?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  insertTime?: Maybe<Scalars['Float']>;
  list?: Maybe<Array<Maybe<ServerError>>>;
  message?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};


export type ServerErrorCountArgs = {
  filter?: InputMaybe<ServerErrorFilter>;
};


export type ServerErrorListArgs = {
  filter?: InputMaybe<ServerErrorFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type ServerErrorActions = {
  __typename?: 'ServerErrorActions';
  add?: Maybe<ServerError>;
  remove?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ServerError>;
};


export type ServerErrorActionsAddArgs = {
  values?: InputMaybe<ServerErrorAdd>;
};


export type ServerErrorActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type ServerErrorActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<ServerErrorUpdate>;
};

export type ServerErrorAdd = {
  code?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ServerErrorFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type ServerErrorUpdate = {
  code?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Shopper = {
  __typename?: 'Shopper';
  ccType?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  exp?: Maybe<Scalars['String']>;
  fraudSessionId?: Maybe<Scalars['String']>;
  insertTime?: Maybe<Scalars['Float']>;
  lastDigits?: Maybe<Scalars['String']>;
  list?: Maybe<Array<Maybe<Shopper>>>;
  name?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  orgSid?: Maybe<Scalars['String']>;
  shopperId?: Maybe<Scalars['Float']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  updateUrl?: Maybe<Scalars['String']>;
  userSid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  zip?: Maybe<Scalars['String']>;
};


export type ShopperCountArgs = {
  filter?: InputMaybe<ShopperFilter>;
};


export type ShopperListArgs = {
  filter?: InputMaybe<ShopperFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type ShopperActions = {
  __typename?: 'ShopperActions';
  add?: Maybe<Shopper>;
  remove?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Shopper>;
};


export type ShopperActionsAddArgs = {
  values?: InputMaybe<ShopperAdd>;
};


export type ShopperActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type ShopperActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<ShopperUpdate>;
};

export type ShopperAdd = {
  ccType?: InputMaybe<Scalars['String']>;
  exp?: InputMaybe<Scalars['String']>;
  fraudSessionId?: InputMaybe<Scalars['String']>;
  lastDigits?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orgSid?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  updateUrl?: InputMaybe<Scalars['String']>;
  userSid?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type ShopperFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
  userSidEqual?: InputMaybe<Scalars['String']>;
};

export type ShopperUpdate = {
  ccType?: InputMaybe<Scalars['String']>;
  exp?: InputMaybe<Scalars['String']>;
  fraudSessionId?: InputMaybe<Scalars['String']>;
  lastDigits?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orgSid?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  updateUrl?: InputMaybe<Scalars['String']>;
  userSid?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type Skip = {
  __typename?: 'Skip';
  endTime?: Maybe<Scalars['Int']>;
  insertTime?: Maybe<Scalars['Float']>;
  objectType?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};

export type SkipActions = {
  __typename?: 'SkipActions';
  void?: Maybe<Scalars['Boolean']>;
};

export type SkipAdd = {
  endTime?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Int']>;
};

export type SkipUpdate = {
  endTime?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Int']>;
};

/** Sort Directions */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Sort Nulls Options */
export enum SortNulls {
  NullsFirst = 'NULLS_FIRST',
  NullsLast = 'NULLS_LAST'
}

export type Speaker = {
  __typename?: 'Speaker';
  count?: Maybe<Scalars['Int']>;
  insertTime?: Maybe<Scalars['Float']>;
  list?: Maybe<Array<Maybe<Speaker>>>;
  name?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  orgSid?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['Float']>;
  userSid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};


export type SpeakerCountArgs = {
  filter?: InputMaybe<SpeakerFilter>;
};


export type SpeakerListArgs = {
  filter?: InputMaybe<SpeakerFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type SpeakerActions = {
  __typename?: 'SpeakerActions';
  add?: Maybe<Speaker>;
  remove?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Speaker>;
};


export type SpeakerActionsAddArgs = {
  values?: InputMaybe<SpeakerAdd>;
};


export type SpeakerActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type SpeakerActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<SpeakerUpdate>;
};

export type SpeakerAdd = {
  name?: InputMaybe<Scalars['String']>;
  orgSid?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  userSid?: InputMaybe<Scalars['String']>;
};

export type SpeakerCuePoint = {
  __typename?: 'SpeakerCuePoint';
  alignment?: Maybe<Scalars['String']>;
  animations?: Maybe<Array<Maybe<GraphicAnimation>>>;
  aspectRatio?: Maybe<Scalars['String']>;
  assetSid?: Maybe<Scalars['String']>;
  assets?: Maybe<Array<Maybe<GraphicAsset>>>;
  bottom?: Maybe<Scalars['Float']>;
  chapterSid?: Maybe<Scalars['String']>;
  colors?: Maybe<Array<Maybe<GraphicColor>>>;
  configurationTime?: Maybe<Scalars['Float']>;
  contentVersion?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Float']>;
  endTime?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  generatingTime?: Maybe<Scalars['Float']>;
  grayscale?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  index?: Maybe<Scalars['Int']>;
  insertTime?: Maybe<Scalars['Float']>;
  key?: Maybe<Scalars['String']>;
  left?: Maybe<Scalars['Float']>;
  linkSid?: Maybe<Scalars['String']>;
  list?: Maybe<Array<Maybe<SpeakerCuePoint>>>;
  logoScale?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  nameBackgroundColor?: Maybe<Scalars['String']>;
  nameBackgroundColorIndex?: Maybe<Scalars['Int']>;
  nameColor?: Maybe<Scalars['String']>;
  nameColorIndex?: Maybe<Scalars['Int']>;
  objectType?: Maybe<Scalars['String']>;
  opacity?: Maybe<Scalars['Float']>;
  overlayed?: Maybe<Scalars['Boolean']>;
  right?: Maybe<Scalars['Float']>;
  sequenceSid?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  speaker?: Maybe<Speaker>;
  speakerSid?: Maybe<Scalars['String']>;
  srcDuration?: Maybe<Scalars['Float']>;
  srcEndTime?: Maybe<Scalars['Int']>;
  srcStartTime?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  thumbnailVersion?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  titleBackgroundColor?: Maybe<Scalars['String']>;
  titleBackgroundColorIndex?: Maybe<Scalars['Int']>;
  titleColor?: Maybe<Scalars['String']>;
  titleColorIndex?: Maybe<Scalars['Int']>;
  top?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Float']>;
  zIndex?: Maybe<Scalars['Int']>;
};


export type SpeakerCuePointCountArgs = {
  filter?: InputMaybe<SpeakerCuePointFilter>;
};


export type SpeakerCuePointListArgs = {
  filter?: InputMaybe<SpeakerCuePointFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type SpeakerCuePointActions = {
  __typename?: 'SpeakerCuePointActions';
  activate?: Maybe<Scalars['Boolean']>;
  add?: Maybe<SpeakerCuePoint>;
  deactivate?: Maybe<Scalars['Boolean']>;
  remove?: Maybe<Scalars['Boolean']>;
  reoverlay?: Maybe<Scalars['Boolean']>;
  speaker?: Maybe<SpeakerActions>;
  update?: Maybe<SpeakerCuePoint>;
};


export type SpeakerCuePointActionsAddArgs = {
  values?: InputMaybe<SpeakerCuePointAdd>;
};


export type SpeakerCuePointActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type SpeakerCuePointActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<SpeakerCuePointUpdate>;
};

export type SpeakerCuePointAdd = {
  alignment?: InputMaybe<Scalars['String']>;
  animations?: InputMaybe<Array<InputMaybe<GraphicAnimationAdd>>>;
  assetSid?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<Array<InputMaybe<GraphicAssetAdd>>>;
  bottom?: InputMaybe<Scalars['Float']>;
  chapterSid?: InputMaybe<Scalars['String']>;
  colors?: InputMaybe<Array<InputMaybe<GraphicColorAdd>>>;
  duration?: InputMaybe<Scalars['Float']>;
  endTime?: InputMaybe<Scalars['Int']>;
  externalId?: InputMaybe<Scalars['String']>;
  grayscale?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  index?: InputMaybe<Scalars['Int']>;
  left?: InputMaybe<Scalars['Float']>;
  logoScale?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  nameBackgroundColor?: InputMaybe<Scalars['String']>;
  nameBackgroundColorIndex?: InputMaybe<Scalars['Int']>;
  nameColor?: InputMaybe<Scalars['String']>;
  nameColorIndex?: InputMaybe<Scalars['Int']>;
  opacity?: InputMaybe<Scalars['Float']>;
  right?: InputMaybe<Scalars['Float']>;
  sequenceSid?: InputMaybe<Scalars['String']>;
  speakerSid?: InputMaybe<Scalars['String']>;
  srcEndTime?: InputMaybe<Scalars['Int']>;
  srcStartTime?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Int']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleBackgroundColor?: InputMaybe<Scalars['String']>;
  titleBackgroundColorIndex?: InputMaybe<Scalars['Int']>;
  titleColor?: InputMaybe<Scalars['String']>;
  titleColorIndex?: InputMaybe<Scalars['Int']>;
  top?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Float']>;
  zIndex?: InputMaybe<Scalars['Int']>;
};

export type SpeakerCuePointFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  sequenceSidEqual?: InputMaybe<Scalars['String']>;
  sidEqual?: InputMaybe<Scalars['String']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type SpeakerCuePointUpdate = {
  alignment?: InputMaybe<Scalars['String']>;
  animations?: InputMaybe<Array<InputMaybe<GraphicAnimationUpdate>>>;
  assetSid?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<Array<InputMaybe<GraphicAssetUpdate>>>;
  bottom?: InputMaybe<Scalars['Float']>;
  chapterSid?: InputMaybe<Scalars['String']>;
  colors?: InputMaybe<Array<InputMaybe<GraphicColorUpdate>>>;
  duration?: InputMaybe<Scalars['Float']>;
  endTime?: InputMaybe<Scalars['Int']>;
  externalId?: InputMaybe<Scalars['String']>;
  grayscale?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  index?: InputMaybe<Scalars['Int']>;
  left?: InputMaybe<Scalars['Float']>;
  logoScale?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  nameBackgroundColor?: InputMaybe<Scalars['String']>;
  nameBackgroundColorIndex?: InputMaybe<Scalars['Int']>;
  nameColor?: InputMaybe<Scalars['String']>;
  nameColorIndex?: InputMaybe<Scalars['Int']>;
  opacity?: InputMaybe<Scalars['Float']>;
  right?: InputMaybe<Scalars['Float']>;
  speakerSid?: InputMaybe<Scalars['String']>;
  srcEndTime?: InputMaybe<Scalars['Int']>;
  srcStartTime?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Int']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleBackgroundColor?: InputMaybe<Scalars['String']>;
  titleBackgroundColorIndex?: InputMaybe<Scalars['Int']>;
  titleColor?: InputMaybe<Scalars['String']>;
  titleColorIndex?: InputMaybe<Scalars['Int']>;
  top?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
  zIndex?: InputMaybe<Scalars['Int']>;
};

export type SpeakerFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type SpeakerUpdate = {
  name?: InputMaybe<Scalars['String']>;
  orgSid?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  userSid?: InputMaybe<Scalars['String']>;
};

export type StringFieldComparison = {
  eq?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  iLike?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['String']>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
  notILike?: InputMaybe<Scalars['String']>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  notLike?: InputMaybe<Scalars['String']>;
};

export type Style = {
  __typename?: 'Style';
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundOpacity?: Maybe<Scalars['Float']>;
  bodyBoldFileName?: Maybe<Scalars['String']>;
  bodyRegularFileName?: Maybe<Scalars['String']>;
  borderColor?: Maybe<Scalars['String']>;
  borderStyle?: Maybe<Scalars['String']>;
  borderWidth?: Maybe<Scalars['Float']>;
  captionFormatting?: Maybe<Scalars['String']>;
  captionsCaseType?: Maybe<Scalars['Int']>;
  captionsFontAssetSid?: Maybe<Scalars['String']>;
  captionsFontColor?: Maybe<Scalars['String']>;
  captionsFontColorIndex?: Maybe<Scalars['Int']>;
  captionsFontFamily?: Maybe<Scalars['String']>;
  captionsFontSize?: Maybe<Scalars['Float']>;
  captionsPosition?: Maybe<Scalars['Int']>;
  captionsRegularFileName?: Maybe<Scalars['String']>;
  captionsStyleColor?: Maybe<Scalars['String']>;
  captionsStyleColorIndex?: Maybe<Scalars['Int']>;
  captionsStyleType?: Maybe<Scalars['Int']>;
  captionsVerticalAlign?: Maybe<Scalars['Int']>;
  depth?: Maybe<Scalars['Int']>;
  depthColor?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  fade?: Maybe<Scalars['Boolean']>;
  fontAssetSid?: Maybe<Scalars['String']>;
  fontFamily?: Maybe<Scalars['String']>;
  fontItalic?: Maybe<Scalars['Boolean']>;
  fontSize?: Maybe<Scalars['Float']>;
  fontWeight?: Maybe<Scalars['String']>;
  foregroundColor?: Maybe<Scalars['String']>;
  frameAssetSid?: Maybe<Scalars['String']>;
  framePositionX?: Maybe<Scalars['Float']>;
  framePositionY?: Maybe<Scalars['Float']>;
  frameWidth?: Maybe<Scalars['Float']>;
  headerBoldFileName?: Maybe<Scalars['String']>;
  headerFontAssetSid?: Maybe<Scalars['String']>;
  headerFontFamily?: Maybe<Scalars['String']>;
  headerRegularFileName?: Maybe<Scalars['String']>;
  highlightColorIndex?: Maybe<Scalars['Int']>;
  iconAssetSid?: Maybe<Scalars['String']>;
  imageAssetSid?: Maybe<Scalars['String']>;
  imagesStyleName?: Maybe<Scalars['String']>;
  insertTime?: Maybe<Scalars['Float']>;
  introAssetSid?: Maybe<Scalars['String']>;
  introLogoAssetSid?: Maybe<Scalars['String']>;
  layers?: Maybe<Scalars['Int']>;
  objectType?: Maybe<Scalars['String']>;
  outlineColor?: Maybe<Scalars['String']>;
  outlineStyle?: Maybe<Scalars['String']>;
  outlineWidth?: Maybe<Scalars['Float']>;
  outroAssetSid?: Maybe<Scalars['String']>;
  outroLogoAssetSid?: Maybe<Scalars['String']>;
  padding?: Maybe<Array<Maybe<Scalars['Float']>>>;
  perspective?: Maybe<Scalars['Int']>;
  sid?: Maybe<Scalars['String']>;
  slideAssetSid?: Maybe<Scalars['String']>;
  speakerAssetSid?: Maybe<Scalars['String']>;
  textAssetSid?: Maybe<Scalars['String']>;
  transitionAssetSid?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
  videoAssetSid?: Maybe<Scalars['String']>;
  visualPackageSid?: Maybe<Scalars['String']>;
};

export type StyleActions = {
  __typename?: 'StyleActions';
  void?: Maybe<Scalars['Boolean']>;
};

export type StyleAdd = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  backgroundOpacity?: InputMaybe<Scalars['Float']>;
  bodyBoldFileName?: InputMaybe<Scalars['String']>;
  bodyRegularFileName?: InputMaybe<Scalars['String']>;
  borderColor?: InputMaybe<Scalars['String']>;
  borderStyle?: InputMaybe<Scalars['String']>;
  borderWidth?: InputMaybe<Scalars['Float']>;
  captionFormatting?: InputMaybe<Scalars['String']>;
  captionsCaseType?: InputMaybe<Scalars['Int']>;
  captionsFontAssetSid?: InputMaybe<Scalars['String']>;
  captionsFontColor?: InputMaybe<Scalars['String']>;
  captionsFontColorIndex?: InputMaybe<Scalars['Int']>;
  captionsFontFamily?: InputMaybe<Scalars['String']>;
  captionsFontSize?: InputMaybe<Scalars['Float']>;
  captionsPosition?: InputMaybe<Scalars['Int']>;
  captionsRegularFileName?: InputMaybe<Scalars['String']>;
  captionsStyleColor?: InputMaybe<Scalars['String']>;
  captionsStyleColorIndex?: InputMaybe<Scalars['Int']>;
  captionsStyleType?: InputMaybe<Scalars['Int']>;
  captionsVerticalAlign?: InputMaybe<Scalars['Int']>;
  depth?: InputMaybe<Scalars['Int']>;
  depthColor?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  fade?: InputMaybe<Scalars['Boolean']>;
  fontAssetSid?: InputMaybe<Scalars['String']>;
  fontFamily?: InputMaybe<Scalars['String']>;
  fontItalic?: InputMaybe<Scalars['Boolean']>;
  fontSize?: InputMaybe<Scalars['Float']>;
  fontWeight?: InputMaybe<Scalars['String']>;
  foregroundColor?: InputMaybe<Scalars['String']>;
  frameAssetSid?: InputMaybe<Scalars['String']>;
  framePositionX?: InputMaybe<Scalars['Float']>;
  framePositionY?: InputMaybe<Scalars['Float']>;
  frameWidth?: InputMaybe<Scalars['Float']>;
  headerBoldFileName?: InputMaybe<Scalars['String']>;
  headerFontAssetSid?: InputMaybe<Scalars['String']>;
  headerFontFamily?: InputMaybe<Scalars['String']>;
  headerRegularFileName?: InputMaybe<Scalars['String']>;
  highlightColorIndex?: InputMaybe<Scalars['Int']>;
  iconAssetSid?: InputMaybe<Scalars['String']>;
  imageAssetSid?: InputMaybe<Scalars['String']>;
  imagesStyleName?: InputMaybe<Scalars['String']>;
  introAssetSid?: InputMaybe<Scalars['String']>;
  introLogoAssetSid?: InputMaybe<Scalars['String']>;
  layers?: InputMaybe<Scalars['Int']>;
  outlineColor?: InputMaybe<Scalars['String']>;
  outlineStyle?: InputMaybe<Scalars['String']>;
  outlineWidth?: InputMaybe<Scalars['Float']>;
  outroAssetSid?: InputMaybe<Scalars['String']>;
  outroLogoAssetSid?: InputMaybe<Scalars['String']>;
  padding?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  perspective?: InputMaybe<Scalars['Int']>;
  slideAssetSid?: InputMaybe<Scalars['String']>;
  speakerAssetSid?: InputMaybe<Scalars['String']>;
  textAssetSid?: InputMaybe<Scalars['String']>;
  transitionAssetSid?: InputMaybe<Scalars['String']>;
  videoAssetSid?: InputMaybe<Scalars['String']>;
  visualPackageSid?: InputMaybe<Scalars['String']>;
};

export type StyleUpdate = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  backgroundOpacity?: InputMaybe<Scalars['Float']>;
  bodyBoldFileName?: InputMaybe<Scalars['String']>;
  bodyRegularFileName?: InputMaybe<Scalars['String']>;
  borderColor?: InputMaybe<Scalars['String']>;
  borderStyle?: InputMaybe<Scalars['String']>;
  borderWidth?: InputMaybe<Scalars['Float']>;
  captionFormatting?: InputMaybe<Scalars['String']>;
  captionsCaseType?: InputMaybe<Scalars['Int']>;
  captionsFontAssetSid?: InputMaybe<Scalars['String']>;
  captionsFontColor?: InputMaybe<Scalars['String']>;
  captionsFontColorIndex?: InputMaybe<Scalars['Int']>;
  captionsFontFamily?: InputMaybe<Scalars['String']>;
  captionsFontSize?: InputMaybe<Scalars['Float']>;
  captionsPosition?: InputMaybe<Scalars['Int']>;
  captionsRegularFileName?: InputMaybe<Scalars['String']>;
  captionsStyleColor?: InputMaybe<Scalars['String']>;
  captionsStyleColorIndex?: InputMaybe<Scalars['Int']>;
  captionsStyleType?: InputMaybe<Scalars['Int']>;
  captionsVerticalAlign?: InputMaybe<Scalars['Int']>;
  depth?: InputMaybe<Scalars['Int']>;
  depthColor?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  fade?: InputMaybe<Scalars['Boolean']>;
  fontAssetSid?: InputMaybe<Scalars['String']>;
  fontFamily?: InputMaybe<Scalars['String']>;
  fontItalic?: InputMaybe<Scalars['Boolean']>;
  fontSize?: InputMaybe<Scalars['Float']>;
  fontWeight?: InputMaybe<Scalars['String']>;
  foregroundColor?: InputMaybe<Scalars['String']>;
  frameAssetSid?: InputMaybe<Scalars['String']>;
  framePositionX?: InputMaybe<Scalars['Float']>;
  framePositionY?: InputMaybe<Scalars['Float']>;
  frameWidth?: InputMaybe<Scalars['Float']>;
  headerBoldFileName?: InputMaybe<Scalars['String']>;
  headerFontAssetSid?: InputMaybe<Scalars['String']>;
  headerFontFamily?: InputMaybe<Scalars['String']>;
  headerRegularFileName?: InputMaybe<Scalars['String']>;
  highlightColorIndex?: InputMaybe<Scalars['Int']>;
  iconAssetSid?: InputMaybe<Scalars['String']>;
  imageAssetSid?: InputMaybe<Scalars['String']>;
  imagesStyleName?: InputMaybe<Scalars['String']>;
  introAssetSid?: InputMaybe<Scalars['String']>;
  introLogoAssetSid?: InputMaybe<Scalars['String']>;
  layers?: InputMaybe<Scalars['Int']>;
  outlineColor?: InputMaybe<Scalars['String']>;
  outlineStyle?: InputMaybe<Scalars['String']>;
  outlineWidth?: InputMaybe<Scalars['Float']>;
  outroAssetSid?: InputMaybe<Scalars['String']>;
  outroLogoAssetSid?: InputMaybe<Scalars['String']>;
  padding?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  perspective?: InputMaybe<Scalars['Int']>;
  slideAssetSid?: InputMaybe<Scalars['String']>;
  speakerAssetSid?: InputMaybe<Scalars['String']>;
  textAssetSid?: InputMaybe<Scalars['String']>;
  transitionAssetSid?: InputMaybe<Scalars['String']>;
  videoAssetSid?: InputMaybe<Scalars['String']>;
  visualPackageSid?: InputMaybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  billingAddress?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingName?: Maybe<Scalars['String']>;
  chargeType?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  couponSid?: Maybe<Scalars['String']>;
  footageUploadsCount?: Maybe<Scalars['Int']>;
  freeTrialRemainingTime?: Maybe<Scalars['Float']>;
  insertTime?: Maybe<Scalars['Float']>;
  invoices?: Maybe<InvoiceList>;
  isCanceled?: Maybe<Scalars['Boolean']>;
  lastActivationDate?: Maybe<Scalars['Float']>;
  list?: Maybe<Array<Maybe<Subscription>>>;
  monthlyPeriodStart?: Maybe<Scalars['Float']>;
  nextChargeTime?: Maybe<Scalars['Float']>;
  objectType?: Maybe<Scalars['String']>;
  orgSid?: Maybe<Scalars['String']>;
  plan?: Maybe<Plan>;
  planSid?: Maybe<Scalars['String']>;
  recurringPrice?: Maybe<Scalars['Float']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  subscriptionId?: Maybe<Scalars['Float']>;
  taxId?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['Float']>;
  userSid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};


export type SubscriptionCountArgs = {
  filter?: InputMaybe<SubscriptionFilter>;
};


export type SubscriptionInvoicesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type SubscriptionListArgs = {
  filter?: InputMaybe<SubscriptionFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type SubscriptionActions = {
  __typename?: 'SubscriptionActions';
  add?: Maybe<Subscription>;
  cancel?: Maybe<Scalars['Boolean']>;
  remove?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Subscription>;
};


export type SubscriptionActionsAddArgs = {
  values?: InputMaybe<SubscriptionAdd>;
};


export type SubscriptionActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type SubscriptionActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<SubscriptionUpdate>;
};

export type SubscriptionAdd = {
  billingAddress?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingName?: InputMaybe<Scalars['String']>;
  chargeType?: InputMaybe<Scalars['Int']>;
  orgSid?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  userSid?: InputMaybe<Scalars['String']>;
};

export type SubscriptionFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
  userSidEqual?: InputMaybe<Scalars['String']>;
};

export type SubscriptionUpdate = {
  billingAddress?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingName?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
};

export type TeamType = {
  __typename?: 'TeamType';
  count?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  insertTime?: Maybe<Scalars['Float']>;
  list?: Maybe<Array<Maybe<TeamType>>>;
  name?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
  videoTypeSids?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type TeamTypeCountArgs = {
  filter?: InputMaybe<TeamTypeFilter>;
};


export type TeamTypeListArgs = {
  filter?: InputMaybe<TeamTypeFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type TeamTypeActions = {
  __typename?: 'TeamTypeActions';
  add?: Maybe<TeamType>;
  remove?: Maybe<Scalars['Boolean']>;
  update?: Maybe<TeamType>;
};


export type TeamTypeActionsAddArgs = {
  values?: InputMaybe<TeamTypeAdd>;
};


export type TeamTypeActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type TeamTypeActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<TeamTypeUpdate>;
};

export type TeamTypeAdd = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  videoTypeSids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TeamTypeFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type TeamTypeUpdate = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  videoTypeSids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Text = {
  __typename?: 'Text';
  align?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Float']>;
  enableX?: Maybe<Scalars['Boolean']>;
  enableY?: Maybe<Scalars['Boolean']>;
  fontItalic?: Maybe<Scalars['Boolean']>;
  fontSize?: Maybe<Scalars['Float']>;
  fontWeight?: Maybe<Scalars['String']>;
  insertTime?: Maybe<Scalars['Float']>;
  lineHeight?: Maybe<Scalars['Float']>;
  objectType?: Maybe<Scalars['String']>;
  opacity?: Maybe<Scalars['Float']>;
  shadowBlur?: Maybe<Scalars['Float']>;
  shadowColor?: Maybe<Scalars['String']>;
  shadowOffsetX?: Maybe<Scalars['Float']>;
  shadowOffsetY?: Maybe<Scalars['Float']>;
  shadowOpacity?: Maybe<Scalars['Float']>;
  sid?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Float']>;
  startColor?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['Float']>;
  velocityType?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

export type TextActions = {
  __typename?: 'TextActions';
  void?: Maybe<Scalars['Boolean']>;
};

export type TextAdd = {
  align?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Float']>;
  enableX?: InputMaybe<Scalars['Boolean']>;
  enableY?: InputMaybe<Scalars['Boolean']>;
  fontItalic?: InputMaybe<Scalars['Boolean']>;
  fontSize?: InputMaybe<Scalars['Float']>;
  fontWeight?: InputMaybe<Scalars['String']>;
  lineHeight?: InputMaybe<Scalars['Float']>;
  opacity?: InputMaybe<Scalars['Float']>;
  shadowBlur?: InputMaybe<Scalars['Float']>;
  shadowColor?: InputMaybe<Scalars['String']>;
  shadowOffsetX?: InputMaybe<Scalars['Float']>;
  shadowOffsetY?: InputMaybe<Scalars['Float']>;
  shadowOpacity?: InputMaybe<Scalars['Float']>;
  start?: InputMaybe<Scalars['Float']>;
  startColor?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  velocityType?: InputMaybe<Scalars['String']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type TextUpdate = {
  align?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Float']>;
  enableX?: InputMaybe<Scalars['Boolean']>;
  enableY?: InputMaybe<Scalars['Boolean']>;
  fontItalic?: InputMaybe<Scalars['Boolean']>;
  fontSize?: InputMaybe<Scalars['Float']>;
  fontWeight?: InputMaybe<Scalars['String']>;
  lineHeight?: InputMaybe<Scalars['Float']>;
  opacity?: InputMaybe<Scalars['Float']>;
  shadowBlur?: InputMaybe<Scalars['Float']>;
  shadowColor?: InputMaybe<Scalars['String']>;
  shadowOffsetX?: InputMaybe<Scalars['Float']>;
  shadowOffsetY?: InputMaybe<Scalars['Float']>;
  shadowOpacity?: InputMaybe<Scalars['Float']>;
  start?: InputMaybe<Scalars['Float']>;
  startColor?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  velocityType?: InputMaybe<Scalars['String']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type TitleCuePoint = {
  __typename?: 'TitleCuePoint';
  alignment?: Maybe<Scalars['String']>;
  animations?: Maybe<Array<Maybe<GraphicAnimation>>>;
  aspectRatio?: Maybe<Scalars['String']>;
  assetSid?: Maybe<Scalars['String']>;
  assets?: Maybe<Array<Maybe<GraphicAsset>>>;
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundColorIndex?: Maybe<Scalars['Int']>;
  bottom?: Maybe<Scalars['Float']>;
  chapterSid?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorIndex?: Maybe<Scalars['Int']>;
  colors?: Maybe<Array<Maybe<GraphicColor>>>;
  configurationTime?: Maybe<Scalars['Float']>;
  contentVersion?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  credit?: Maybe<Scalars['String']>;
  creditRequired?: Maybe<Scalars['Boolean']>;
  duration?: Maybe<Scalars['Float']>;
  endTime?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  fontItalic?: Maybe<Scalars['Boolean']>;
  fontSize?: Maybe<Scalars['Float']>;
  fontWeight?: Maybe<Scalars['String']>;
  generatingTime?: Maybe<Scalars['Float']>;
  grayscale?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  icons?: Maybe<Array<Maybe<Scalars['String']>>>;
  images?: Maybe<Array<Maybe<Image>>>;
  insertTime?: Maybe<Scalars['Float']>;
  key?: Maybe<Scalars['String']>;
  left?: Maybe<Scalars['Float']>;
  linkSid?: Maybe<Scalars['String']>;
  list?: Maybe<Array<Maybe<TitleCuePoint>>>;
  logoScale?: Maybe<Scalars['Float']>;
  objectType?: Maybe<Scalars['String']>;
  opacity?: Maybe<Scalars['Float']>;
  overlayed?: Maybe<Scalars['Boolean']>;
  right?: Maybe<Scalars['Float']>;
  sequenceSid?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  srcDuration?: Maybe<Scalars['Float']>;
  srcEndTime?: Maybe<Scalars['Int']>;
  srcStartTime?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  svg?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  thumbnailVersion?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  titleType?: Maybe<Scalars['Int']>;
  top?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  videoUrl?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<Maybe<Video>>>;
  width?: Maybe<Scalars['Float']>;
  zIndex?: Maybe<Scalars['Int']>;
};


export type TitleCuePointCountArgs = {
  filter?: InputMaybe<TitleCuePointFilter>;
};


export type TitleCuePointIconsArgs = {
  count?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sequenceSid?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};


export type TitleCuePointImagesArgs = {
  count?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sequenceSid?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};


export type TitleCuePointListArgs = {
  filter?: InputMaybe<TitleCuePointFilter>;
  pager?: InputMaybe<PagerAdd>;
};


export type TitleCuePointVideosArgs = {
  count?: InputMaybe<Scalars['Int']>;
  sequenceSid?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type TitleCuePointActions = {
  __typename?: 'TitleCuePointActions';
  activate?: Maybe<Scalars['Boolean']>;
  add?: Maybe<TitleCuePoint>;
  deactivate?: Maybe<Scalars['Boolean']>;
  remove?: Maybe<Scalars['Boolean']>;
  reoverlay?: Maybe<Scalars['Boolean']>;
  update?: Maybe<TitleCuePoint>;
};


export type TitleCuePointActionsAddArgs = {
  values?: InputMaybe<TitleCuePointAdd>;
};


export type TitleCuePointActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type TitleCuePointActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<TitleCuePointUpdate>;
};

export type TitleCuePointAdd = {
  alignment?: InputMaybe<Scalars['String']>;
  animations?: InputMaybe<Array<InputMaybe<GraphicAnimationAdd>>>;
  assetSid?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<Array<InputMaybe<GraphicAssetAdd>>>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  backgroundColorIndex?: InputMaybe<Scalars['Int']>;
  bottom?: InputMaybe<Scalars['Float']>;
  chapterSid?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  colorIndex?: InputMaybe<Scalars['Int']>;
  colors?: InputMaybe<Array<InputMaybe<GraphicColorAdd>>>;
  credit?: InputMaybe<Scalars['String']>;
  creditRequired?: InputMaybe<Scalars['Boolean']>;
  duration?: InputMaybe<Scalars['Float']>;
  endTime?: InputMaybe<Scalars['Int']>;
  externalId?: InputMaybe<Scalars['String']>;
  fontItalic?: InputMaybe<Scalars['Boolean']>;
  fontSize?: InputMaybe<Scalars['Float']>;
  fontWeight?: InputMaybe<Scalars['String']>;
  grayscale?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  left?: InputMaybe<Scalars['Float']>;
  logoScale?: InputMaybe<Scalars['Float']>;
  opacity?: InputMaybe<Scalars['Float']>;
  right?: InputMaybe<Scalars['Float']>;
  sequenceSid?: InputMaybe<Scalars['String']>;
  srcEndTime?: InputMaybe<Scalars['Int']>;
  srcStartTime?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Int']>;
  svg?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleType?: InputMaybe<Scalars['Int']>;
  top?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
  videoUrl?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
  zIndex?: InputMaybe<Scalars['Int']>;
};

export type TitleCuePointFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  sequenceSidEqual?: InputMaybe<Scalars['String']>;
  sidEqual?: InputMaybe<Scalars['String']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type TitleCuePointUpdate = {
  alignment?: InputMaybe<Scalars['String']>;
  animations?: InputMaybe<Array<InputMaybe<GraphicAnimationUpdate>>>;
  assetSid?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<Array<InputMaybe<GraphicAssetUpdate>>>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  backgroundColorIndex?: InputMaybe<Scalars['Int']>;
  bottom?: InputMaybe<Scalars['Float']>;
  chapterSid?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  colorIndex?: InputMaybe<Scalars['Int']>;
  colors?: InputMaybe<Array<InputMaybe<GraphicColorUpdate>>>;
  credit?: InputMaybe<Scalars['String']>;
  creditRequired?: InputMaybe<Scalars['Boolean']>;
  duration?: InputMaybe<Scalars['Float']>;
  endTime?: InputMaybe<Scalars['Int']>;
  externalId?: InputMaybe<Scalars['String']>;
  fontItalic?: InputMaybe<Scalars['Boolean']>;
  fontSize?: InputMaybe<Scalars['Float']>;
  fontWeight?: InputMaybe<Scalars['String']>;
  grayscale?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  left?: InputMaybe<Scalars['Float']>;
  logoScale?: InputMaybe<Scalars['Float']>;
  opacity?: InputMaybe<Scalars['Float']>;
  right?: InputMaybe<Scalars['Float']>;
  srcEndTime?: InputMaybe<Scalars['Int']>;
  srcStartTime?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Int']>;
  svg?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleType?: InputMaybe<Scalars['Int']>;
  top?: InputMaybe<Scalars['Float']>;
  url?: InputMaybe<Scalars['String']>;
  videoUrl?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
  zIndex?: InputMaybe<Scalars['Int']>;
};

export type Track = {
  __typename?: 'Track';
  count?: Maybe<Scalars['Int']>;
  credit?: Maybe<Scalars['String']>;
  creditRequired?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  insertTime?: Maybe<Scalars['Float']>;
  isSource?: Maybe<Scalars['Boolean']>;
  list?: Maybe<Array<Maybe<Track>>>;
  name?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};


export type TrackCountArgs = {
  filter?: InputMaybe<TrackFilter>;
};


export type TrackListArgs = {
  filter?: InputMaybe<TrackFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type TrackActions = {
  __typename?: 'TrackActions';
  add?: Maybe<Track>;
  remove?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Track>;
};


export type TrackActionsAddArgs = {
  values?: InputMaybe<TrackAdd>;
};


export type TrackActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type TrackActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<TrackUpdate>;
};

export type TrackAdd = {
  credit?: InputMaybe<Scalars['String']>;
  creditRequired?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  isSource?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type TrackFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type TrackUpdate = {
  credit?: InputMaybe<Scalars['String']>;
  creditRequired?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  isSource?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type Transcript = {
  __typename?: 'Transcript';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  footageId: Scalars['String'];
  id: Scalars['ID'];
  lastVersion: Scalars['Float'];
  ownerSid: Scalars['String'];
  ownerType: OwnerType;
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  words?: Maybe<Array<V2_Word>>;
};

export type TranscriptConnection = {
  __typename?: 'TranscriptConnection';
  /** Array of nodes. */
  nodes: Array<Transcript>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type TranscriptDeleteFilter = {
  and?: InputMaybe<Array<TranscriptDeleteFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdBy?: InputMaybe<StringFieldComparison>;
  footageId?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  lastVersion?: InputMaybe<NumberFieldComparison>;
  or?: InputMaybe<Array<TranscriptDeleteFilter>>;
  ownerSid?: InputMaybe<StringFieldComparison>;
  ownerType?: InputMaybe<OwnerTypeFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type TranscriptDeleteResponse = {
  __typename?: 'TranscriptDeleteResponse';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  footageId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lastVersion?: Maybe<Scalars['Float']>;
  ownerSid?: Maybe<Scalars['String']>;
  ownerType?: Maybe<OwnerType>;
  text?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  words?: Maybe<Array<V2_Word>>;
};

export type TranscriptFilter = {
  and?: InputMaybe<Array<TranscriptFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdBy?: InputMaybe<StringFieldComparison>;
  footageId?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  lastVersion?: InputMaybe<NumberFieldComparison>;
  or?: InputMaybe<Array<TranscriptFilter>>;
  ownerSid?: InputMaybe<StringFieldComparison>;
  ownerType?: InputMaybe<OwnerTypeFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type TranscriptInput = {
  footageId: Scalars['String'];
  words: Array<V2_WordInput>;
};

export type TranscriptNonEmbeddedInput = {
  footageId: Scalars['String'];
  lastVersion: Scalars['Float'];
  text?: InputMaybe<Scalars['String']>;
  words?: InputMaybe<Array<V2_WordEmbeddedInput>>;
};

export type TranscriptSort = {
  direction: SortDirection;
  field: TranscriptSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum TranscriptSortFields {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  FootageId = 'footageId',
  Id = 'id',
  LastVersion = 'lastVersion',
  OwnerSid = 'ownerSid',
  OwnerType = 'ownerType',
  UpdatedAt = 'updatedAt'
}

export type TranscriptUpdate = {
  updateType: UpdateType;
  words: Array<V2_WordInput>;
};

export type TranscriptUpdateFilter = {
  and?: InputMaybe<Array<TranscriptUpdateFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdBy?: InputMaybe<StringFieldComparison>;
  footageId?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  lastVersion?: InputMaybe<NumberFieldComparison>;
  or?: InputMaybe<Array<TranscriptUpdateFilter>>;
  ownerSid?: InputMaybe<StringFieldComparison>;
  ownerType?: InputMaybe<OwnerTypeFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type UpdateManyCropDetailsInput = {
  /** Filter used to find fields to update */
  filter: CropDetailUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: CropDetailUpdate;
};

export type UpdateManyDownloadInfosInput = {
  /** Filter used to find fields to update */
  filter: DownloadInfoUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: DownloadInfoUpdate;
};

export type UpdateManyFootagesInput = {
  /** Filter used to find fields to update */
  filter: FootageUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: FootageUpdate;
};

export type UpdateManyResponse = {
  __typename?: 'UpdateManyResponse';
  /** The number of records updated. */
  updatedCount: Scalars['Int'];
};

export type UpdateManyTranscriptsInput = {
  /** Filter used to find fields to update */
  filter: TranscriptUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: TranscriptUpdate;
};

export type UpdateOneBoardInput = {
  /** The id of the record to update */
  id: Scalars['ID'];
  /** The update to apply. */
  update: BoardUpdate;
};

export type UpdateOneCropDetailInput = {
  /** The id of the record to update */
  id: Scalars['ID'];
  /** The update to apply. */
  update: CropDetailUpdate;
};

export type UpdateOneDownloadInfoInput = {
  /** The id of the record to update */
  id: Scalars['ID'];
  /** The update to apply. */
  update: DownloadInfoUpdate;
};

export type UpdateOneFootageInput = {
  /** The id of the record to update */
  id: Scalars['ID'];
  /** The update to apply. */
  update: FootageUpdate;
};

export type UpdateOneTranscriptInput = {
  /** The id of the record to update */
  id: Scalars['ID'];
  /** The update to apply. */
  update: TranscriptUpdate;
};

export enum UpdateType {
  Merge = 'merge',
  Overwrite = 'overwrite'
}

export type User = {
  __typename?: 'User';
  cacheVersion?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  defaultPlanToAssign?: Maybe<Scalars['Int']>;
  department?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fontFamily?: Maybe<Scalars['String']>;
  impersonate?: Maybe<Scalars['String']>;
  insertTime?: Maybe<Scalars['Float']>;
  languageCode?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  list?: Maybe<Array<Maybe<User>>>;
  login?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  onboardingFinished?: Maybe<Scalars['Boolean']>;
  orgIndustry?: Maybe<Scalars['String']>;
  orgName?: Maybe<Scalars['String']>;
  orgNumOfEmpolyees?: Maybe<Scalars['String']>;
  orgSid?: Maybe<Scalars['String']>;
  orgUrl?: Maybe<Scalars['String']>;
  resetToken?: Maybe<Scalars['String']>;
  resetUrl?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['Int']>;
  roleSid?: Maybe<Scalars['String']>;
  setPassword?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  signupCampaign?: Maybe<Scalars['String']>;
  signupCompletionUrl?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  teamTypeSid?: Maybe<Scalars['String']>;
  thumbUrl?: Maybe<Scalars['String']>;
  uiFlags?: Maybe<Scalars['Float']>;
  updateTime?: Maybe<Scalars['Float']>;
  userPurpose?: Maybe<Scalars['String']>;
  userRole?: Maybe<Scalars['String']>;
  verifyLogin?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};


export type UserCountArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type UserListArgs = {
  filter?: InputMaybe<UserFilter>;
  pager?: InputMaybe<PagerAdd>;
};


export type UserLoginArgs = {
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};


export type UserSetPasswordArgs = {
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};


export type UserVerifyLoginArgs = {
  provider?: InputMaybe<Scalars['String']>;
  signupCampaign?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type UserAction = {
  __typename?: 'UserAction';
  count?: Maybe<Scalars['Int']>;
  insertTime?: Maybe<Scalars['Float']>;
  list?: Maybe<Array<Maybe<UserAction>>>;
  objectType?: Maybe<Scalars['String']>;
  orgSid?: Maybe<Scalars['String']>;
  sequenceSid?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  userSid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};


export type UserActionCountArgs = {
  filter?: InputMaybe<UserActionFilter>;
};


export type UserActionListArgs = {
  filter?: InputMaybe<UserActionFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type UserActionActions = {
  __typename?: 'UserActionActions';
  remove?: Maybe<Scalars['Boolean']>;
};


export type UserActionActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};

export type UserActionFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type UserActions = {
  __typename?: 'UserActions';
  add?: Maybe<User>;
  changePassword?: Maybe<Scalars['String']>;
  remove?: Maybe<Scalars['Boolean']>;
  requestResetPassword?: Maybe<Scalars['Boolean']>;
  resetPassword?: Maybe<Scalars['Boolean']>;
  uiFlagOn?: Maybe<Scalars['Int']>;
  update?: Maybe<User>;
};


export type UserActionsAddArgs = {
  values?: InputMaybe<UserAdd>;
};


export type UserActionsChangePasswordArgs = {
  oldPassword?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};


export type UserActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type UserActionsRequestResetPasswordArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type UserActionsUiFlagOnArgs = {
  bit?: InputMaybe<Scalars['Int']>;
};


export type UserActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<UserUpdate>;
};

export type UserAdd = {
  department?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  fontFamily?: InputMaybe<Scalars['String']>;
  languageCode?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  onboardingFinished?: InputMaybe<Scalars['Boolean']>;
  orgIndustry?: InputMaybe<Scalars['String']>;
  orgName?: InputMaybe<Scalars['String']>;
  orgNumOfEmpolyees?: InputMaybe<Scalars['String']>;
  orgSid?: InputMaybe<Scalars['String']>;
  orgUrl?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['Int']>;
  roleSid?: InputMaybe<Scalars['String']>;
  signupCampaign?: InputMaybe<Scalars['String']>;
  teamTypeSid?: InputMaybe<Scalars['String']>;
  uiFlags?: InputMaybe<Scalars['Float']>;
  userPurpose?: InputMaybe<Scalars['String']>;
  userRole?: InputMaybe<Scalars['String']>;
};

export type UserBase = {
  __typename?: 'UserBase';
  count?: Maybe<Scalars['Int']>;
  insertTime?: Maybe<Scalars['Float']>;
  list?: Maybe<Array<Maybe<UserBase>>>;
  objectType?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  uiFlags?: Maybe<Scalars['Float']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};


export type UserBaseCountArgs = {
  filter?: InputMaybe<UserBaseFilter>;
};


export type UserBaseListArgs = {
  filter?: InputMaybe<UserBaseFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type UserBaseActions = {
  __typename?: 'UserBaseActions';
  add?: Maybe<UserBase>;
  remove?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserBase>;
};


export type UserBaseActionsAddArgs = {
  values?: InputMaybe<UserBaseAdd>;
};


export type UserBaseActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type UserBaseActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<UserBaseUpdate>;
};

export type UserBaseAdd = {
  uiFlags?: InputMaybe<Scalars['Float']>;
};

export type UserBaseFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type UserBaseUpdate = {
  uiFlags?: InputMaybe<Scalars['Float']>;
};

export type UserCoupon = {
  __typename?: 'UserCoupon';
  count?: Maybe<Scalars['Int']>;
  couponSid?: Maybe<Scalars['String']>;
  grantingUserSid?: Maybe<Scalars['String']>;
  insertTime?: Maybe<Scalars['Float']>;
  list?: Maybe<Array<Maybe<UserCoupon>>>;
  objectType?: Maybe<Scalars['String']>;
  orgSid?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  userSid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};


export type UserCouponCountArgs = {
  filter?: InputMaybe<UserCouponFilter>;
};


export type UserCouponListArgs = {
  filter?: InputMaybe<UserCouponFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type UserCouponActions = {
  __typename?: 'UserCouponActions';
  add?: Maybe<UserCoupon>;
  remove?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserCoupon>;
};


export type UserCouponActionsAddArgs = {
  values?: InputMaybe<UserCouponAdd>;
};


export type UserCouponActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type UserCouponActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<UserCouponUpdate>;
};

export type UserCouponAdd = {
  couponSid?: InputMaybe<Scalars['String']>;
  grantingUserSid?: InputMaybe<Scalars['String']>;
  orgSid?: InputMaybe<Scalars['String']>;
  userSid?: InputMaybe<Scalars['String']>;
};

export type UserCouponFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type UserCouponUpdate = {
  couponSid?: InputMaybe<Scalars['String']>;
  grantingUserSid?: InputMaybe<Scalars['String']>;
  orgSid?: InputMaybe<Scalars['String']>;
  userSid?: InputMaybe<Scalars['String']>;
};

export type UserFilter = {
  emailEqual?: InputMaybe<Scalars['String']>;
  emailLike?: InputMaybe<Scalars['String']>;
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  orgSidEqual?: InputMaybe<Scalars['String']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type UserUpdate = {
  department?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  fontFamily?: InputMaybe<Scalars['String']>;
  languageCode?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  onboardingFinished?: InputMaybe<Scalars['Boolean']>;
  orgIndustry?: InputMaybe<Scalars['String']>;
  orgName?: InputMaybe<Scalars['String']>;
  orgNumOfEmpolyees?: InputMaybe<Scalars['String']>;
  orgSid?: InputMaybe<Scalars['String']>;
  orgUrl?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['Int']>;
  roleSid?: InputMaybe<Scalars['String']>;
  signupCampaign?: InputMaybe<Scalars['String']>;
  teamTypeSid?: InputMaybe<Scalars['String']>;
  uiFlags?: InputMaybe<Scalars['Float']>;
  userPurpose?: InputMaybe<Scalars['String']>;
  userRole?: InputMaybe<Scalars['String']>;
};

export type V2_Word = {
  __typename?: 'V2_Word';
  alt?: Maybe<Scalars['Boolean']>;
  confidence?: Maybe<Scalars['Float']>;
  endTime: Scalars['Int'];
  highlight?: Maybe<Scalars['Boolean']>;
  startTime: Scalars['Int'];
  version?: Maybe<Scalars['Int']>;
  word: Scalars['String'];
};

export type V2_WordEmbeddedInput = {
  alt?: InputMaybe<Scalars['Boolean']>;
  confidence?: InputMaybe<Scalars['Float']>;
  endTime: Scalars['Int'];
  highlight?: InputMaybe<Scalars['Boolean']>;
  startTime: Scalars['Int'];
  version?: InputMaybe<Scalars['Int']>;
  word: Scalars['String'];
};

export type V2_WordInput = {
  alt?: InputMaybe<Scalars['Boolean']>;
  confidence?: InputMaybe<Scalars['Float']>;
  endTime: Scalars['Int'];
  highlight?: InputMaybe<Scalars['Boolean']>;
  startTime: Scalars['Int'];
  word: Scalars['String'];
};

export type Video = {
  __typename?: 'Video';
  count?: Maybe<Scalars['Int']>;
  credit?: Maybe<Scalars['String']>;
  creditRequired?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  imageUrl?: Maybe<Scalars['String']>;
  insertTime?: Maybe<Scalars['Float']>;
  isSource?: Maybe<Scalars['Boolean']>;
  list?: Maybe<Array<Maybe<Video>>>;
  objectType?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  thumbUrl?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
};


export type VideoCountArgs = {
  filter?: InputMaybe<VideoFilter>;
};


export type VideoListArgs = {
  filter?: InputMaybe<VideoFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type VideoActions = {
  __typename?: 'VideoActions';
  add?: Maybe<Video>;
  remove?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Video>;
};


export type VideoActionsAddArgs = {
  values?: InputMaybe<VideoAdd>;
};


export type VideoActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type VideoActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<VideoUpdate>;
};

export type VideoAdd = {
  credit?: InputMaybe<Scalars['String']>;
  creditRequired?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isSource?: InputMaybe<Scalars['Boolean']>;
  thumbUrl?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type VideoFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type VideoType = {
  __typename?: 'VideoType';
  count?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  editRulesSid?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  insertTime?: Maybe<Scalars['Float']>;
  list?: Maybe<Array<Maybe<VideoType>>>;
  name?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
};


export type VideoTypeCountArgs = {
  filter?: InputMaybe<VideoTypeFilter>;
};


export type VideoTypeListArgs = {
  filter?: InputMaybe<VideoTypeFilter>;
  pager?: InputMaybe<PagerAdd>;
};

export type VideoTypeActions = {
  __typename?: 'VideoTypeActions';
  add?: Maybe<VideoType>;
  disable?: Maybe<Scalars['Boolean']>;
  enable?: Maybe<Scalars['Boolean']>;
  remove?: Maybe<Scalars['Boolean']>;
  setDefault?: Maybe<VideoType>;
  update?: Maybe<VideoType>;
};


export type VideoTypeActionsAddArgs = {
  values?: InputMaybe<VideoTypeAdd>;
};


export type VideoTypeActionsRemoveArgs = {
  sid?: InputMaybe<Scalars['String']>;
};


export type VideoTypeActionsUpdateArgs = {
  sid?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<VideoTypeUpdate>;
};

export type VideoTypeAdd = {
  description?: InputMaybe<Scalars['String']>;
  editRulesSid?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

export type VideoTypeFilter = {
  insertTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  insertTimeLessThan?: InputMaybe<Scalars['Float']>;
  statusEqual?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusNotEqual?: InputMaybe<Scalars['Int']>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updateTimeGreaterThan?: InputMaybe<Scalars['Float']>;
  updateTimeLessThan?: InputMaybe<Scalars['Float']>;
};

export type VideoTypeUpdate = {
  description?: InputMaybe<Scalars['String']>;
  editRulesSid?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

export type VideoUpdate = {
  credit?: InputMaybe<Scalars['String']>;
  creditRequired?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isSource?: InputMaybe<Scalars['Boolean']>;
  thumbUrl?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type Word = {
  __typename?: 'Word';
  alt?: Maybe<Scalars['Boolean']>;
  chapterSid?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorIndex?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['Int']>;
  excluded?: Maybe<Scalars['Boolean']>;
  flags?: Maybe<Scalars['Int']>;
  fontItalic?: Maybe<Scalars['Boolean']>;
  fontSize?: Maybe<Scalars['Float']>;
  fontWeight?: Maybe<Scalars['String']>;
  highlight?: Maybe<Scalars['Boolean']>;
  insertTime?: Maybe<Scalars['Float']>;
  manualTiming?: Maybe<Scalars['Boolean']>;
  newLine?: Maybe<Scalars['Boolean']>;
  objectType?: Maybe<Scalars['String']>;
  positionX?: Maybe<Scalars['Float']>;
  positionY?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  startTime?: Maybe<Scalars['Int']>;
  updateTime?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Int']>;
  word?: Maybe<Scalars['String']>;
};

export type WordActions = {
  __typename?: 'WordActions';
  void?: Maybe<Scalars['Boolean']>;
};

export type WordAdd = {
  alt?: InputMaybe<Scalars['Boolean']>;
  chapterSid?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  colorIndex?: InputMaybe<Scalars['Int']>;
  endTime?: InputMaybe<Scalars['Int']>;
  excluded?: InputMaybe<Scalars['Boolean']>;
  flags?: InputMaybe<Scalars['Int']>;
  fontItalic?: InputMaybe<Scalars['Boolean']>;
  fontSize?: InputMaybe<Scalars['Float']>;
  fontWeight?: InputMaybe<Scalars['String']>;
  highlight?: InputMaybe<Scalars['Boolean']>;
  manualTiming?: InputMaybe<Scalars['Boolean']>;
  newLine?: InputMaybe<Scalars['Boolean']>;
  positionX?: InputMaybe<Scalars['Float']>;
  positionY?: InputMaybe<Scalars['Float']>;
  score?: InputMaybe<Scalars['Float']>;
  startTime?: InputMaybe<Scalars['Int']>;
  word?: InputMaybe<Scalars['String']>;
};

export type WordUpdate = {
  active?: InputMaybe<Scalars['Boolean']>;
  alt?: InputMaybe<Scalars['Boolean']>;
  chapterSid?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  colorIndex?: InputMaybe<Scalars['Int']>;
  endTime?: InputMaybe<Scalars['Int']>;
  excluded?: InputMaybe<Scalars['Boolean']>;
  flags?: InputMaybe<Scalars['Int']>;
  fontItalic?: InputMaybe<Scalars['Boolean']>;
  fontSize?: InputMaybe<Scalars['Float']>;
  fontWeight?: InputMaybe<Scalars['String']>;
  highlight?: InputMaybe<Scalars['Boolean']>;
  index?: InputMaybe<Scalars['Int']>;
  manualTiming?: InputMaybe<Scalars['Boolean']>;
  newLine?: InputMaybe<Scalars['Boolean']>;
  origin?: InputMaybe<Scalars['String']>;
  originEndTime?: InputMaybe<Scalars['Int']>;
  originStartTime?: InputMaybe<Scalars['Int']>;
  positionX?: InputMaybe<Scalars['Float']>;
  positionY?: InputMaybe<Scalars['Float']>;
  score?: InputMaybe<Scalars['Float']>;
  startTime?: InputMaybe<Scalars['Int']>;
  word?: InputMaybe<Scalars['String']>;
};

export type GetAssetsQueryVariables = Exact<{
  filter?: InputMaybe<AssetFilter>;
  pager?: InputMaybe<PagerAdd>;
}>;


export type GetAssetsQuery = { __typename?: 'Query', asset?: { __typename?: 'Asset', list?: Array<{ __typename?: 'Asset', sid?: string | null, objectType?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, folderSid?: string | null, isDefault?: boolean | null, type?: number | null, userSid?: string | null, orgSid?: string | null, creatorSid?: string | null, fileNames?: Array<string | null> | null, languageCode?: string | null, ownerSid?: string | null, parentSid?: string | null, name?: string | null, description?: string | null, systemId?: string | null, genres?: Array<string | null> | null, tags?: Array<string | null> | null, moods?: Array<string | null> | null, size?: number | null, aspectRatio?: string | null, noWords?: boolean | null, errorCause?: string | null, errorCode?: number | null, published?: boolean | null, duration?: number | null, footageSid?: string | null, contentIdentifier?: { __typename?: 'ContentIdentifier', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, thumbnailVersion?: number | null, key?: string | null, aspectRatio?: string | null } | null } | null> | null } | null };

export type GetAssetQueryVariables = Exact<{
  sid?: InputMaybe<Scalars['String']>;
}>;


export type GetAssetQuery = { __typename?: 'Query', asset?: { __typename?: 'Asset', sid?: string | null, objectType?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, folderSid?: string | null, isDefault?: boolean | null, type?: number | null, userSid?: string | null, orgSid?: string | null, creatorSid?: string | null, fileNames?: Array<string | null> | null, languageCode?: string | null, ownerSid?: string | null, parentSid?: string | null, name?: string | null, description?: string | null, systemId?: string | null, genres?: Array<string | null> | null, tags?: Array<string | null> | null, moods?: Array<string | null> | null, size?: number | null, aspectRatio?: string | null, noWords?: boolean | null, errorCause?: string | null, errorCode?: number | null, published?: boolean | null, duration?: number | null, footageSid?: string | null, contentIdentifier?: { __typename?: 'ContentIdentifier', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, thumbnailVersion?: number | null, key?: string | null, aspectRatio?: string | null } | null } | null };

export type CreateAssetMutationVariables = Exact<{
  type: Scalars['Int'];
  name: Scalars['String'];
}>;


export type CreateAssetMutation = { __typename?: 'Mutation', asset?: { __typename?: 'AssetActions', add?: { __typename?: 'Asset', sid?: string | null, objectType?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, folderSid?: string | null, isDefault?: boolean | null, type?: number | null, userSid?: string | null, orgSid?: string | null, creatorSid?: string | null, fileNames?: Array<string | null> | null, languageCode?: string | null, ownerSid?: string | null, parentSid?: string | null, name?: string | null, description?: string | null, systemId?: string | null, genres?: Array<string | null> | null, tags?: Array<string | null> | null, moods?: Array<string | null> | null, size?: number | null, aspectRatio?: string | null, noWords?: boolean | null, errorCause?: string | null, errorCode?: number | null, published?: boolean | null, duration?: number | null, footageSid?: string | null, contentIdentifier?: { __typename?: 'ContentIdentifier', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, thumbnailVersion?: number | null, key?: string | null, aspectRatio?: string | null } | null } | null } | null };

export type UpdateAssetMutationVariables = Exact<{
  sid: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  languageCode?: InputMaybe<Scalars['String']>;
}>;


export type UpdateAssetMutation = { __typename?: 'Mutation', asset?: { __typename?: 'AssetActions', update?: { __typename?: 'Asset', sid?: string | null, objectType?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, folderSid?: string | null, isDefault?: boolean | null, type?: number | null, userSid?: string | null, orgSid?: string | null, creatorSid?: string | null, fileNames?: Array<string | null> | null, languageCode?: string | null, ownerSid?: string | null, parentSid?: string | null, name?: string | null, description?: string | null, systemId?: string | null, genres?: Array<string | null> | null, tags?: Array<string | null> | null, moods?: Array<string | null> | null, size?: number | null, aspectRatio?: string | null, noWords?: boolean | null, errorCause?: string | null, errorCode?: number | null, published?: boolean | null, duration?: number | null, footageSid?: string | null, contentIdentifier?: { __typename?: 'ContentIdentifier', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, thumbnailVersion?: number | null, key?: string | null, aspectRatio?: string | null } | null } | null } | null };

export type FullAssetFragment = { __typename?: 'Asset', sid?: string | null, objectType?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, folderSid?: string | null, isDefault?: boolean | null, type?: number | null, userSid?: string | null, orgSid?: string | null, creatorSid?: string | null, fileNames?: Array<string | null> | null, languageCode?: string | null, ownerSid?: string | null, parentSid?: string | null, name?: string | null, description?: string | null, systemId?: string | null, genres?: Array<string | null> | null, tags?: Array<string | null> | null, moods?: Array<string | null> | null, size?: number | null, aspectRatio?: string | null, noWords?: boolean | null, errorCause?: string | null, errorCode?: number | null, published?: boolean | null, duration?: number | null, footageSid?: string | null, contentIdentifier?: { __typename?: 'ContentIdentifier', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, thumbnailVersion?: number | null, key?: string | null, aspectRatio?: string | null } | null };

export type GetBoardsQueryVariables = Exact<{
  paging: OffsetPaging;
  filter: BoardFilter;
  sorting: Array<BoardSort> | BoardSort;
}>;


export type GetBoardsQuery = { __typename?: 'Query', boards: { __typename?: 'BoardConnection', pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, nodes: Array<{ __typename?: 'Board', id: string, createdAt: any, updatedAt: any, ownerSid: string, ownerType: OwnerType, createdBy: string, name: string, parentBoardIds?: Array<string> | null, footageIds?: Array<string> | null, boardIds?: Array<string> | null }> } };

export type CreateBoardMutationVariables = Exact<{
  input: CreateOneBoardInput;
}>;


export type CreateBoardMutation = { __typename?: 'Mutation', createOneBoard: { __typename?: 'Board', id: string, createdAt: any, updatedAt: any, ownerSid: string, ownerType: OwnerType, createdBy: string, name: string, parentBoardIds?: Array<string> | null, footageIds?: Array<string> | null, boardIds?: Array<string> | null } };

export type UpdateBoardMutationVariables = Exact<{
  input: UpdateOneBoardInput;
}>;


export type UpdateBoardMutation = { __typename?: 'Mutation', updateOneBoard: { __typename?: 'Board', id: string, createdAt: any, updatedAt: any, ownerSid: string, ownerType: OwnerType, createdBy: string, name: string, parentBoardIds?: Array<string> | null, footageIds?: Array<string> | null, boardIds?: Array<string> | null } };

export type DeleteBoardMutationVariables = Exact<{
  input: DeleteOneBoardInput;
}>;


export type DeleteBoardMutation = { __typename?: 'Mutation', deleteOneBoard: { __typename?: 'BoardDeleteResponse', id?: string | null, createdAt?: any | null, updatedAt?: any | null, ownerSid?: string | null, ownerType?: OwnerType | null, createdBy?: string | null, name?: string | null, parentBoardIds?: Array<string> | null, footageIds?: Array<string> | null, boardIds?: Array<string> | null } };

export type MoveFootageToBoardMutationVariables = Exact<{
  footageId: Scalars['String'];
  boardId: Scalars['String'];
}>;


export type MoveFootageToBoardMutation = { __typename?: 'Mutation', moveFootageToBoard: boolean };

export type RemoveFootageFromBoardMutationVariables = Exact<{
  footageId: Scalars['String'];
}>;


export type RemoveFootageFromBoardMutation = { __typename?: 'Mutation', removeFootageFromBoard: boolean };

export type UpdateWordsMutationVariables = Exact<{
  sequenceSid: Scalars['String'];
  words: Array<WordUpdate> | WordUpdate;
}>;


export type UpdateWordsMutation = { __typename?: 'Mutation', closedCaption?: { __typename?: 'ClosedCaptionActions', updateWords?: boolean | null } | null };

export type GetCropDetailsQueryVariables = Exact<{
  externalSequenceSid: Scalars['String'];
  outputAspectRatio: Scalars['String'];
}>;


export type GetCropDetailsQuery = { __typename?: 'Query', cropDetails: { __typename?: 'CropDetailConnection', nodes: Array<{ __typename?: 'CropDetail', externalAssetSid: string, originalAspectRatio: string, outputWidth: number, outputHeight: number, color: string, brandColorIndex?: number | null, blur: boolean, cropData?: Array<{ __typename?: 'CropData', start: number, end: number, crop: { __typename?: 'Crop', width: number, height: number, topx: number, topy: number }, draw: { __typename?: 'Draw', width: number, height: number, topx: number, topy: number } }> | null }> } };

export type UpdateAssetCropDataMutationVariables = Exact<{
  externalSequenceSid: Scalars['String'];
  externalAssetSid: Scalars['String'];
  outputAspectRatio: Scalars['String'];
  cropData: Array<CropDataUpdate> | CropDataUpdate;
}>;


export type UpdateAssetCropDataMutation = { __typename?: 'Mutation', updateAssetCropData: { __typename?: 'CropDetail', originalAspectRatio: string, outputWidth: number, outputHeight: number, color: string, brandColorIndex?: number | null, blur: boolean, cropData?: Array<{ __typename?: 'CropData', start: number, end: number, crop: { __typename?: 'Crop', width: number, height: number, topx: number, topy: number }, draw: { __typename?: 'Draw', width: number, height: number, topx: number, topy: number } }> | null } };

export type UpdateBackgroundDesignMutationVariables = Exact<{
  externalSequenceSid: Scalars['String'];
  color: Scalars['String'];
  brandColorIndex?: InputMaybe<Scalars['Int']>;
  blur: Scalars['Boolean'];
}>;


export type UpdateBackgroundDesignMutation = { __typename?: 'Mutation', updateBackgroundDesign: number };

export type GetBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBalanceQuery = { __typename?: 'Query', getDownloadsBalance: { __typename?: 'DownloadsBalance', periodMaxDownloads: number, periodLeftDownloads?: number | null, periodStartTime: any, periodEndTime: any } };

export type GetDownloadInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDownloadInfoQuery = { __typename?: 'Query', downloadInfo: { __typename?: 'DownloadInfo', id: string, createdAt: any, updatedAt: any, footageId: string, externalSequenceId: string, externalSequenceTitle: string, externalSequenceEndVersion?: number | null, hitCounter: number, status: DownloadStatus } };

export type GetDownloadInfosQueryVariables = Exact<{
  paging: OffsetPaging;
  filter: DownloadInfoFilter;
  sorting: Array<DownloadInfoSort> | DownloadInfoSort;
}>;


export type GetDownloadInfosQuery = { __typename?: 'Query', downloadInfos: { __typename?: 'DownloadInfoConnection', pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, nodes: Array<{ __typename?: 'DownloadInfo', id: string, createdAt: any, updatedAt: any, footageId: string, externalSequenceId: string, externalSequenceTitle: string, externalSequenceEndVersion?: number | null, hitCounter: number, status: DownloadStatus }> } };

export type LeanDownloadInfoFragment = { __typename?: 'DownloadInfo', id: string, createdAt: any, updatedAt: any, footageId: string, externalSequenceId: string, externalSequenceTitle: string, externalSequenceEndVersion?: number | null, hitCounter: number, status: DownloadStatus };

export type GetEditRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEditRulesQuery = { __typename?: 'Query', editRules?: { __typename?: 'EditRules', list?: Array<{ __typename?: 'EditRules', sid?: string | null, objectType?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, name: string, useSpeakers: boolean, useIntro: boolean, useOutro: boolean, useVideos: boolean, useIcons: boolean, useImages: boolean, useTexts: boolean, useSlides: boolean, useLogo: boolean, useMusic: boolean, useHighlight: boolean, useFrame: boolean, volume?: number | null, noContentVolume?: number | null } | null> | null } | null };

export type FullEditRulesFragment = { __typename?: 'EditRules', sid?: string | null, objectType?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, name: string, useSpeakers: boolean, useIntro: boolean, useOutro: boolean, useVideos: boolean, useIcons: boolean, useImages: boolean, useTexts: boolean, useSlides: boolean, useLogo: boolean, useMusic: boolean, useHighlight: boolean, useFrame: boolean, volume?: number | null, noContentVolume?: number | null };

export type GetFolderStructuresQueryVariables = Exact<{
  type: Scalars['Int'];
}>;


export type GetFolderStructuresQuery = { __typename?: 'Query', folderStructure?: { __typename?: 'FolderStructure', list?: Array<{ __typename?: 'FolderStructure', sid?: string | null, objectType?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, userSid?: string | null, type?: number | null, parentSid?: string | null, systemId?: string | null, name?: string | null } | null> | null } | null };

export type GetFootagesQueryVariables = Exact<{
  paging: OffsetPaging;
  filter: FootageFilter;
  sorting: Array<FootageSort> | FootageSort;
}>;


export type GetFootagesQuery = { __typename?: 'Query', footages: { __typename?: 'FootageConnection', pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, nodes: Array<{ __typename?: 'Footage', id: string, status: FootageStatus, filename: string, origin: FootageOrigin, originalFootageId?: string | null, languageCode?: string | null, createdAt: any, youtubeId?: string | null, thumbnail?: { __typename?: 'Content', filePath: string } | null, filesPaths?: { __typename?: 'FilesPaths', previewFootage?: string | null, formattedFootage?: string | null } | null, mediainfo?: { __typename?: 'MediaInfo', duration: number, aspectRatio?: string | null } | null, clips?: Array<{ __typename?: 'Clip', id: string, title: string, type: ClipType, status: ClipStatus, clipFrom: number, duration: number, sequences?: Array<{ __typename?: 'ClipSequence', id: string, title: string, type: ClipSequenceType, status: ClipSequenceStatus, externalSequenceId?: string | null, ratio: string, languageCode: string, favorite?: boolean | null, openedAt?: any | null, editedAt?: any | null, downloadedAt?: any | null }> | null }> | null, automationData?: { __typename?: 'AutomationData', externalPresetSid: string } | null }> } };

export type GetFootagesByBoardIdQueryVariables = Exact<{
  paging: OffsetPaging;
  filter: FootageFilter;
  sorting: Array<FootageSort> | FootageSort;
  boardId: Scalars['String'];
}>;


export type GetFootagesByBoardIdQuery = { __typename?: 'Query', getFootagesByBoardId: { __typename?: 'FootageOffsetConnection', pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, nodes: Array<{ __typename?: 'Footage', id: string, status: FootageStatus, filename: string, origin: FootageOrigin, originalFootageId?: string | null, languageCode?: string | null, createdAt: any, youtubeId?: string | null, thumbnail?: { __typename?: 'Content', filePath: string } | null, filesPaths?: { __typename?: 'FilesPaths', previewFootage?: string | null, formattedFootage?: string | null } | null, mediainfo?: { __typename?: 'MediaInfo', duration: number, aspectRatio?: string | null } | null, clips?: Array<{ __typename?: 'Clip', id: string, title: string, type: ClipType, status: ClipStatus, clipFrom: number, duration: number, sequences?: Array<{ __typename?: 'ClipSequence', id: string, title: string, type: ClipSequenceType, status: ClipSequenceStatus, externalSequenceId?: string | null, ratio: string, languageCode: string, favorite?: boolean | null, openedAt?: any | null, editedAt?: any | null, downloadedAt?: any | null }> | null }> | null, automationData?: { __typename?: 'AutomationData', externalPresetSid: string } | null }> } };

export type GetFootageWithClipSequenceFavoritesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetFootageWithClipSequenceFavoritesQuery = { __typename?: 'Query', footageWithClipSequenceFavorites: { __typename?: 'Footage', id: string, status: FootageStatus, filename: string, origin: FootageOrigin, originalFootageId?: string | null, languageCode?: string | null, createdAt: any, youtubeId?: string | null, thumbnail?: { __typename?: 'Content', filePath: string } | null, filesPaths?: { __typename?: 'FilesPaths', previewFootage?: string | null, formattedFootage?: string | null } | null, mediainfo?: { __typename?: 'MediaInfo', duration: number, aspectRatio?: string | null } | null, clips?: Array<{ __typename?: 'Clip', id: string, title: string, type: ClipType, status: ClipStatus, clipFrom: number, duration: number, sequences?: Array<{ __typename?: 'ClipSequence', id: string, title: string, type: ClipSequenceType, status: ClipSequenceStatus, externalSequenceId?: string | null, ratio: string, languageCode: string, favorite?: boolean | null, openedAt?: any | null, editedAt?: any | null, downloadedAt?: any | null }> | null }> | null, automationData?: { __typename?: 'AutomationData', externalPresetSid: string } | null } };

export type GetFootageTranscriptQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetFootageTranscriptQuery = { __typename?: 'Query', footageWithClipSequenceFavorites: { __typename?: 'Footage', id: string, transcriptRef?: { __typename?: 'Transcript', words?: Array<{ __typename?: 'V2_Word', word: string, startTime: number, endTime: number, confidence?: number | null, alt?: boolean | null, highlight?: boolean | null, version?: number | null }> | null } | null } };

export type CreateFootageMutationVariables = Exact<{
  input: CreateOneFootageInput;
}>;


export type CreateFootageMutation = { __typename?: 'Mutation', createOneFootage: { __typename?: 'Footage', id: string, status: FootageStatus, filename: string, origin: FootageOrigin, originalFootageId?: string | null, languageCode?: string | null, createdAt: any, youtubeId?: string | null, thumbnail?: { __typename?: 'Content', filePath: string } | null, filesPaths?: { __typename?: 'FilesPaths', previewFootage?: string | null, formattedFootage?: string | null } | null, mediainfo?: { __typename?: 'MediaInfo', duration: number, aspectRatio?: string | null } | null, clips?: Array<{ __typename?: 'Clip', id: string, title: string, type: ClipType, status: ClipStatus, clipFrom: number, duration: number, sequences?: Array<{ __typename?: 'ClipSequence', id: string, title: string, type: ClipSequenceType, status: ClipSequenceStatus, externalSequenceId?: string | null, ratio: string, languageCode: string, favorite?: boolean | null, openedAt?: any | null, editedAt?: any | null, downloadedAt?: any | null }> | null }> | null, automationData?: { __typename?: 'AutomationData', externalPresetSid: string } | null } };

export type UpdateFootageMutationVariables = Exact<{
  input: UpdateOneFootageInput;
}>;


export type UpdateFootageMutation = { __typename?: 'Mutation', updateOneFootage: { __typename?: 'Footage', id: string, status: FootageStatus, filename: string, origin: FootageOrigin, originalFootageId?: string | null, languageCode?: string | null, createdAt: any, youtubeId?: string | null, thumbnail?: { __typename?: 'Content', filePath: string } | null, filesPaths?: { __typename?: 'FilesPaths', previewFootage?: string | null, formattedFootage?: string | null } | null, mediainfo?: { __typename?: 'MediaInfo', duration: number, aspectRatio?: string | null } | null, clips?: Array<{ __typename?: 'Clip', id: string, title: string, type: ClipType, status: ClipStatus, clipFrom: number, duration: number, sequences?: Array<{ __typename?: 'ClipSequence', id: string, title: string, type: ClipSequenceType, status: ClipSequenceStatus, externalSequenceId?: string | null, ratio: string, languageCode: string, favorite?: boolean | null, openedAt?: any | null, editedAt?: any | null, downloadedAt?: any | null }> | null }> | null, automationData?: { __typename?: 'AutomationData', externalPresetSid: string } | null } };

export type GenerateFootageUploaderUrlMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type GenerateFootageUploaderUrlMutation = { __typename?: 'Mutation', generateUploadUrl: string };

export type DeleteFootageMutationVariables = Exact<{
  input: DeleteOneFootageInput;
}>;


export type DeleteFootageMutation = { __typename?: 'Mutation', deleteOneFootage: { __typename?: 'Footage', id: string } };

export type UpdateClipSequenceMutationVariables = Exact<{
  footageId: Scalars['String'];
  clipId: Scalars['String'];
  id: Scalars['String'];
  update: ClipSequenceUpdate;
}>;


export type UpdateClipSequenceMutation = { __typename?: 'Mutation', updateClipSequence: { __typename?: 'ClipSequence', id: string, title: string, languageCode: string, type: ClipSequenceType, status: ClipSequenceStatus, externalSequenceId?: string | null, ratio: string, favorite?: boolean | null } };

export type DeleteClipSequenceMutationVariables = Exact<{
  footageId: Scalars['String'];
  clipId: Scalars['String'];
  id: Scalars['String'];
}>;


export type DeleteClipSequenceMutation = { __typename?: 'Mutation', deleteClipSequence: { __typename?: 'ClipSequence', id: string } };

export type CloneClipSequenceMutationVariables = Exact<{
  footageId: Scalars['String'];
  clipId: Scalars['String'];
  id: Scalars['String'];
  input: ClipSequenceCloneInput;
}>;


export type CloneClipSequenceMutation = { __typename?: 'Mutation', cloneClipSequence: { __typename?: 'ClipSequence', id: string } };

export type ReplaceExampleClipSequenceMutationVariables = Exact<{
  footageId: Scalars['String'];
  clipId: Scalars['String'];
  id: Scalars['String'];
}>;


export type ReplaceExampleClipSequenceMutation = { __typename?: 'Mutation', replaceExampleClipSequence: { __typename?: 'ClipSequence', id: string, externalSequenceId?: string | null } };

export type TranslateClipSequenceMutationVariables = Exact<{
  footageId: Scalars['String'];
  clipId: Scalars['String'];
  id: Scalars['String'];
  input: ClipSequenceTranslateInput;
}>;


export type TranslateClipSequenceMutation = { __typename?: 'Mutation', translateClipSequence: { __typename?: 'ClipSequence', id: string } };

export type RenameClipSequenceMutationVariables = Exact<{
  footageId: Scalars['String'];
  clipId: Scalars['String'];
  id: Scalars['String'];
  input: ClipSequenceRenameInput;
}>;


export type RenameClipSequenceMutation = { __typename?: 'Mutation', renameClipSequence: { __typename?: 'ClipSequence', id: string } };

export type AddClipSequenceFavoriteMutationVariables = Exact<{
  footageId: Scalars['String'];
  clipId: Scalars['String'];
  id: Scalars['String'];
}>;


export type AddClipSequenceFavoriteMutation = { __typename?: 'Mutation', addClipSequenceFavorite: { __typename?: 'ClipSequence', id: string, favorite?: boolean | null } };

export type DeleteClipSequenceFavoriteMutationVariables = Exact<{
  footageId: Scalars['String'];
  clipId: Scalars['String'];
  id: Scalars['String'];
}>;


export type DeleteClipSequenceFavoriteMutation = { __typename?: 'Mutation', deleteClipSequenceFavorite: { __typename?: 'ClipSequence', id: string, favorite?: boolean | null } };

export type InteractClipSequenceMutationVariables = Exact<{
  footageId: Scalars['String'];
  externalSequenceId: Scalars['String'];
  sequenceInteraction: SequenceInteraction;
}>;


export type InteractClipSequenceMutation = { __typename?: 'Mutation', interactClipSequence: { __typename?: 'ClipSequence', id: string, title: string, type: ClipSequenceType, status: ClipSequenceStatus, externalSequenceId?: string | null, ratio: string, languageCode: string, favorite?: boolean | null, openedAt?: any | null, editedAt?: any | null, downloadedAt?: any | null } };

export type SplitFootageByUserTimestampsMutationVariables = Exact<{
  input: ClipByTimestampsInput;
}>;


export type SplitFootageByUserTimestampsMutation = { __typename?: 'Mutation', splitFootageByUserTimestamps: number };

export type ClipSequenceFragment = { __typename?: 'ClipSequence', id: string, title: string, type: ClipSequenceType, status: ClipSequenceStatus, externalSequenceId?: string | null, ratio: string, languageCode: string, favorite?: boolean | null, openedAt?: any | null, editedAt?: any | null, downloadedAt?: any | null };

export type LeanFootageFragment = { __typename?: 'Footage', id: string, status: FootageStatus, filename: string, origin: FootageOrigin, originalFootageId?: string | null, languageCode?: string | null, createdAt: any, youtubeId?: string | null, thumbnail?: { __typename?: 'Content', filePath: string } | null, filesPaths?: { __typename?: 'FilesPaths', previewFootage?: string | null, formattedFootage?: string | null } | null, mediainfo?: { __typename?: 'MediaInfo', duration: number, aspectRatio?: string | null } | null, clips?: Array<{ __typename?: 'Clip', id: string, title: string, type: ClipType, status: ClipStatus, clipFrom: number, duration: number, sequences?: Array<{ __typename?: 'ClipSequence', id: string, title: string, type: ClipSequenceType, status: ClipSequenceStatus, externalSequenceId?: string | null, ratio: string, languageCode: string, favorite?: boolean | null, openedAt?: any | null, editedAt?: any | null, downloadedAt?: any | null }> | null }> | null, automationData?: { __typename?: 'AutomationData', externalPresetSid: string } | null };

export type TranscriptFootageFragment = { __typename?: 'Footage', id: string, transcriptRef?: { __typename?: 'Transcript', words?: Array<{ __typename?: 'V2_Word', word: string, startTime: number, endTime: number, confidence?: number | null, alt?: boolean | null, highlight?: boolean | null, version?: number | null }> | null } | null };

export type GetPlansQueryVariables = Exact<{
  filter?: InputMaybe<PlanFilter>;
}>;


export type GetPlansQuery = { __typename?: 'Query', plan?: { __typename?: 'Plan', list?: Array<{ __typename?: 'Plan', sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, name?: string | null, recurringPrice?: number | null, overrideRecurringPrice?: number | null, annualRecurringPrice?: number | null, annualOverrideRecurringPrice?: number | null, description?: string | null, freeTrial?: number | null, maxVideoDuration?: number | null, maxVideos?: number | null, maxUsers?: number | null, maxStorage?: number | null, brandsCount?: number | null, icon?: string | null, hidden?: boolean | null, features?: Array<string | null> | null, salesOnly?: boolean | null, buttonColor?: string | null, provider?: number | null, planId?: number | null, annualPlanId?: number | null, showShutterStockBadge?: boolean | null, promptTag?: string | null, annualDiscountPercentage?: number | null, annualDiscountPrice?: number | null, tier?: number | null, buttonAditionalColor?: string | null, pricePerSeatMonthly?: number | null, pricePerSeatAnnually?: number | null, subHeader?: string | null, maxFootageUploads?: number | null, maxFootageUploadMinutesDuration?: number | null, allowedTierFeatures?: Array<string | null> | null, disallowedTierFeatures?: Array<string | null> | null } | null> | null } | null };

export type GetPlanQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlanQuery = { __typename?: 'Query', plan?: { __typename?: 'Plan', sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, name?: string | null, recurringPrice?: number | null, overrideRecurringPrice?: number | null, annualRecurringPrice?: number | null, annualOverrideRecurringPrice?: number | null, description?: string | null, freeTrial?: number | null, maxVideoDuration?: number | null, maxVideos?: number | null, maxUsers?: number | null, maxStorage?: number | null, brandsCount?: number | null, icon?: string | null, hidden?: boolean | null, features?: Array<string | null> | null, salesOnly?: boolean | null, buttonColor?: string | null, provider?: number | null, planId?: number | null, annualPlanId?: number | null, showShutterStockBadge?: boolean | null, promptTag?: string | null, annualDiscountPercentage?: number | null, annualDiscountPrice?: number | null, tier?: number | null, buttonAditionalColor?: string | null, pricePerSeatMonthly?: number | null, pricePerSeatAnnually?: number | null, subHeader?: string | null, maxFootageUploads?: number | null, maxFootageUploadMinutesDuration?: number | null, allowedTierFeatures?: Array<string | null> | null, disallowedTierFeatures?: Array<string | null> | null } | null };

export type SelectPlanMutationVariables = Exact<{
  planSid: Scalars['String'];
  chargeType: Scalars['Int'];
}>;


export type SelectPlanMutation = { __typename?: 'Mutation', plan?: { __typename?: 'PlanActions', select?: { __typename?: 'Subscription', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, subscriptionId?: number | null, userSid?: string | null, orgSid?: string | null, nextChargeTime?: number | null, planSid?: string | null, recurringPrice?: number | null, chargeType?: number | null, couponSid?: string | null, taxId?: string | null, billingAddress?: string | null, billingEmail?: string | null, billingName?: string | null, monthlyPeriodStart?: number | null, lastActivationDate?: number | null, isCanceled?: boolean | null, freeTrialRemainingTime?: number | null, footageUploadsCount?: number | null } | null } | null };

export type FullPlanFragment = { __typename?: 'Plan', sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, name?: string | null, recurringPrice?: number | null, overrideRecurringPrice?: number | null, annualRecurringPrice?: number | null, annualOverrideRecurringPrice?: number | null, description?: string | null, freeTrial?: number | null, maxVideoDuration?: number | null, maxVideos?: number | null, maxUsers?: number | null, maxStorage?: number | null, brandsCount?: number | null, icon?: string | null, hidden?: boolean | null, features?: Array<string | null> | null, salesOnly?: boolean | null, buttonColor?: string | null, provider?: number | null, planId?: number | null, annualPlanId?: number | null, showShutterStockBadge?: boolean | null, promptTag?: string | null, annualDiscountPercentage?: number | null, annualDiscountPrice?: number | null, tier?: number | null, buttonAditionalColor?: string | null, pricePerSeatMonthly?: number | null, pricePerSeatAnnually?: number | null, subHeader?: string | null, maxFootageUploads?: number | null, maxFootageUploadMinutesDuration?: number | null, allowedTierFeatures?: Array<string | null> | null, disallowedTierFeatures?: Array<string | null> | null };

export type GetPresetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPresetsQuery = { __typename?: 'Query', preset?: { __typename?: 'Preset', list?: Array<{ __typename?: 'Preset', sid?: string | null, objectType?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, userSid?: string | null, name?: string | null, fontFamily?: string | null, headerFontFamily?: string | null, headerBoldVariant?: string | null, headerRegularVariant?: string | null, bodyBoldVariant?: string | null, bodyRegularVariant?: string | null, defaultVisualPackage?: string | null, defaultVideoType?: string | null, exampleAsset?: boolean | null, assets?: Array<{ __typename?: 'AssetUsage', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, assetSid?: string | null, type?: number | null, usageType?: number | null, fileNames?: Array<string | null> | null, regularFileName?: string | null, boldFileName?: string | null, isDefault?: boolean | null } | null> | null, colors?: Array<{ __typename?: 'Color', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, color?: string | null, rgb?: Array<number | null> | null, brightness?: number | null, brightnessIndex?: number | null, dominancy?: number | null, grayness?: number | null, percent?: number | null } | null> | null, secondaryColors?: Array<{ __typename?: 'Color', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, color?: string | null, rgb?: Array<number | null> | null, brightness?: number | null, brightnessIndex?: number | null, dominancy?: number | null, grayness?: number | null, percent?: number | null } | null> | null, editRules?: { __typename?: 'EditRules', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, name: string, useSpeakers: boolean, useIntro: boolean, useOutro: boolean, useVideos: boolean, useIcons: boolean, useImages: boolean, useTexts: boolean, useSlides: boolean, useLogo: boolean, useMusic: boolean, useHighlight: boolean, useFrame: boolean, volume?: number | null, noContentVolume?: number | null } | null } | null> | null } | null };

export type CreatePresetMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<Array<AssetUsageAdd> | AssetUsageAdd>;
  colors?: InputMaybe<Array<ColorAdd> | ColorAdd>;
  defaultVisualPackage?: InputMaybe<Scalars['String']>;
  exampleAsset?: InputMaybe<Scalars['Boolean']>;
  headerFontFamily?: InputMaybe<Scalars['String']>;
  headerBoldVariant?: InputMaybe<Scalars['String']>;
  headerRegularVariant?: InputMaybe<Scalars['String']>;
  defaultVideoType?: InputMaybe<Scalars['String']>;
  editRules?: InputMaybe<EditRulesAdd>;
}>;


export type CreatePresetMutation = { __typename?: 'Mutation', preset?: { __typename?: 'PresetActions', add?: { __typename?: 'Preset', sid?: string | null, objectType?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, userSid?: string | null, name?: string | null, fontFamily?: string | null, headerFontFamily?: string | null, headerBoldVariant?: string | null, headerRegularVariant?: string | null, bodyBoldVariant?: string | null, bodyRegularVariant?: string | null, defaultVisualPackage?: string | null, defaultVideoType?: string | null, exampleAsset?: boolean | null, assets?: Array<{ __typename?: 'AssetUsage', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, assetSid?: string | null, type?: number | null, usageType?: number | null, fileNames?: Array<string | null> | null, regularFileName?: string | null, boldFileName?: string | null, isDefault?: boolean | null } | null> | null, colors?: Array<{ __typename?: 'Color', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, color?: string | null, rgb?: Array<number | null> | null, brightness?: number | null, brightnessIndex?: number | null, dominancy?: number | null, grayness?: number | null, percent?: number | null } | null> | null, secondaryColors?: Array<{ __typename?: 'Color', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, color?: string | null, rgb?: Array<number | null> | null, brightness?: number | null, brightnessIndex?: number | null, dominancy?: number | null, grayness?: number | null, percent?: number | null } | null> | null, editRules?: { __typename?: 'EditRules', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, name: string, useSpeakers: boolean, useIntro: boolean, useOutro: boolean, useVideos: boolean, useIcons: boolean, useImages: boolean, useTexts: boolean, useSlides: boolean, useLogo: boolean, useMusic: boolean, useHighlight: boolean, useFrame: boolean, volume?: number | null, noContentVolume?: number | null } | null } | null } | null };

export type UpdatePresetMutationVariables = Exact<{
  sid: Scalars['String'];
  values?: InputMaybe<PresetUpdate>;
}>;


export type UpdatePresetMutation = { __typename?: 'Mutation', preset?: { __typename?: 'PresetActions', update?: { __typename?: 'Preset', sid?: string | null, objectType?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, userSid?: string | null, name?: string | null, fontFamily?: string | null, headerFontFamily?: string | null, headerBoldVariant?: string | null, headerRegularVariant?: string | null, bodyBoldVariant?: string | null, bodyRegularVariant?: string | null, defaultVisualPackage?: string | null, defaultVideoType?: string | null, exampleAsset?: boolean | null, assets?: Array<{ __typename?: 'AssetUsage', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, assetSid?: string | null, type?: number | null, usageType?: number | null, fileNames?: Array<string | null> | null, regularFileName?: string | null, boldFileName?: string | null, isDefault?: boolean | null } | null> | null, colors?: Array<{ __typename?: 'Color', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, color?: string | null, rgb?: Array<number | null> | null, brightness?: number | null, brightnessIndex?: number | null, dominancy?: number | null, grayness?: number | null, percent?: number | null } | null> | null, secondaryColors?: Array<{ __typename?: 'Color', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, color?: string | null, rgb?: Array<number | null> | null, brightness?: number | null, brightnessIndex?: number | null, dominancy?: number | null, grayness?: number | null, percent?: number | null } | null> | null, editRules?: { __typename?: 'EditRules', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, name: string, useSpeakers: boolean, useIntro: boolean, useOutro: boolean, useVideos: boolean, useIcons: boolean, useImages: boolean, useTexts: boolean, useSlides: boolean, useLogo: boolean, useMusic: boolean, useHighlight: boolean, useFrame: boolean, volume?: number | null, noContentVolume?: number | null } | null } | null } | null };

export type DeletePresetMutationVariables = Exact<{
  sid: Scalars['String'];
}>;


export type DeletePresetMutation = { __typename?: 'Mutation', preset?: { __typename?: 'PresetActions', remove?: boolean | null } | null };

export type SetDefaultPresetMutationVariables = Exact<{
  sid: Scalars['String'];
}>;


export type SetDefaultPresetMutation = { __typename?: 'Mutation', preset?: { __typename?: 'PresetActions', setDefault?: { __typename?: 'Preset', sid?: string | null, objectType?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, userSid?: string | null, name?: string | null, fontFamily?: string | null, headerFontFamily?: string | null, headerBoldVariant?: string | null, headerRegularVariant?: string | null, bodyBoldVariant?: string | null, bodyRegularVariant?: string | null, defaultVisualPackage?: string | null, defaultVideoType?: string | null, exampleAsset?: boolean | null, assets?: Array<{ __typename?: 'AssetUsage', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, assetSid?: string | null, type?: number | null, usageType?: number | null, fileNames?: Array<string | null> | null, regularFileName?: string | null, boldFileName?: string | null, isDefault?: boolean | null } | null> | null, colors?: Array<{ __typename?: 'Color', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, color?: string | null, rgb?: Array<number | null> | null, brightness?: number | null, brightnessIndex?: number | null, dominancy?: number | null, grayness?: number | null, percent?: number | null } | null> | null, secondaryColors?: Array<{ __typename?: 'Color', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, color?: string | null, rgb?: Array<number | null> | null, brightness?: number | null, brightnessIndex?: number | null, dominancy?: number | null, grayness?: number | null, percent?: number | null } | null> | null, editRules?: { __typename?: 'EditRules', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, name: string, useSpeakers: boolean, useIntro: boolean, useOutro: boolean, useVideos: boolean, useIcons: boolean, useImages: boolean, useTexts: boolean, useSlides: boolean, useLogo: boolean, useMusic: boolean, useHighlight: boolean, useFrame: boolean, volume?: number | null, noContentVolume?: number | null } | null } | null } | null };

export type FullPresetFragment = { __typename?: 'Preset', sid?: string | null, objectType?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, userSid?: string | null, name?: string | null, fontFamily?: string | null, headerFontFamily?: string | null, headerBoldVariant?: string | null, headerRegularVariant?: string | null, bodyBoldVariant?: string | null, bodyRegularVariant?: string | null, defaultVisualPackage?: string | null, defaultVideoType?: string | null, exampleAsset?: boolean | null, assets?: Array<{ __typename?: 'AssetUsage', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, assetSid?: string | null, type?: number | null, usageType?: number | null, fileNames?: Array<string | null> | null, regularFileName?: string | null, boldFileName?: string | null, isDefault?: boolean | null } | null> | null, colors?: Array<{ __typename?: 'Color', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, color?: string | null, rgb?: Array<number | null> | null, brightness?: number | null, brightnessIndex?: number | null, dominancy?: number | null, grayness?: number | null, percent?: number | null } | null> | null, secondaryColors?: Array<{ __typename?: 'Color', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, color?: string | null, rgb?: Array<number | null> | null, brightness?: number | null, brightnessIndex?: number | null, dominancy?: number | null, grayness?: number | null, percent?: number | null } | null> | null, editRules?: { __typename?: 'EditRules', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, name: string, useSpeakers: boolean, useIntro: boolean, useOutro: boolean, useVideos: boolean, useIcons: boolean, useImages: boolean, useTexts: boolean, useSlides: boolean, useLogo: boolean, useMusic: boolean, useHighlight: boolean, useFrame: boolean, volume?: number | null, noContentVolume?: number | null } | null };

export type GetSequencesQueryVariables = Exact<{
  filter: SequenceFilter;
  pager: PagerAdd;
}>;


export type GetSequencesQuery = { __typename?: 'Query', sequence?: { __typename?: 'Sequence', list?: Array<{ __typename?: 'Sequence', sid?: string | null, title?: string | null, duration?: number | null, languageCode?: string | null, useV2ClosedCaptions?: boolean | null, footageSid?: string | null, chapters?: Array<{ __typename?: 'Chapter', sid?: string | null, status?: number | null, contentVersion?: number | null, thumbnailVersion?: number | null, cuePointType?: number | null, assetSid?: string | null } | null> | null } | null> | null } | null };

export type GetSequenceQueryVariables = Exact<{
  sequenceSid: Scalars['String'];
}>;


export type GetSequenceQuery = { __typename?: 'Query', sequence?: { __typename?: 'Sequence', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, useFootageForCrop?: boolean | null, transcripted?: number | null, highlighted?: number | null, validated?: number | null, masked?: number | null, presetSid?: string | null, userSid?: string | null, width?: number | null, height?: number | null, aspectRatio?: string | null, altAspectRatios?: Array<string | null> | null, languageCode?: string | null, title?: string | null, useGreenScreen?: boolean | null, useDenoised?: boolean | null, useCaptions?: boolean | null, useV2ClosedCaptions?: boolean | null, captionsBackgroundOpacity?: number | null, useTitleCuePoints?: boolean | null, burnCaptions?: boolean | null, editRulesSid?: string | null, folderSid?: string | null, generatedType?: string | null, footageSid?: string | null, errorCause?: string | null, errorCode?: number | null, duration?: number | null, role?: number | null, accessesCount?: number | null, audioGenerated?: boolean | null, editRules?: { __typename?: 'EditRules', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, name: string, useSpeakers: boolean, useIntro: boolean, useOutro: boolean, useVideos: boolean, useIcons: boolean, useImages: boolean, useTexts: boolean, useSlides: boolean, useLogo: boolean, useMusic: boolean, useHighlight: boolean, useFrame: boolean, volume?: number | null, noContentVolume?: number | null } | null, logo?: { __typename?: 'Logo', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, name?: string | null, srcWidth?: number | null, srcHeight?: number | null, size?: number | null, top?: number | null, bottom?: number | null, left?: number | null, right?: number | null, removeWhiteBackground?: boolean | null, crop?: boolean | null, opacity?: number | null } | null, chapters?: Array<{ __typename?: 'Chapter', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, title?: string | null, cid?: string | null, index?: number | null, keyFramed?: boolean | null, formated?: boolean | null, transcripted?: boolean | null, highlighted?: boolean | null, faceDetected?: boolean | null, noiseReducted?: boolean | null, resized?: boolean | null, fitted?: boolean | null, verified?: boolean | null, masked?: boolean | null, offset?: number | null, externalVendor?: string | null, externalId?: string | null, mute?: boolean | null, disabled?: boolean | null, greenScreenColor?: Array<number | null> | null, clipFrom?: number | null, cuePointSid?: string | null, cuePointType?: number | null, image?: boolean | null, detections?: Array<{ __typename?: 'Detection', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, start?: number | null, end?: number | null, xCenterPercentage?: number | null, yCenterPercentage?: number | null } | null> | null, resize?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, fit?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, maskPreview?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null } | null> | null, colors?: Array<{ __typename?: 'Color', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, color?: string | null, rgb?: Array<number | null> | null, brightness?: number | null, brightnessIndex?: number | null, dominancy?: number | null, grayness?: number | null, percent?: number | null } | null> | null, style?: { __typename?: 'Style', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, fontAssetSid?: string | null, captionsFontAssetSid?: string | null, introLogoAssetSid?: string | null, outroLogoAssetSid?: string | null, captionsRegularFileName?: string | null, captionsFontFamily?: string | null, textAssetSid?: string | null, slideAssetSid?: string | null, speakerAssetSid?: string | null, introAssetSid?: string | null, outroAssetSid?: string | null, transitionAssetSid?: string | null, frameAssetSid?: string | null, visualPackageSid?: string | null, backgroundOpacity?: number | null, fontSize?: number | null, fontWeight?: string | null, fontItalic?: boolean | null, fontFamily?: string | null, padding?: Array<number | null> | null, outlineWidth?: number | null, outlineStyle?: string | null, borderWidth?: number | null, borderStyle?: string | null, backgroundColor?: string | null, outlineColor?: string | null, borderColor?: string | null, foregroundColor?: string | null, imagesStyleName?: string | null, headerFontFamily?: string | null, headerFontAssetSid?: string | null, headerBoldFileName?: string | null, headerRegularFileName?: string | null, bodyBoldFileName?: string | null, bodyRegularFileName?: string | null, captionsVerticalAlign?: number | null, captionsStyleType?: number | null, captionsFontColor?: string | null, captionsFontColorIndex?: number | null, captionsStyleColor?: string | null, captionsStyleColorIndex?: number | null, captionsPosition?: number | null, depth?: number | null, layers?: number | null, perspective?: number | null, fade?: boolean | null, direction?: string | null, depthColor?: string | null, highlightColorIndex?: number | null, framePositionX?: number | null, framePositionY?: number | null, frameWidth?: number | null } | null, music?: { __typename?: 'Music', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, description?: string | null, externalId?: string | null, credit?: string | null, creditRequired?: boolean | null, enabled?: boolean | null, downloadDate?: number | null, volume?: number | null, noContentVolume?: number | null, overrideVolume?: boolean | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, video?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, output?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, backgroundJobs?: Array<{ __typename?: 'BackgroundJob', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, startTime?: number | null, type?: string | null, subType?: string | null, audioSid?: string | null } | null> | null, scenes?: Array<{ __typename?: 'Chapter', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, title?: string | null, cid?: string | null, index?: number | null, keyFramed?: boolean | null, formated?: boolean | null, transcripted?: boolean | null, highlighted?: boolean | null, faceDetected?: boolean | null, noiseReducted?: boolean | null, resized?: boolean | null, fitted?: boolean | null, verified?: boolean | null, masked?: boolean | null, offset?: number | null, externalVendor?: string | null, externalId?: string | null, mute?: boolean | null, disabled?: boolean | null, greenScreenColor?: Array<number | null> | null, clipFrom?: number | null, cuePointSid?: string | null, cuePointType?: number | null, image?: boolean | null, detections?: Array<{ __typename?: 'Detection', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, start?: number | null, end?: number | null, xCenterPercentage?: number | null, yCenterPercentage?: number | null } | null> | null, resize?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, fit?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, maskPreview?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null } | null> | null } | null };

export type GetSequencesByFootageIdQueryVariables = Exact<{
  footageId?: InputMaybe<Scalars['String']>;
}>;


export type GetSequencesByFootageIdQuery = { __typename?: 'Query', sequence?: { __typename?: 'Sequence', list?: Array<{ __typename?: 'Sequence', sid?: string | null, title?: string | null, duration?: number | null, languageCode?: string | null, useV2ClosedCaptions?: boolean | null, footageSid?: string | null, chapters?: Array<{ __typename?: 'Chapter', sid?: string | null, status?: number | null, contentVersion?: number | null, thumbnailVersion?: number | null, cuePointType?: number | null, assetSid?: string | null } | null> | null } | null> | null } | null };

export type GetSequenceProcessingStatusPropsQueryVariables = Exact<{
  sequenceSid: Scalars['String'];
}>;


export type GetSequenceProcessingStatusPropsQuery = { __typename?: 'Query', sequence?: { __typename?: 'Sequence', sid?: string | null, status?: number | null, chapters?: Array<{ __typename?: 'Chapter', cuePointType?: number | null, faceDetected?: boolean | null } | null> | null, editRules?: { __typename?: 'EditRules', useSpeakers: boolean } | null } | null };

export type CreateSequenceMutationVariables = Exact<{
  values: SequenceAdd;
}>;


export type CreateSequenceMutation = { __typename?: 'Mutation', sequence?: { __typename?: 'SequenceActions', add?: { __typename?: 'Sequence', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, useFootageForCrop?: boolean | null, transcripted?: number | null, highlighted?: number | null, validated?: number | null, masked?: number | null, presetSid?: string | null, userSid?: string | null, width?: number | null, height?: number | null, aspectRatio?: string | null, altAspectRatios?: Array<string | null> | null, languageCode?: string | null, title?: string | null, useGreenScreen?: boolean | null, useDenoised?: boolean | null, useCaptions?: boolean | null, useV2ClosedCaptions?: boolean | null, captionsBackgroundOpacity?: number | null, useTitleCuePoints?: boolean | null, burnCaptions?: boolean | null, editRulesSid?: string | null, folderSid?: string | null, generatedType?: string | null, footageSid?: string | null, errorCause?: string | null, errorCode?: number | null, duration?: number | null, role?: number | null, accessesCount?: number | null, audioGenerated?: boolean | null, editRules?: { __typename?: 'EditRules', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, name: string, useSpeakers: boolean, useIntro: boolean, useOutro: boolean, useVideos: boolean, useIcons: boolean, useImages: boolean, useTexts: boolean, useSlides: boolean, useLogo: boolean, useMusic: boolean, useHighlight: boolean, useFrame: boolean, volume?: number | null, noContentVolume?: number | null } | null, logo?: { __typename?: 'Logo', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, name?: string | null, srcWidth?: number | null, srcHeight?: number | null, size?: number | null, top?: number | null, bottom?: number | null, left?: number | null, right?: number | null, removeWhiteBackground?: boolean | null, crop?: boolean | null, opacity?: number | null } | null, chapters?: Array<{ __typename?: 'Chapter', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, title?: string | null, cid?: string | null, index?: number | null, keyFramed?: boolean | null, formated?: boolean | null, transcripted?: boolean | null, highlighted?: boolean | null, faceDetected?: boolean | null, noiseReducted?: boolean | null, resized?: boolean | null, fitted?: boolean | null, verified?: boolean | null, masked?: boolean | null, offset?: number | null, externalVendor?: string | null, externalId?: string | null, mute?: boolean | null, disabled?: boolean | null, greenScreenColor?: Array<number | null> | null, clipFrom?: number | null, cuePointSid?: string | null, cuePointType?: number | null, image?: boolean | null, detections?: Array<{ __typename?: 'Detection', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, start?: number | null, end?: number | null, xCenterPercentage?: number | null, yCenterPercentage?: number | null } | null> | null, resize?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, fit?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, maskPreview?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null } | null> | null, colors?: Array<{ __typename?: 'Color', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, color?: string | null, rgb?: Array<number | null> | null, brightness?: number | null, brightnessIndex?: number | null, dominancy?: number | null, grayness?: number | null, percent?: number | null } | null> | null, style?: { __typename?: 'Style', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, fontAssetSid?: string | null, captionsFontAssetSid?: string | null, introLogoAssetSid?: string | null, outroLogoAssetSid?: string | null, captionsRegularFileName?: string | null, captionsFontFamily?: string | null, textAssetSid?: string | null, slideAssetSid?: string | null, speakerAssetSid?: string | null, introAssetSid?: string | null, outroAssetSid?: string | null, transitionAssetSid?: string | null, frameAssetSid?: string | null, visualPackageSid?: string | null, backgroundOpacity?: number | null, fontSize?: number | null, fontWeight?: string | null, fontItalic?: boolean | null, fontFamily?: string | null, padding?: Array<number | null> | null, outlineWidth?: number | null, outlineStyle?: string | null, borderWidth?: number | null, borderStyle?: string | null, backgroundColor?: string | null, outlineColor?: string | null, borderColor?: string | null, foregroundColor?: string | null, imagesStyleName?: string | null, headerFontFamily?: string | null, headerFontAssetSid?: string | null, headerBoldFileName?: string | null, headerRegularFileName?: string | null, bodyBoldFileName?: string | null, bodyRegularFileName?: string | null, captionsVerticalAlign?: number | null, captionsStyleType?: number | null, captionsFontColor?: string | null, captionsFontColorIndex?: number | null, captionsStyleColor?: string | null, captionsStyleColorIndex?: number | null, captionsPosition?: number | null, depth?: number | null, layers?: number | null, perspective?: number | null, fade?: boolean | null, direction?: string | null, depthColor?: string | null, highlightColorIndex?: number | null, framePositionX?: number | null, framePositionY?: number | null, frameWidth?: number | null } | null, music?: { __typename?: 'Music', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, description?: string | null, externalId?: string | null, credit?: string | null, creditRequired?: boolean | null, enabled?: boolean | null, downloadDate?: number | null, volume?: number | null, noContentVolume?: number | null, overrideVolume?: boolean | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, video?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, output?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, backgroundJobs?: Array<{ __typename?: 'BackgroundJob', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, startTime?: number | null, type?: string | null, subType?: string | null, audioSid?: string | null } | null> | null, scenes?: Array<{ __typename?: 'Chapter', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, title?: string | null, cid?: string | null, index?: number | null, keyFramed?: boolean | null, formated?: boolean | null, transcripted?: boolean | null, highlighted?: boolean | null, faceDetected?: boolean | null, noiseReducted?: boolean | null, resized?: boolean | null, fitted?: boolean | null, verified?: boolean | null, masked?: boolean | null, offset?: number | null, externalVendor?: string | null, externalId?: string | null, mute?: boolean | null, disabled?: boolean | null, greenScreenColor?: Array<number | null> | null, clipFrom?: number | null, cuePointSid?: string | null, cuePointType?: number | null, image?: boolean | null, detections?: Array<{ __typename?: 'Detection', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, start?: number | null, end?: number | null, xCenterPercentage?: number | null, yCenterPercentage?: number | null } | null> | null, resize?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, fit?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, maskPreview?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null } | null> | null } | null } | null };

export type UpdateSequenceMutationVariables = Exact<{
  sid: Scalars['String'];
  values: SequenceUpdate;
}>;


export type UpdateSequenceMutation = { __typename?: 'Mutation', sequence?: { __typename?: 'SequenceActions', update?: { __typename?: 'Sequence', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, useFootageForCrop?: boolean | null, transcripted?: number | null, highlighted?: number | null, validated?: number | null, masked?: number | null, presetSid?: string | null, userSid?: string | null, width?: number | null, height?: number | null, aspectRatio?: string | null, altAspectRatios?: Array<string | null> | null, languageCode?: string | null, title?: string | null, useGreenScreen?: boolean | null, useDenoised?: boolean | null, useCaptions?: boolean | null, useV2ClosedCaptions?: boolean | null, captionsBackgroundOpacity?: number | null, useTitleCuePoints?: boolean | null, burnCaptions?: boolean | null, editRulesSid?: string | null, folderSid?: string | null, generatedType?: string | null, footageSid?: string | null, errorCause?: string | null, errorCode?: number | null, duration?: number | null, role?: number | null, accessesCount?: number | null, audioGenerated?: boolean | null, editRules?: { __typename?: 'EditRules', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, name: string, useSpeakers: boolean, useIntro: boolean, useOutro: boolean, useVideos: boolean, useIcons: boolean, useImages: boolean, useTexts: boolean, useSlides: boolean, useLogo: boolean, useMusic: boolean, useHighlight: boolean, useFrame: boolean, volume?: number | null, noContentVolume?: number | null } | null, logo?: { __typename?: 'Logo', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, name?: string | null, srcWidth?: number | null, srcHeight?: number | null, size?: number | null, top?: number | null, bottom?: number | null, left?: number | null, right?: number | null, removeWhiteBackground?: boolean | null, crop?: boolean | null, opacity?: number | null } | null, chapters?: Array<{ __typename?: 'Chapter', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, title?: string | null, cid?: string | null, index?: number | null, keyFramed?: boolean | null, formated?: boolean | null, transcripted?: boolean | null, highlighted?: boolean | null, faceDetected?: boolean | null, noiseReducted?: boolean | null, resized?: boolean | null, fitted?: boolean | null, verified?: boolean | null, masked?: boolean | null, offset?: number | null, externalVendor?: string | null, externalId?: string | null, mute?: boolean | null, disabled?: boolean | null, greenScreenColor?: Array<number | null> | null, clipFrom?: number | null, cuePointSid?: string | null, cuePointType?: number | null, image?: boolean | null, detections?: Array<{ __typename?: 'Detection', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, start?: number | null, end?: number | null, xCenterPercentage?: number | null, yCenterPercentage?: number | null } | null> | null, resize?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, fit?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, maskPreview?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null } | null> | null, colors?: Array<{ __typename?: 'Color', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, color?: string | null, rgb?: Array<number | null> | null, brightness?: number | null, brightnessIndex?: number | null, dominancy?: number | null, grayness?: number | null, percent?: number | null } | null> | null, style?: { __typename?: 'Style', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, fontAssetSid?: string | null, captionsFontAssetSid?: string | null, introLogoAssetSid?: string | null, outroLogoAssetSid?: string | null, captionsRegularFileName?: string | null, captionsFontFamily?: string | null, textAssetSid?: string | null, slideAssetSid?: string | null, speakerAssetSid?: string | null, introAssetSid?: string | null, outroAssetSid?: string | null, transitionAssetSid?: string | null, frameAssetSid?: string | null, visualPackageSid?: string | null, backgroundOpacity?: number | null, fontSize?: number | null, fontWeight?: string | null, fontItalic?: boolean | null, fontFamily?: string | null, padding?: Array<number | null> | null, outlineWidth?: number | null, outlineStyle?: string | null, borderWidth?: number | null, borderStyle?: string | null, backgroundColor?: string | null, outlineColor?: string | null, borderColor?: string | null, foregroundColor?: string | null, imagesStyleName?: string | null, headerFontFamily?: string | null, headerFontAssetSid?: string | null, headerBoldFileName?: string | null, headerRegularFileName?: string | null, bodyBoldFileName?: string | null, bodyRegularFileName?: string | null, captionsVerticalAlign?: number | null, captionsStyleType?: number | null, captionsFontColor?: string | null, captionsFontColorIndex?: number | null, captionsStyleColor?: string | null, captionsStyleColorIndex?: number | null, captionsPosition?: number | null, depth?: number | null, layers?: number | null, perspective?: number | null, fade?: boolean | null, direction?: string | null, depthColor?: string | null, highlightColorIndex?: number | null, framePositionX?: number | null, framePositionY?: number | null, frameWidth?: number | null } | null, music?: { __typename?: 'Music', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, description?: string | null, externalId?: string | null, credit?: string | null, creditRequired?: boolean | null, enabled?: boolean | null, downloadDate?: number | null, volume?: number | null, noContentVolume?: number | null, overrideVolume?: boolean | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, video?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, output?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, backgroundJobs?: Array<{ __typename?: 'BackgroundJob', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, startTime?: number | null, type?: string | null, subType?: string | null, audioSid?: string | null } | null> | null, scenes?: Array<{ __typename?: 'Chapter', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, title?: string | null, cid?: string | null, index?: number | null, keyFramed?: boolean | null, formated?: boolean | null, transcripted?: boolean | null, highlighted?: boolean | null, faceDetected?: boolean | null, noiseReducted?: boolean | null, resized?: boolean | null, fitted?: boolean | null, verified?: boolean | null, masked?: boolean | null, offset?: number | null, externalVendor?: string | null, externalId?: string | null, mute?: boolean | null, disabled?: boolean | null, greenScreenColor?: Array<number | null> | null, clipFrom?: number | null, cuePointSid?: string | null, cuePointType?: number | null, image?: boolean | null, detections?: Array<{ __typename?: 'Detection', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, start?: number | null, end?: number | null, xCenterPercentage?: number | null, yCenterPercentage?: number | null } | null> | null, resize?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, fit?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, maskPreview?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null } | null> | null } | null } | null };

export type ApplyPresetToSequenceMutationVariables = Exact<{
  userSid: Scalars['String'];
  sequenceSid: Scalars['String'];
  presetSid: Scalars['String'];
}>;


export type ApplyPresetToSequenceMutation = { __typename?: 'Mutation', sequence?: { __typename?: 'SequenceActions', updatePreset?: { __typename?: 'Sequence', sid?: string | null } | null } | null };

export type ValidateInputsMutationVariables = Exact<{
  sequenceSid: Scalars['String'];
}>;


export type ValidateInputsMutation = { __typename?: 'Mutation', sequence?: { __typename?: 'SequenceActions', validateInputs?: { __typename?: 'Sequence', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, useFootageForCrop?: boolean | null, transcripted?: number | null, highlighted?: number | null, validated?: number | null, masked?: number | null, presetSid?: string | null, userSid?: string | null, width?: number | null, height?: number | null, aspectRatio?: string | null, altAspectRatios?: Array<string | null> | null, languageCode?: string | null, title?: string | null, useGreenScreen?: boolean | null, useDenoised?: boolean | null, useCaptions?: boolean | null, useV2ClosedCaptions?: boolean | null, captionsBackgroundOpacity?: number | null, useTitleCuePoints?: boolean | null, burnCaptions?: boolean | null, editRulesSid?: string | null, folderSid?: string | null, generatedType?: string | null, footageSid?: string | null, errorCause?: string | null, errorCode?: number | null, duration?: number | null, role?: number | null, accessesCount?: number | null, audioGenerated?: boolean | null, editRules?: { __typename?: 'EditRules', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, name: string, useSpeakers: boolean, useIntro: boolean, useOutro: boolean, useVideos: boolean, useIcons: boolean, useImages: boolean, useTexts: boolean, useSlides: boolean, useLogo: boolean, useMusic: boolean, useHighlight: boolean, useFrame: boolean, volume?: number | null, noContentVolume?: number | null } | null, logo?: { __typename?: 'Logo', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, name?: string | null, srcWidth?: number | null, srcHeight?: number | null, size?: number | null, top?: number | null, bottom?: number | null, left?: number | null, right?: number | null, removeWhiteBackground?: boolean | null, crop?: boolean | null, opacity?: number | null } | null, chapters?: Array<{ __typename?: 'Chapter', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, title?: string | null, cid?: string | null, index?: number | null, keyFramed?: boolean | null, formated?: boolean | null, transcripted?: boolean | null, highlighted?: boolean | null, faceDetected?: boolean | null, noiseReducted?: boolean | null, resized?: boolean | null, fitted?: boolean | null, verified?: boolean | null, masked?: boolean | null, offset?: number | null, externalVendor?: string | null, externalId?: string | null, mute?: boolean | null, disabled?: boolean | null, greenScreenColor?: Array<number | null> | null, clipFrom?: number | null, cuePointSid?: string | null, cuePointType?: number | null, image?: boolean | null, detections?: Array<{ __typename?: 'Detection', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, start?: number | null, end?: number | null, xCenterPercentage?: number | null, yCenterPercentage?: number | null } | null> | null, resize?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, fit?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, maskPreview?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null } | null> | null, colors?: Array<{ __typename?: 'Color', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, color?: string | null, rgb?: Array<number | null> | null, brightness?: number | null, brightnessIndex?: number | null, dominancy?: number | null, grayness?: number | null, percent?: number | null } | null> | null, style?: { __typename?: 'Style', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, fontAssetSid?: string | null, captionsFontAssetSid?: string | null, introLogoAssetSid?: string | null, outroLogoAssetSid?: string | null, captionsRegularFileName?: string | null, captionsFontFamily?: string | null, textAssetSid?: string | null, slideAssetSid?: string | null, speakerAssetSid?: string | null, introAssetSid?: string | null, outroAssetSid?: string | null, transitionAssetSid?: string | null, frameAssetSid?: string | null, visualPackageSid?: string | null, backgroundOpacity?: number | null, fontSize?: number | null, fontWeight?: string | null, fontItalic?: boolean | null, fontFamily?: string | null, padding?: Array<number | null> | null, outlineWidth?: number | null, outlineStyle?: string | null, borderWidth?: number | null, borderStyle?: string | null, backgroundColor?: string | null, outlineColor?: string | null, borderColor?: string | null, foregroundColor?: string | null, imagesStyleName?: string | null, headerFontFamily?: string | null, headerFontAssetSid?: string | null, headerBoldFileName?: string | null, headerRegularFileName?: string | null, bodyBoldFileName?: string | null, bodyRegularFileName?: string | null, captionsVerticalAlign?: number | null, captionsStyleType?: number | null, captionsFontColor?: string | null, captionsFontColorIndex?: number | null, captionsStyleColor?: string | null, captionsStyleColorIndex?: number | null, captionsPosition?: number | null, depth?: number | null, layers?: number | null, perspective?: number | null, fade?: boolean | null, direction?: string | null, depthColor?: string | null, highlightColorIndex?: number | null, framePositionX?: number | null, framePositionY?: number | null, frameWidth?: number | null } | null, music?: { __typename?: 'Music', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, description?: string | null, externalId?: string | null, credit?: string | null, creditRequired?: boolean | null, enabled?: boolean | null, downloadDate?: number | null, volume?: number | null, noContentVolume?: number | null, overrideVolume?: boolean | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, video?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, output?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, backgroundJobs?: Array<{ __typename?: 'BackgroundJob', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, startTime?: number | null, type?: string | null, subType?: string | null, audioSid?: string | null } | null> | null, scenes?: Array<{ __typename?: 'Chapter', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, title?: string | null, cid?: string | null, index?: number | null, keyFramed?: boolean | null, formated?: boolean | null, transcripted?: boolean | null, highlighted?: boolean | null, faceDetected?: boolean | null, noiseReducted?: boolean | null, resized?: boolean | null, fitted?: boolean | null, verified?: boolean | null, masked?: boolean | null, offset?: number | null, externalVendor?: string | null, externalId?: string | null, mute?: boolean | null, disabled?: boolean | null, greenScreenColor?: Array<number | null> | null, clipFrom?: number | null, cuePointSid?: string | null, cuePointType?: number | null, image?: boolean | null, detections?: Array<{ __typename?: 'Detection', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, start?: number | null, end?: number | null, xCenterPercentage?: number | null, yCenterPercentage?: number | null } | null> | null, resize?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, fit?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, maskPreview?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null } | null> | null } | null } | null };

export type ReorderSequenceChaptersMutationVariables = Exact<{
  sequenceSid: Scalars['String'];
  chapters: Array<ChapterOrder> | ChapterOrder;
}>;


export type ReorderSequenceChaptersMutation = { __typename?: 'Mutation', sequence?: { __typename?: 'SequenceActions', reorderScenes?: { __typename?: 'Sequence', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, useFootageForCrop?: boolean | null, transcripted?: number | null, highlighted?: number | null, validated?: number | null, masked?: number | null, presetSid?: string | null, userSid?: string | null, width?: number | null, height?: number | null, aspectRatio?: string | null, altAspectRatios?: Array<string | null> | null, languageCode?: string | null, title?: string | null, useGreenScreen?: boolean | null, useDenoised?: boolean | null, useCaptions?: boolean | null, useV2ClosedCaptions?: boolean | null, captionsBackgroundOpacity?: number | null, useTitleCuePoints?: boolean | null, burnCaptions?: boolean | null, editRulesSid?: string | null, folderSid?: string | null, generatedType?: string | null, footageSid?: string | null, errorCause?: string | null, errorCode?: number | null, duration?: number | null, role?: number | null, accessesCount?: number | null, audioGenerated?: boolean | null, editRules?: { __typename?: 'EditRules', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, name: string, useSpeakers: boolean, useIntro: boolean, useOutro: boolean, useVideos: boolean, useIcons: boolean, useImages: boolean, useTexts: boolean, useSlides: boolean, useLogo: boolean, useMusic: boolean, useHighlight: boolean, useFrame: boolean, volume?: number | null, noContentVolume?: number | null } | null, logo?: { __typename?: 'Logo', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, name?: string | null, srcWidth?: number | null, srcHeight?: number | null, size?: number | null, top?: number | null, bottom?: number | null, left?: number | null, right?: number | null, removeWhiteBackground?: boolean | null, crop?: boolean | null, opacity?: number | null } | null, chapters?: Array<{ __typename?: 'Chapter', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, title?: string | null, cid?: string | null, index?: number | null, keyFramed?: boolean | null, formated?: boolean | null, transcripted?: boolean | null, highlighted?: boolean | null, faceDetected?: boolean | null, noiseReducted?: boolean | null, resized?: boolean | null, fitted?: boolean | null, verified?: boolean | null, masked?: boolean | null, offset?: number | null, externalVendor?: string | null, externalId?: string | null, mute?: boolean | null, disabled?: boolean | null, greenScreenColor?: Array<number | null> | null, clipFrom?: number | null, cuePointSid?: string | null, cuePointType?: number | null, image?: boolean | null, detections?: Array<{ __typename?: 'Detection', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, start?: number | null, end?: number | null, xCenterPercentage?: number | null, yCenterPercentage?: number | null } | null> | null, resize?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, fit?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, maskPreview?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null } | null> | null, colors?: Array<{ __typename?: 'Color', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, color?: string | null, rgb?: Array<number | null> | null, brightness?: number | null, brightnessIndex?: number | null, dominancy?: number | null, grayness?: number | null, percent?: number | null } | null> | null, style?: { __typename?: 'Style', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, fontAssetSid?: string | null, captionsFontAssetSid?: string | null, introLogoAssetSid?: string | null, outroLogoAssetSid?: string | null, captionsRegularFileName?: string | null, captionsFontFamily?: string | null, textAssetSid?: string | null, slideAssetSid?: string | null, speakerAssetSid?: string | null, introAssetSid?: string | null, outroAssetSid?: string | null, transitionAssetSid?: string | null, frameAssetSid?: string | null, visualPackageSid?: string | null, backgroundOpacity?: number | null, fontSize?: number | null, fontWeight?: string | null, fontItalic?: boolean | null, fontFamily?: string | null, padding?: Array<number | null> | null, outlineWidth?: number | null, outlineStyle?: string | null, borderWidth?: number | null, borderStyle?: string | null, backgroundColor?: string | null, outlineColor?: string | null, borderColor?: string | null, foregroundColor?: string | null, imagesStyleName?: string | null, headerFontFamily?: string | null, headerFontAssetSid?: string | null, headerBoldFileName?: string | null, headerRegularFileName?: string | null, bodyBoldFileName?: string | null, bodyRegularFileName?: string | null, captionsVerticalAlign?: number | null, captionsStyleType?: number | null, captionsFontColor?: string | null, captionsFontColorIndex?: number | null, captionsStyleColor?: string | null, captionsStyleColorIndex?: number | null, captionsPosition?: number | null, depth?: number | null, layers?: number | null, perspective?: number | null, fade?: boolean | null, direction?: string | null, depthColor?: string | null, highlightColorIndex?: number | null, framePositionX?: number | null, framePositionY?: number | null, frameWidth?: number | null } | null, music?: { __typename?: 'Music', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, description?: string | null, externalId?: string | null, credit?: string | null, creditRequired?: boolean | null, enabled?: boolean | null, downloadDate?: number | null, volume?: number | null, noContentVolume?: number | null, overrideVolume?: boolean | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, video?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, output?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, backgroundJobs?: Array<{ __typename?: 'BackgroundJob', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, startTime?: number | null, type?: string | null, subType?: string | null, audioSid?: string | null } | null> | null, scenes?: Array<{ __typename?: 'Chapter', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, title?: string | null, cid?: string | null, index?: number | null, keyFramed?: boolean | null, formated?: boolean | null, transcripted?: boolean | null, highlighted?: boolean | null, faceDetected?: boolean | null, noiseReducted?: boolean | null, resized?: boolean | null, fitted?: boolean | null, verified?: boolean | null, masked?: boolean | null, offset?: number | null, externalVendor?: string | null, externalId?: string | null, mute?: boolean | null, disabled?: boolean | null, greenScreenColor?: Array<number | null> | null, clipFrom?: number | null, cuePointSid?: string | null, cuePointType?: number | null, image?: boolean | null, detections?: Array<{ __typename?: 'Detection', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, start?: number | null, end?: number | null, xCenterPercentage?: number | null, yCenterPercentage?: number | null } | null> | null, resize?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, fit?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, maskPreview?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null } | null> | null } | null } | null };

export type AddChapterMutationVariables = Exact<{
  sequenceSid: Scalars['String'];
  chapter: ChapterAdd;
}>;


export type AddChapterMutation = { __typename?: 'Mutation', sequence?: { __typename?: 'SequenceActions', addChapter?: { __typename?: 'Chapter', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, title?: string | null, cid?: string | null, index?: number | null, keyFramed?: boolean | null, formated?: boolean | null, transcripted?: boolean | null, highlighted?: boolean | null, faceDetected?: boolean | null, noiseReducted?: boolean | null, resized?: boolean | null, fitted?: boolean | null, verified?: boolean | null, masked?: boolean | null, offset?: number | null, externalVendor?: string | null, externalId?: string | null, mute?: boolean | null, disabled?: boolean | null, greenScreenColor?: Array<number | null> | null, clipFrom?: number | null, cuePointSid?: string | null, cuePointType?: number | null, image?: boolean | null, detections?: Array<{ __typename?: 'Detection', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, start?: number | null, end?: number | null, xCenterPercentage?: number | null, yCenterPercentage?: number | null } | null> | null, resize?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, fit?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, maskPreview?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null } | null } | null };

export type CreateSequenceFromTemplateMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateSequenceFromTemplateMutation = { __typename?: 'Mutation', sequence?: { __typename?: 'SequenceActions', createFromTemplate?: { __typename?: 'Sequence', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, useFootageForCrop?: boolean | null, transcripted?: number | null, highlighted?: number | null, validated?: number | null, masked?: number | null, presetSid?: string | null, userSid?: string | null, width?: number | null, height?: number | null, aspectRatio?: string | null, altAspectRatios?: Array<string | null> | null, languageCode?: string | null, title?: string | null, useGreenScreen?: boolean | null, useDenoised?: boolean | null, useCaptions?: boolean | null, useV2ClosedCaptions?: boolean | null, captionsBackgroundOpacity?: number | null, useTitleCuePoints?: boolean | null, burnCaptions?: boolean | null, editRulesSid?: string | null, folderSid?: string | null, generatedType?: string | null, footageSid?: string | null, errorCause?: string | null, errorCode?: number | null, duration?: number | null, role?: number | null, accessesCount?: number | null, audioGenerated?: boolean | null, editRules?: { __typename?: 'EditRules', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, name: string, useSpeakers: boolean, useIntro: boolean, useOutro: boolean, useVideos: boolean, useIcons: boolean, useImages: boolean, useTexts: boolean, useSlides: boolean, useLogo: boolean, useMusic: boolean, useHighlight: boolean, useFrame: boolean, volume?: number | null, noContentVolume?: number | null } | null, logo?: { __typename?: 'Logo', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, name?: string | null, srcWidth?: number | null, srcHeight?: number | null, size?: number | null, top?: number | null, bottom?: number | null, left?: number | null, right?: number | null, removeWhiteBackground?: boolean | null, crop?: boolean | null, opacity?: number | null } | null, chapters?: Array<{ __typename?: 'Chapter', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, title?: string | null, cid?: string | null, index?: number | null, keyFramed?: boolean | null, formated?: boolean | null, transcripted?: boolean | null, highlighted?: boolean | null, faceDetected?: boolean | null, noiseReducted?: boolean | null, resized?: boolean | null, fitted?: boolean | null, verified?: boolean | null, masked?: boolean | null, offset?: number | null, externalVendor?: string | null, externalId?: string | null, mute?: boolean | null, disabled?: boolean | null, greenScreenColor?: Array<number | null> | null, clipFrom?: number | null, cuePointSid?: string | null, cuePointType?: number | null, image?: boolean | null, detections?: Array<{ __typename?: 'Detection', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, start?: number | null, end?: number | null, xCenterPercentage?: number | null, yCenterPercentage?: number | null } | null> | null, resize?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, fit?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, maskPreview?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null } | null> | null, colors?: Array<{ __typename?: 'Color', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, color?: string | null, rgb?: Array<number | null> | null, brightness?: number | null, brightnessIndex?: number | null, dominancy?: number | null, grayness?: number | null, percent?: number | null } | null> | null, style?: { __typename?: 'Style', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, fontAssetSid?: string | null, captionsFontAssetSid?: string | null, introLogoAssetSid?: string | null, outroLogoAssetSid?: string | null, captionsRegularFileName?: string | null, captionsFontFamily?: string | null, textAssetSid?: string | null, slideAssetSid?: string | null, speakerAssetSid?: string | null, introAssetSid?: string | null, outroAssetSid?: string | null, transitionAssetSid?: string | null, frameAssetSid?: string | null, visualPackageSid?: string | null, backgroundOpacity?: number | null, fontSize?: number | null, fontWeight?: string | null, fontItalic?: boolean | null, fontFamily?: string | null, padding?: Array<number | null> | null, outlineWidth?: number | null, outlineStyle?: string | null, borderWidth?: number | null, borderStyle?: string | null, backgroundColor?: string | null, outlineColor?: string | null, borderColor?: string | null, foregroundColor?: string | null, imagesStyleName?: string | null, headerFontFamily?: string | null, headerFontAssetSid?: string | null, headerBoldFileName?: string | null, headerRegularFileName?: string | null, bodyBoldFileName?: string | null, bodyRegularFileName?: string | null, captionsVerticalAlign?: number | null, captionsStyleType?: number | null, captionsFontColor?: string | null, captionsFontColorIndex?: number | null, captionsStyleColor?: string | null, captionsStyleColorIndex?: number | null, captionsPosition?: number | null, depth?: number | null, layers?: number | null, perspective?: number | null, fade?: boolean | null, direction?: string | null, depthColor?: string | null, highlightColorIndex?: number | null, framePositionX?: number | null, framePositionY?: number | null, frameWidth?: number | null } | null, music?: { __typename?: 'Music', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, description?: string | null, externalId?: string | null, credit?: string | null, creditRequired?: boolean | null, enabled?: boolean | null, downloadDate?: number | null, volume?: number | null, noContentVolume?: number | null, overrideVolume?: boolean | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, video?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, output?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, backgroundJobs?: Array<{ __typename?: 'BackgroundJob', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, startTime?: number | null, type?: string | null, subType?: string | null, audioSid?: string | null } | null> | null, scenes?: Array<{ __typename?: 'Chapter', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, title?: string | null, cid?: string | null, index?: number | null, keyFramed?: boolean | null, formated?: boolean | null, transcripted?: boolean | null, highlighted?: boolean | null, faceDetected?: boolean | null, noiseReducted?: boolean | null, resized?: boolean | null, fitted?: boolean | null, verified?: boolean | null, masked?: boolean | null, offset?: number | null, externalVendor?: string | null, externalId?: string | null, mute?: boolean | null, disabled?: boolean | null, greenScreenColor?: Array<number | null> | null, clipFrom?: number | null, cuePointSid?: string | null, cuePointType?: number | null, image?: boolean | null, detections?: Array<{ __typename?: 'Detection', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, start?: number | null, end?: number | null, xCenterPercentage?: number | null, yCenterPercentage?: number | null } | null> | null, resize?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, fit?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, maskPreview?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null } | null> | null } | null } | null };

export type RenameSequenceMutationVariables = Exact<{
  sequenceSid: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
}>;


export type RenameSequenceMutation = { __typename?: 'Mutation', sequence?: { __typename?: 'SequenceActions', update?: { __typename?: 'Sequence', sid?: string | null, title?: string | null } | null } | null };

export type DeleteSequenceMutationVariables = Exact<{
  sequenceSid: Scalars['String'];
}>;


export type DeleteSequenceMutation = { __typename?: 'Mutation', sequence?: { __typename?: 'SequenceActions', remove?: boolean | null } | null };

export type DuplicateSequenceMutationVariables = Exact<{
  sequenceSid: Scalars['String'];
  userSid: Scalars['String'];
  aspectRatio: Scalars['String'];
  languageCode?: InputMaybe<Scalars['String']>;
}>;


export type DuplicateSequenceMutation = { __typename?: 'Mutation', sequence?: { __typename?: 'SequenceActions', clone?: { __typename?: 'Sequence', sid?: string | null } | null } | null };

export type LeanSequenceFragment = { __typename?: 'Sequence', sid?: string | null, title?: string | null, duration?: number | null, languageCode?: string | null, useV2ClosedCaptions?: boolean | null, footageSid?: string | null, chapters?: Array<{ __typename?: 'Chapter', sid?: string | null, status?: number | null, contentVersion?: number | null, thumbnailVersion?: number | null, cuePointType?: number | null, assetSid?: string | null } | null> | null };

export type FullChapterFragment = { __typename?: 'Chapter', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, title?: string | null, cid?: string | null, index?: number | null, keyFramed?: boolean | null, formated?: boolean | null, transcripted?: boolean | null, highlighted?: boolean | null, faceDetected?: boolean | null, noiseReducted?: boolean | null, resized?: boolean | null, fitted?: boolean | null, verified?: boolean | null, masked?: boolean | null, offset?: number | null, externalVendor?: string | null, externalId?: string | null, mute?: boolean | null, disabled?: boolean | null, greenScreenColor?: Array<number | null> | null, clipFrom?: number | null, cuePointSid?: string | null, cuePointType?: number | null, image?: boolean | null, detections?: Array<{ __typename?: 'Detection', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, start?: number | null, end?: number | null, xCenterPercentage?: number | null, yCenterPercentage?: number | null } | null> | null, resize?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, fit?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, maskPreview?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null };

export type FullSequenceFragment = { __typename?: 'Sequence', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, useFootageForCrop?: boolean | null, transcripted?: number | null, highlighted?: number | null, validated?: number | null, masked?: number | null, presetSid?: string | null, userSid?: string | null, width?: number | null, height?: number | null, aspectRatio?: string | null, altAspectRatios?: Array<string | null> | null, languageCode?: string | null, title?: string | null, useGreenScreen?: boolean | null, useDenoised?: boolean | null, useCaptions?: boolean | null, useV2ClosedCaptions?: boolean | null, captionsBackgroundOpacity?: number | null, useTitleCuePoints?: boolean | null, burnCaptions?: boolean | null, editRulesSid?: string | null, folderSid?: string | null, generatedType?: string | null, footageSid?: string | null, errorCause?: string | null, errorCode?: number | null, duration?: number | null, role?: number | null, accessesCount?: number | null, audioGenerated?: boolean | null, editRules?: { __typename?: 'EditRules', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, name: string, useSpeakers: boolean, useIntro: boolean, useOutro: boolean, useVideos: boolean, useIcons: boolean, useImages: boolean, useTexts: boolean, useSlides: boolean, useLogo: boolean, useMusic: boolean, useHighlight: boolean, useFrame: boolean, volume?: number | null, noContentVolume?: number | null } | null, logo?: { __typename?: 'Logo', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, name?: string | null, srcWidth?: number | null, srcHeight?: number | null, size?: number | null, top?: number | null, bottom?: number | null, left?: number | null, right?: number | null, removeWhiteBackground?: boolean | null, crop?: boolean | null, opacity?: number | null } | null, chapters?: Array<{ __typename?: 'Chapter', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, title?: string | null, cid?: string | null, index?: number | null, keyFramed?: boolean | null, formated?: boolean | null, transcripted?: boolean | null, highlighted?: boolean | null, faceDetected?: boolean | null, noiseReducted?: boolean | null, resized?: boolean | null, fitted?: boolean | null, verified?: boolean | null, masked?: boolean | null, offset?: number | null, externalVendor?: string | null, externalId?: string | null, mute?: boolean | null, disabled?: boolean | null, greenScreenColor?: Array<number | null> | null, clipFrom?: number | null, cuePointSid?: string | null, cuePointType?: number | null, image?: boolean | null, detections?: Array<{ __typename?: 'Detection', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, start?: number | null, end?: number | null, xCenterPercentage?: number | null, yCenterPercentage?: number | null } | null> | null, resize?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, fit?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, maskPreview?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null } | null> | null, colors?: Array<{ __typename?: 'Color', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, color?: string | null, rgb?: Array<number | null> | null, brightness?: number | null, brightnessIndex?: number | null, dominancy?: number | null, grayness?: number | null, percent?: number | null } | null> | null, style?: { __typename?: 'Style', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, fontAssetSid?: string | null, captionsFontAssetSid?: string | null, introLogoAssetSid?: string | null, outroLogoAssetSid?: string | null, captionsRegularFileName?: string | null, captionsFontFamily?: string | null, textAssetSid?: string | null, slideAssetSid?: string | null, speakerAssetSid?: string | null, introAssetSid?: string | null, outroAssetSid?: string | null, transitionAssetSid?: string | null, frameAssetSid?: string | null, visualPackageSid?: string | null, backgroundOpacity?: number | null, fontSize?: number | null, fontWeight?: string | null, fontItalic?: boolean | null, fontFamily?: string | null, padding?: Array<number | null> | null, outlineWidth?: number | null, outlineStyle?: string | null, borderWidth?: number | null, borderStyle?: string | null, backgroundColor?: string | null, outlineColor?: string | null, borderColor?: string | null, foregroundColor?: string | null, imagesStyleName?: string | null, headerFontFamily?: string | null, headerFontAssetSid?: string | null, headerBoldFileName?: string | null, headerRegularFileName?: string | null, bodyBoldFileName?: string | null, bodyRegularFileName?: string | null, captionsVerticalAlign?: number | null, captionsStyleType?: number | null, captionsFontColor?: string | null, captionsFontColorIndex?: number | null, captionsStyleColor?: string | null, captionsStyleColorIndex?: number | null, captionsPosition?: number | null, depth?: number | null, layers?: number | null, perspective?: number | null, fade?: boolean | null, direction?: string | null, depthColor?: string | null, highlightColorIndex?: number | null, framePositionX?: number | null, framePositionY?: number | null, frameWidth?: number | null } | null, music?: { __typename?: 'Music', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, description?: string | null, externalId?: string | null, credit?: string | null, creditRequired?: boolean | null, enabled?: boolean | null, downloadDate?: number | null, volume?: number | null, noContentVolume?: number | null, overrideVolume?: boolean | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, video?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, output?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, backgroundJobs?: Array<{ __typename?: 'BackgroundJob', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, startTime?: number | null, type?: string | null, subType?: string | null, audioSid?: string | null } | null> | null, scenes?: Array<{ __typename?: 'Chapter', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, name?: string | null, title?: string | null, cid?: string | null, index?: number | null, keyFramed?: boolean | null, formated?: boolean | null, transcripted?: boolean | null, highlighted?: boolean | null, faceDetected?: boolean | null, noiseReducted?: boolean | null, resized?: boolean | null, fitted?: boolean | null, verified?: boolean | null, masked?: boolean | null, offset?: number | null, externalVendor?: string | null, externalId?: string | null, mute?: boolean | null, disabled?: boolean | null, greenScreenColor?: Array<number | null> | null, clipFrom?: number | null, cuePointSid?: string | null, cuePointType?: number | null, image?: boolean | null, detections?: Array<{ __typename?: 'Detection', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, start?: number | null, end?: number | null, xCenterPercentage?: number | null, yCenterPercentage?: number | null } | null> | null, resize?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, fit?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, mask?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, maskPreview?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null, audio?: { __typename?: 'Content', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null } | null } | null> | null };

export type GetSequenceCaptionsQueryVariables = Exact<{
  sequenceSid: Scalars['String'];
}>;


export type GetSequenceCaptionsQuery = { __typename?: 'Query', closedCaption?: { __typename?: 'ClosedCaption', listWords?: Array<{ __typename?: 'Word', word?: string | null, startTime?: number | null, endTime?: number | null, newLine?: boolean | null, highlight?: boolean | null, flags?: number | null, chapterSid?: string | null } | null> | null } | null };

export type GetV2SequenceCaptionsQueryVariables = Exact<{
  sequenceSid: Scalars['String'];
  chapterSid?: InputMaybe<Scalars['String']>;
}>;


export type GetV2SequenceCaptionsQuery = { __typename?: 'Query', closedCaptions: Array<{ __typename?: 'ClosedCaptionsOutput', syncWithTranscript: boolean, contentVersion: number }> };

export type RegenerateSequenceCaptionsMutationVariables = Exact<{
  sequenceSid: Scalars['String'];
}>;


export type RegenerateSequenceCaptionsMutation = { __typename?: 'Mutation', regenerateClosedCaptions: { __typename?: 'ClosedCaptionListWords', words?: Array<{ __typename?: 'ClosedCaptionWordOutput', word: string, startTime: number, endTime: number, newLine?: boolean | null, highlight?: boolean | null, flags?: number | null, chapterSid: string }> | null } };

export type UnsyncClosedCaptionsWithTranscriptMutationVariables = Exact<{
  sequenceSid: Scalars['String'];
}>;


export type UnsyncClosedCaptionsWithTranscriptMutation = { __typename?: 'Mutation', unsyncClosedCaptionsWithTranscript: { __typename?: 'ClosedCaptionSyncStatus', syncWithTranscript: boolean } };

export type GetShopperQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShopperQuery = { __typename?: 'Query', shopper?: { __typename?: 'Shopper', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, shopperId?: number | null, userSid?: string | null, orgSid?: string | null, ccType?: string | null, exp?: string | null, lastDigits?: string | null, zip?: string | null, name?: string | null, fraudSessionId?: string | null, updateUrl?: string | null } | null };

export type FullShopperFragment = { __typename?: 'Shopper', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, shopperId?: number | null, userSid?: string | null, orgSid?: string | null, ccType?: string | null, exp?: string | null, lastDigits?: string | null, zip?: string | null, name?: string | null, fraudSessionId?: string | null, updateUrl?: string | null };

export type GetSpeakerCuePointsQueryVariables = Exact<{
  sequenceSid?: InputMaybe<Scalars['String']>;
}>;


export type GetSpeakerCuePointsQuery = { __typename?: 'Query', speakerCuePoint?: { __typename?: 'SpeakerCuePoint', list?: Array<{ __typename?: 'SpeakerCuePoint', sid?: string | null, objectType?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, sequenceSid?: string | null, chapterSid?: string | null, type?: number | null, startTime?: number | null, endTime?: number | null, srcStartTime?: number | null, srcEndTime?: number | null, title?: string | null, opacity?: number | null, width?: number | null, height?: number | null, top?: number | null, bottom?: number | null, left?: number | null, right?: number | null, zIndex?: number | null, grayscale?: number | null, alignment?: string | null, externalId?: string | null, name?: string | null, nameColor?: string | null, titleColor?: string | null, nameColorIndex?: number | null, titleColorIndex?: number | null, nameBackgroundColor?: string | null, titleBackgroundColor?: string | null, nameBackgroundColorIndex?: number | null, titleBackgroundColorIndex?: number | null, index?: number | null, speakerSid?: string | null, animations?: Array<{ __typename?: 'GraphicAnimation', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, type?: string | null, kind?: string | null, start?: number | null, startValue?: number | null, endValue?: number | null, startX?: number | null, startY?: number | null, endX?: number | null, endY?: number | null, duration?: number | null, easing?: string | null } | null> | null, colors?: Array<{ __typename?: 'GraphicColor', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, name?: string | null, className?: string | null, type?: number | null, color?: string | null, colorIndex?: number | null } | null> | null, assets?: Array<{ __typename?: 'GraphicAsset', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, name?: string | null, className?: string | null, type?: number | null, assetSid?: string | null } | null> | null, speaker?: { __typename?: 'Speaker', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, userSid?: string | null, orgSid?: string | null, name?: string | null, title?: string | null } | null } | null> | null } | null };

export type UpdateSpeakerCuePointMutationVariables = Exact<{
  sid: Scalars['String'];
  sequenceSid: Scalars['String'];
  values: SpeakerCuePointUpdate;
}>;


export type UpdateSpeakerCuePointMutation = { __typename?: 'Mutation', speakerCuePoint?: { __typename?: 'SpeakerCuePointActions', update?: { __typename?: 'SpeakerCuePoint', sid?: string | null } | null } | null };

export type RemoveSpeakerCuePointMutationVariables = Exact<{
  sid: Scalars['String'];
  sequenceSid: Scalars['String'];
}>;


export type RemoveSpeakerCuePointMutation = { __typename?: 'Mutation', speakerCuePoint?: { __typename?: 'SpeakerCuePointActions', remove?: boolean | null } | null };

export type ActivateSpeakerCuePointMutationVariables = Exact<{
  sid: Scalars['String'];
  sequenceSid: Scalars['String'];
}>;


export type ActivateSpeakerCuePointMutation = { __typename?: 'Mutation', speakerCuePoint?: { __typename?: 'SpeakerCuePointActions', activate?: boolean | null } | null };

export type DeactivateSpeakerCuePointMutationVariables = Exact<{
  sid: Scalars['String'];
  sequenceSid: Scalars['String'];
}>;


export type DeactivateSpeakerCuePointMutation = { __typename?: 'Mutation', speakerCuePoint?: { __typename?: 'SpeakerCuePointActions', deactivate?: boolean | null } | null };

export type FullSpeakerCuePointFragment = { __typename?: 'SpeakerCuePoint', sid?: string | null, objectType?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, key?: string | null, thumbnailVersion?: number | null, assetSid?: string | null, linkSid?: string | null, size?: number | null, contentVersion?: number | null, duration?: number | null, srcDuration?: number | null, configurationTime?: number | null, generatingTime?: number | null, aspectRatio?: string | null, sequenceSid?: string | null, chapterSid?: string | null, type?: number | null, startTime?: number | null, endTime?: number | null, srcStartTime?: number | null, srcEndTime?: number | null, title?: string | null, opacity?: number | null, width?: number | null, height?: number | null, top?: number | null, bottom?: number | null, left?: number | null, right?: number | null, zIndex?: number | null, grayscale?: number | null, alignment?: string | null, externalId?: string | null, name?: string | null, nameColor?: string | null, titleColor?: string | null, nameColorIndex?: number | null, titleColorIndex?: number | null, nameBackgroundColor?: string | null, titleBackgroundColor?: string | null, nameBackgroundColorIndex?: number | null, titleBackgroundColorIndex?: number | null, index?: number | null, speakerSid?: string | null, animations?: Array<{ __typename?: 'GraphicAnimation', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, type?: string | null, kind?: string | null, start?: number | null, startValue?: number | null, endValue?: number | null, startX?: number | null, startY?: number | null, endX?: number | null, endY?: number | null, duration?: number | null, easing?: string | null } | null> | null, colors?: Array<{ __typename?: 'GraphicColor', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, name?: string | null, className?: string | null, type?: number | null, color?: string | null, colorIndex?: number | null } | null> | null, assets?: Array<{ __typename?: 'GraphicAsset', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, name?: string | null, className?: string | null, type?: number | null, assetSid?: string | null } | null> | null, speaker?: { __typename?: 'Speaker', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, userSid?: string | null, orgSid?: string | null, name?: string | null, title?: string | null } | null };

export type GetSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionQuery = { __typename?: 'Query', subscription?: { __typename?: 'Subscription', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, subscriptionId?: number | null, userSid?: string | null, orgSid?: string | null, nextChargeTime?: number | null, planSid?: string | null, recurringPrice?: number | null, chargeType?: number | null, couponSid?: string | null, taxId?: string | null, billingAddress?: string | null, billingEmail?: string | null, billingName?: string | null, monthlyPeriodStart?: number | null, lastActivationDate?: number | null, isCanceled?: boolean | null, freeTrialRemainingTime?: number | null, footageUploadsCount?: number | null } | null };

export type FullSubscriptionFragment = { __typename?: 'Subscription', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, subscriptionId?: number | null, userSid?: string | null, orgSid?: string | null, nextChargeTime?: number | null, planSid?: string | null, recurringPrice?: number | null, chargeType?: number | null, couponSid?: string | null, taxId?: string | null, billingAddress?: string | null, billingEmail?: string | null, billingName?: string | null, monthlyPeriodStart?: number | null, lastActivationDate?: number | null, isCanceled?: boolean | null, freeTrialRemainingTime?: number | null, footageUploadsCount?: number | null };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, uiFlags?: number | null, orgSid?: string | null, email?: string | null, resetToken?: string | null, firstName?: string | null, lastName?: string | null, role?: number | null, thumbUrl?: string | null, teamTypeSid?: string | null, orgName?: string | null, orgUrl?: string | null, orgIndustry?: string | null, orgNumOfEmpolyees?: string | null, fontFamily?: string | null, roleSid?: string | null, resetUrl?: string | null, cacheVersion?: number | null, department?: string | null, userPurpose?: string | null, onboardingFinished?: boolean | null, languageCode?: string | null } | null };

export type CreateUserMutationVariables = Exact<{
  email: Scalars['String'];
  signupCampaign?: InputMaybe<Scalars['String']>;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', user?: { __typename?: 'UserActions', add?: { __typename?: 'User', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, uiFlags?: number | null, orgSid?: string | null, email?: string | null, resetToken?: string | null, firstName?: string | null, lastName?: string | null, role?: number | null, thumbUrl?: string | null, teamTypeSid?: string | null, orgName?: string | null, orgUrl?: string | null, orgIndustry?: string | null, orgNumOfEmpolyees?: string | null, fontFamily?: string | null, roleSid?: string | null, resetUrl?: string | null, cacheVersion?: number | null, department?: string | null, userPurpose?: string | null, onboardingFinished?: boolean | null, languageCode?: string | null } | null } | null };

export type UpdateUserMutationVariables = Exact<{
  userSid: Scalars['String'];
  department?: InputMaybe<Scalars['String']>;
  userPurpose?: InputMaybe<Scalars['String']>;
  orgName?: InputMaybe<Scalars['String']>;
  orgUrl?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  onboardingFinished?: InputMaybe<Scalars['Boolean']>;
  signupCampaign?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', user?: { __typename?: 'UserActions', update?: { __typename?: 'User', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, uiFlags?: number | null, orgSid?: string | null, email?: string | null, resetToken?: string | null, firstName?: string | null, lastName?: string | null, role?: number | null, thumbUrl?: string | null, teamTypeSid?: string | null, orgName?: string | null, orgUrl?: string | null, orgIndustry?: string | null, orgNumOfEmpolyees?: string | null, fontFamily?: string | null, roleSid?: string | null, resetUrl?: string | null, cacheVersion?: number | null, department?: string | null, userPurpose?: string | null, onboardingFinished?: boolean | null, languageCode?: string | null } | null } | null };

export type LoginUserQueryVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', login?: string | null } | null };

export type LoginUserOAuthQueryVariables = Exact<{
  provider: Scalars['String'];
  providerToken: Scalars['String'];
  signupCampaign?: InputMaybe<Scalars['String']>;
}>;


export type LoginUserOAuthQuery = { __typename?: 'Query', user?: { __typename?: 'User', verifyLogin?: string | null } | null };

export type UpdateUserPasswordQueryVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
}>;


export type UpdateUserPasswordQuery = { __typename?: 'Query', user?: { __typename?: 'User', setPassword?: string | null } | null };

export type ResetUserPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResetUserPasswordMutation = { __typename?: 'Mutation', user?: { __typename?: 'UserActions', requestResetPassword?: boolean | null } | null };

export type FullUserFragment = { __typename?: 'User', objectType?: string | null, sid?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, uiFlags?: number | null, orgSid?: string | null, email?: string | null, resetToken?: string | null, firstName?: string | null, lastName?: string | null, role?: number | null, thumbUrl?: string | null, teamTypeSid?: string | null, orgName?: string | null, orgUrl?: string | null, orgIndustry?: string | null, orgNumOfEmpolyees?: string | null, fontFamily?: string | null, roleSid?: string | null, resetUrl?: string | null, cacheVersion?: number | null, department?: string | null, userPurpose?: string | null, onboardingFinished?: boolean | null, languageCode?: string | null };

export type GetVideoTypesQueryVariables = Exact<{
  filter?: InputMaybe<VideoTypeFilter>;
  pager?: InputMaybe<PagerAdd>;
}>;


export type GetVideoTypesQuery = { __typename?: 'Query', videoType?: { __typename?: 'VideoType', list?: Array<{ __typename?: 'VideoType', sid?: string | null, objectType?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, name?: string | null, description?: string | null, editRulesSid?: string | null, order?: number | null, icon?: string | null } | null> | null } | null };

export type FullVideoTypeFragment = { __typename?: 'VideoType', sid?: string | null, objectType?: string | null, version?: number | null, insertTime?: number | null, updateTime?: number | null, status?: number | null, name?: string | null, description?: string | null, editRulesSid?: string | null, order?: number | null, icon?: string | null };

export type GetWordsByExternalAssetIdQueryVariables = Exact<{
  footageId: Scalars['String'];
  externalAssetSid: Scalars['String'];
}>;


export type GetWordsByExternalAssetIdQuery = { __typename?: 'Query', getWordsByExternalAssetId: { __typename?: 'SelectedWords', durationMs: number, words?: Array<{ __typename?: 'V2_Word', word: string, startTime: number, endTime: number, confidence?: number | null, alt?: boolean | null, version?: number | null, highlight?: boolean | null }> | null } };

export type UpdateBulkOfWordsInTranscriptMutationVariables = Exact<{
  footageId: Scalars['String'];
  input: BulkOfWordsUpdate;
}>;


export type UpdateBulkOfWordsInTranscriptMutation = { __typename?: 'Mutation', updateBulkOfWordsInTranscript: { __typename?: 'Transcript', text?: string | null, words?: Array<{ __typename?: 'V2_Word', word: string, startTime: number, endTime: number, version?: number | null, highlight?: boolean | null }> | null } };

export const FullAssetFragmentDoc = gql`
    fragment fullAsset on Asset {
  sid
  objectType
  sid
  version
  insertTime
  updateTime
  status
  folderSid
  isDefault
  type
  userSid
  orgSid
  creatorSid
  fileNames
  languageCode
  ownerSid
  parentSid
  name
  description
  systemId
  genres
  tags
  moods
  size
  aspectRatio
  noWords
  contentIdentifier {
    objectType
    sid
    version
    insertTime
    updateTime
    thumbnailVersion
    key
    aspectRatio
  }
  errorCause
  errorCode
  published
  duration
  footageSid
}
    `;
export const LeanDownloadInfoFragmentDoc = gql`
    fragment leanDownloadInfo on DownloadInfo {
  id
  createdAt
  updatedAt
  footageId
  externalSequenceId
  externalSequenceTitle
  externalSequenceEndVersion
  hitCounter
  status
}
    `;
export const FullEditRulesFragmentDoc = gql`
    fragment fullEditRules on EditRules {
  sid
  objectType
  sid
  version
  insertTime
  updateTime
  status
  name
  useSpeakers
  useIntro
  useOutro
  useVideos
  useIcons
  useImages
  useTexts
  useSlides
  useLogo
  useMusic
  useHighlight
  useFrame
  volume
  noContentVolume
}
    `;
export const ClipSequenceFragmentDoc = gql`
    fragment clipSequence on ClipSequence {
  id
  title
  type
  status
  externalSequenceId
  ratio
  languageCode
  favorite
  openedAt
  editedAt
  downloadedAt
}
    `;
export const LeanFootageFragmentDoc = gql`
    fragment leanFootage on Footage {
  id
  thumbnail {
    filePath
  }
  status
  filename
  filesPaths {
    previewFootage
    formattedFootage
  }
  origin
  originalFootageId
  languageCode
  createdAt
  youtubeId
  mediainfo {
    duration
    aspectRatio
  }
  clips {
    id
    title
    type
    status
    clipFrom
    duration
    sequences {
      id
      title
      type
      status
      externalSequenceId
      ratio
      languageCode
      favorite
      openedAt
      editedAt
      downloadedAt
    }
  }
  automationData {
    externalPresetSid
  }
}
    `;
export const TranscriptFootageFragmentDoc = gql`
    fragment transcriptFootage on Footage {
  id
  transcriptRef {
    words {
      word
      startTime
      endTime
      confidence
      alt
      highlight
      version
    }
  }
}
    `;
export const FullPlanFragmentDoc = gql`
    fragment fullPlan on Plan {
  sid
  version
  insertTime
  updateTime
  status
  name
  recurringPrice
  overrideRecurringPrice
  annualRecurringPrice
  annualOverrideRecurringPrice
  description
  freeTrial
  maxVideoDuration
  maxVideos
  maxUsers
  maxStorage
  brandsCount
  icon
  hidden
  features
  salesOnly
  buttonColor
  provider
  planId
  annualPlanId
  showShutterStockBadge
  promptTag
  annualDiscountPercentage
  annualDiscountPrice
  tier
  buttonAditionalColor
  pricePerSeatMonthly
  pricePerSeatAnnually
  subHeader
  maxFootageUploads
  maxFootageUploadMinutesDuration
  allowedTierFeatures
  disallowedTierFeatures
}
    `;
export const FullPresetFragmentDoc = gql`
    fragment fullPreset on Preset {
  sid
  objectType
  sid
  version
  insertTime
  updateTime
  status
  assets {
    objectType
    sid
    version
    insertTime
    updateTime
    assetSid
    type
    usageType
    fileNames
    regularFileName
    boldFileName
    isDefault
  }
  userSid
  name
  colors {
    objectType
    sid
    version
    insertTime
    updateTime
    color
    rgb
    brightness
    brightnessIndex
    dominancy
    grayness
    percent
  }
  secondaryColors {
    objectType
    sid
    version
    insertTime
    updateTime
    color
    rgb
    brightness
    brightnessIndex
    dominancy
    grayness
    percent
  }
  fontFamily
  headerFontFamily
  headerBoldVariant
  headerRegularVariant
  bodyBoldVariant
  bodyRegularVariant
  defaultVisualPackage
  defaultVideoType
  exampleAsset
  editRules {
    objectType
    sid
    version
    insertTime
    updateTime
    status
    name
    useSpeakers
    useIntro
    useOutro
    useVideos
    useIcons
    useImages
    useTexts
    useSlides
    useLogo
    useMusic
    useHighlight
    useFrame
    volume
    noContentVolume
  }
}
    `;
export const LeanSequenceFragmentDoc = gql`
    fragment leanSequence on Sequence {
  sid
  title
  duration
  languageCode
  useV2ClosedCaptions
  footageSid
  chapters {
    sid
    status
    contentVersion
    thumbnailVersion
    cuePointType
    assetSid
  }
}
    `;
export const FullChapterFragmentDoc = gql`
    fragment fullChapter on Chapter {
  objectType
  sid
  version
  insertTime
  updateTime
  status
  key
  thumbnailVersion
  assetSid
  linkSid
  size
  contentVersion
  duration
  srcDuration
  configurationTime
  generatingTime
  aspectRatio
  name
  title
  cid
  index
  keyFramed
  formated
  transcripted
  highlighted
  detections {
    objectType
    sid
    version
    insertTime
    updateTime
    start
    end
    xCenterPercentage
    yCenterPercentage
  }
  faceDetected
  noiseReducted
  resized
  fitted
  verified
  masked
  resize {
    objectType
    sid
    version
    insertTime
    updateTime
    status
    key
    thumbnailVersion
    assetSid
    linkSid
    size
    contentVersion
    duration
    srcDuration
    configurationTime
    generatingTime
    aspectRatio
  }
  fit {
    objectType
    sid
    version
    insertTime
    updateTime
    status
    key
    thumbnailVersion
    assetSid
    linkSid
    size
    contentVersion
    duration
    srcDuration
    configurationTime
    generatingTime
    aspectRatio
  }
  mask {
    objectType
    sid
    version
    insertTime
    updateTime
    status
    key
    thumbnailVersion
    assetSid
    linkSid
    size
    contentVersion
    duration
    srcDuration
    configurationTime
    generatingTime
    aspectRatio
  }
  maskPreview {
    objectType
    sid
    version
    insertTime
    updateTime
    status
    key
    thumbnailVersion
    assetSid
    linkSid
    size
    contentVersion
    duration
    srcDuration
    configurationTime
    generatingTime
    aspectRatio
  }
  audio {
    objectType
    sid
    version
    insertTime
    updateTime
    status
    key
    thumbnailVersion
    assetSid
    linkSid
    size
    contentVersion
    duration
    srcDuration
    configurationTime
    generatingTime
    aspectRatio
  }
  offset
  externalVendor
  externalId
  mute
  disabled
  greenScreenColor
  clipFrom
  cuePointSid
  cuePointType
  image
}
    `;
export const FullSequenceFragmentDoc = gql`
    fragment fullSequence on Sequence {
  objectType
  sid
  version
  insertTime
  updateTime
  status
  useFootageForCrop
  editRules {
    objectType
    sid
    version
    insertTime
    updateTime
    status
    name
    useSpeakers
    useIntro
    useOutro
    useVideos
    useIcons
    useImages
    useTexts
    useSlides
    useLogo
    useMusic
    useHighlight
    useFrame
    volume
    noContentVolume
  }
  logo {
    objectType
    sid
    version
    insertTime
    updateTime
    status
    key
    thumbnailVersion
    assetSid
    linkSid
    name
    srcWidth
    srcHeight
    size
    top
    bottom
    left
    right
    removeWhiteBackground
    crop
    opacity
  }
  chapters {
    objectType
    sid
    version
    insertTime
    updateTime
    status
    key
    thumbnailVersion
    assetSid
    linkSid
    size
    contentVersion
    duration
    srcDuration
    configurationTime
    generatingTime
    aspectRatio
    name
    title
    cid
    index
    keyFramed
    formated
    transcripted
    highlighted
    detections {
      objectType
      sid
      version
      insertTime
      updateTime
      start
      end
      xCenterPercentage
      yCenterPercentage
    }
    faceDetected
    noiseReducted
    resized
    fitted
    verified
    masked
    resize {
      objectType
      sid
      version
      insertTime
      updateTime
      status
      key
      thumbnailVersion
      assetSid
      linkSid
      size
      contentVersion
      duration
      srcDuration
      configurationTime
      generatingTime
      aspectRatio
    }
    fit {
      objectType
      sid
      version
      insertTime
      updateTime
      status
      key
      thumbnailVersion
      assetSid
      linkSid
      size
      contentVersion
      duration
      srcDuration
      configurationTime
      generatingTime
      aspectRatio
    }
    mask {
      objectType
      sid
      version
      insertTime
      updateTime
      status
      key
      thumbnailVersion
      assetSid
      linkSid
      size
      contentVersion
      duration
      srcDuration
      configurationTime
      generatingTime
      aspectRatio
    }
    maskPreview {
      objectType
      sid
      version
      insertTime
      updateTime
      status
      key
      thumbnailVersion
      assetSid
      linkSid
      size
      contentVersion
      duration
      srcDuration
      configurationTime
      generatingTime
      aspectRatio
    }
    audio {
      objectType
      sid
      version
      insertTime
      updateTime
      status
      key
      thumbnailVersion
      assetSid
      linkSid
      size
      contentVersion
      duration
      srcDuration
      configurationTime
      generatingTime
      aspectRatio
    }
    offset
    externalVendor
    externalId
    mute
    disabled
    greenScreenColor
    clipFrom
    cuePointSid
    cuePointType
    image
  }
  colors {
    objectType
    sid
    version
    insertTime
    updateTime
    color
    rgb
    brightness
    brightnessIndex
    dominancy
    grayness
    percent
  }
  transcripted
  highlighted
  validated
  masked
  presetSid
  userSid
  width
  height
  aspectRatio
  altAspectRatios
  languageCode
  style {
    objectType
    sid
    version
    insertTime
    updateTime
    fontAssetSid
    captionsFontAssetSid
    introLogoAssetSid
    outroLogoAssetSid
    captionsRegularFileName
    captionsFontFamily
    textAssetSid
    slideAssetSid
    speakerAssetSid
    introAssetSid
    outroAssetSid
    transitionAssetSid
    frameAssetSid
    visualPackageSid
    backgroundOpacity
    fontSize
    fontWeight
    fontItalic
    fontFamily
    padding
    outlineWidth
    outlineStyle
    borderWidth
    borderStyle
    backgroundColor
    outlineColor
    borderColor
    foregroundColor
    imagesStyleName
    headerFontFamily
    headerFontAssetSid
    headerBoldFileName
    headerRegularFileName
    bodyBoldFileName
    bodyRegularFileName
    captionsVerticalAlign
    captionsStyleType
    captionsFontColor
    captionsFontColorIndex
    captionsStyleColor
    captionsStyleColorIndex
    captionsPosition
    depth
    layers
    perspective
    fade
    direction
    depthColor
    highlightColorIndex
    framePositionX
    framePositionY
    frameWidth
  }
  title
  music {
    objectType
    sid
    version
    insertTime
    updateTime
    status
    key
    thumbnailVersion
    assetSid
    linkSid
    size
    contentVersion
    duration
    srcDuration
    configurationTime
    generatingTime
    aspectRatio
    name
    description
    externalId
    credit
    creditRequired
    enabled
    downloadDate
    volume
    noContentVolume
    overrideVolume
  }
  audio {
    objectType
    sid
    version
    insertTime
    updateTime
    status
    key
    thumbnailVersion
    assetSid
    linkSid
    size
    contentVersion
    duration
    srcDuration
    configurationTime
    generatingTime
    aspectRatio
  }
  video {
    objectType
    sid
    version
    insertTime
    updateTime
    status
    key
    thumbnailVersion
    assetSid
    linkSid
    size
    contentVersion
    duration
    srcDuration
    configurationTime
    generatingTime
    aspectRatio
  }
  mask {
    objectType
    sid
    version
    insertTime
    updateTime
    status
    key
    thumbnailVersion
    assetSid
    linkSid
    size
    contentVersion
    duration
    srcDuration
    configurationTime
    generatingTime
    aspectRatio
  }
  output {
    objectType
    sid
    version
    insertTime
    updateTime
    status
    key
    thumbnailVersion
    assetSid
    linkSid
    size
    contentVersion
    duration
    srcDuration
    configurationTime
    generatingTime
    aspectRatio
  }
  useGreenScreen
  useDenoised
  useCaptions
  useV2ClosedCaptions
  captionsBackgroundOpacity
  useTitleCuePoints
  burnCaptions
  editRulesSid
  folderSid
  generatedType
  footageSid
  errorCause
  errorCode
  backgroundJobs {
    objectType
    sid
    version
    insertTime
    updateTime
    startTime
    type
    subType
    audioSid
  }
  duration
  scenes {
    ... on Chapter {
      objectType
      sid
      version
      insertTime
      updateTime
      status
      key
      thumbnailVersion
      assetSid
      linkSid
      size
      contentVersion
      duration
      srcDuration
      configurationTime
      generatingTime
      aspectRatio
      name
      title
      cid
      index
      keyFramed
      formated
      transcripted
      highlighted
      detections {
        objectType
        sid
        version
        insertTime
        updateTime
        start
        end
        xCenterPercentage
        yCenterPercentage
      }
      faceDetected
      noiseReducted
      resized
      fitted
      verified
      masked
      resize {
        objectType
        sid
        version
        insertTime
        updateTime
        status
        key
        thumbnailVersion
        assetSid
        linkSid
        size
        contentVersion
        duration
        srcDuration
        configurationTime
        generatingTime
        aspectRatio
      }
      fit {
        objectType
        sid
        version
        insertTime
        updateTime
        status
        key
        thumbnailVersion
        assetSid
        linkSid
        size
        contentVersion
        duration
        srcDuration
        configurationTime
        generatingTime
        aspectRatio
      }
      mask {
        objectType
        sid
        version
        insertTime
        updateTime
        status
        key
        thumbnailVersion
        assetSid
        linkSid
        size
        contentVersion
        duration
        srcDuration
        configurationTime
        generatingTime
        aspectRatio
      }
      maskPreview {
        objectType
        sid
        version
        insertTime
        updateTime
        status
        key
        thumbnailVersion
        assetSid
        linkSid
        size
        contentVersion
        duration
        srcDuration
        configurationTime
        generatingTime
        aspectRatio
      }
      audio {
        objectType
        sid
        version
        insertTime
        updateTime
        status
        key
        thumbnailVersion
        assetSid
        linkSid
        size
        contentVersion
        duration
        srcDuration
        configurationTime
        generatingTime
        aspectRatio
      }
      offset
      externalVendor
      externalId
      mute
      disabled
      greenScreenColor
      clipFrom
      cuePointSid
      cuePointType
      image
    }
  }
  role
  accessesCount
  audioGenerated
}
    `;
export const FullShopperFragmentDoc = gql`
    fragment fullShopper on Shopper {
  objectType
  sid
  version
  insertTime
  updateTime
  status
  shopperId
  userSid
  orgSid
  ccType
  exp
  lastDigits
  zip
  name
  fraudSessionId
  updateUrl
}
    `;
export const FullSpeakerCuePointFragmentDoc = gql`
    fragment fullSpeakerCuePoint on SpeakerCuePoint {
  sid
  objectType
  sid
  version
  insertTime
  updateTime
  status
  key
  thumbnailVersion
  assetSid
  linkSid
  size
  contentVersion
  duration
  srcDuration
  configurationTime
  generatingTime
  aspectRatio
  sequenceSid
  chapterSid
  type
  startTime
  endTime
  srcStartTime
  srcEndTime
  title
  opacity
  width
  height
  top
  bottom
  left
  right
  zIndex
  grayscale
  alignment
  animations {
    objectType
    sid
    version
    insertTime
    updateTime
    type
    kind
    start
    startValue
    endValue
    startX
    startY
    endX
    endY
    duration
    easing
  }
  externalId
  colors {
    objectType
    sid
    version
    insertTime
    updateTime
    name
    className
    type
    color
    colorIndex
  }
  assets {
    objectType
    sid
    version
    insertTime
    updateTime
    name
    className
    type
    assetSid
  }
  name
  nameColor
  titleColor
  nameColorIndex
  titleColorIndex
  nameBackgroundColor
  titleBackgroundColor
  nameBackgroundColorIndex
  titleBackgroundColorIndex
  index
  speakerSid
  speaker {
    objectType
    sid
    version
    insertTime
    updateTime
    status
    userSid
    orgSid
    name
    title
  }
}
    `;
export const FullSubscriptionFragmentDoc = gql`
    fragment fullSubscription on Subscription {
  objectType
  sid
  version
  insertTime
  updateTime
  status
  subscriptionId
  userSid
  orgSid
  nextChargeTime
  planSid
  recurringPrice
  chargeType
  couponSid
  taxId
  billingAddress
  billingEmail
  billingName
  monthlyPeriodStart
  lastActivationDate
  isCanceled
  freeTrialRemainingTime
  footageUploadsCount
}
    `;
export const FullUserFragmentDoc = gql`
    fragment fullUser on User {
  objectType
  sid
  version
  insertTime
  updateTime
  status
  uiFlags
  orgSid
  email
  resetToken
  firstName
  lastName
  role
  thumbUrl
  teamTypeSid
  orgName
  orgUrl
  orgIndustry
  orgNumOfEmpolyees
  fontFamily
  roleSid
  resetUrl
  cacheVersion
  department
  userPurpose
  onboardingFinished
  languageCode
}
    `;
export const FullVideoTypeFragmentDoc = gql`
    fragment fullVideoType on VideoType {
  sid
  objectType
  sid
  version
  insertTime
  updateTime
  status
  name
  description
  editRulesSid
  order
  icon
}
    `;
export const GetAssetsDocument = gql`
    query getAssets($filter: AssetFilter, $pager: PagerAdd) {
  asset {
    list(filter: $filter, pager: $pager) {
      ...fullAsset
    }
  }
}
    ${FullAssetFragmentDoc}`;
export const GetAssetDocument = gql`
    query getAsset($sid: String) {
  asset(sid: $sid) {
    ...fullAsset
  }
}
    ${FullAssetFragmentDoc}`;
export const CreateAssetDocument = gql`
    mutation createAsset($type: Int!, $name: String!) {
  asset {
    add(values: {type: $type, name: $name}) {
      ...fullAsset
    }
  }
}
    ${FullAssetFragmentDoc}`;
export const UpdateAssetDocument = gql`
    mutation updateAsset($sid: String!, $name: String, $languageCode: String) {
  asset {
    update(sid: $sid, values: {name: $name, languageCode: $languageCode}) {
      ...fullAsset
    }
  }
}
    ${FullAssetFragmentDoc}`;
export const GetBoardsDocument = gql`
    query getBoards($paging: OffsetPaging!, $filter: BoardFilter!, $sorting: [BoardSort!]!) {
  boards(paging: $paging, filter: $filter, sorting: $sorting) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    nodes {
      id
      createdAt
      updatedAt
      ownerSid
      ownerType
      createdBy
      name
      parentBoardIds
      footageIds
      boardIds
    }
  }
}
    `;
export const CreateBoardDocument = gql`
    mutation createBoard($input: CreateOneBoardInput!) {
  createOneBoard(input: $input) {
    id
    createdAt
    updatedAt
    ownerSid
    ownerType
    createdBy
    name
    parentBoardIds
    footageIds
    boardIds
  }
}
    `;
export const UpdateBoardDocument = gql`
    mutation updateBoard($input: UpdateOneBoardInput!) {
  updateOneBoard(input: $input) {
    id
    createdAt
    updatedAt
    ownerSid
    ownerType
    createdBy
    name
    parentBoardIds
    footageIds
    boardIds
  }
}
    `;
export const DeleteBoardDocument = gql`
    mutation deleteBoard($input: DeleteOneBoardInput!) {
  deleteOneBoard(input: $input) {
    id
    createdAt
    updatedAt
    ownerSid
    ownerType
    createdBy
    name
    parentBoardIds
    footageIds
    boardIds
  }
}
    `;
export const MoveFootageToBoardDocument = gql`
    mutation moveFootageToBoard($footageId: String!, $boardId: String!) {
  moveFootageToBoard(footageId: $footageId, boardId: $boardId)
}
    `;
export const RemoveFootageFromBoardDocument = gql`
    mutation removeFootageFromBoard($footageId: String!) {
  removeFootageFromBoard(footageId: $footageId)
}
    `;
export const UpdateWordsDocument = gql`
    mutation updateWords($sequenceSid: String!, $words: [WordUpdate!]!) {
  closedCaption {
    updateWords(sequenceSid: $sequenceSid, words: $words)
  }
}
    `;
export const GetCropDetailsDocument = gql`
    query getCropDetails($externalSequenceSid: String!, $outputAspectRatio: String!) {
  cropDetails(
    filter: {externalSequenceSid: {eq: $externalSequenceSid}, outputAspectRatio: {eq: $outputAspectRatio}}
  ) {
    nodes {
      externalAssetSid
      originalAspectRatio
      outputWidth
      outputHeight
      color
      brandColorIndex
      blur
      cropData {
        start
        end
        crop {
          width
          height
          topx
          topy
        }
        draw {
          width
          height
          topx
          topy
        }
      }
    }
  }
}
    `;
export const UpdateAssetCropDataDocument = gql`
    mutation updateAssetCropData($externalSequenceSid: String!, $externalAssetSid: String!, $outputAspectRatio: String!, $cropData: [CropDataUpdate!]!) {
  updateAssetCropData(
    externalSequenceSid: $externalSequenceSid
    externalAssetSid: $externalAssetSid
    outputAspectRatio: $outputAspectRatio
    cropData: $cropData
  ) {
    originalAspectRatio
    outputWidth
    outputHeight
    color
    brandColorIndex
    blur
    cropData {
      start
      end
      crop {
        width
        height
        topx
        topy
      }
      draw {
        width
        height
        topx
        topy
      }
    }
  }
}
    `;
export const UpdateBackgroundDesignDocument = gql`
    mutation updateBackgroundDesign($externalSequenceSid: String!, $color: String!, $brandColorIndex: Int, $blur: Boolean!) {
  updateBackgroundDesign(
    externalSequenceSid: $externalSequenceSid
    color: $color
    brandColorIndex: $brandColorIndex
    blur: $blur
  )
}
    `;
export const GetBalanceDocument = gql`
    query getBalance {
  getDownloadsBalance {
    periodMaxDownloads
    periodLeftDownloads
    periodStartTime
    periodEndTime
  }
}
    `;
export const GetDownloadInfoDocument = gql`
    query getDownloadInfo($id: ID!) {
  downloadInfo(id: $id) {
    ...leanDownloadInfo
  }
}
    ${LeanDownloadInfoFragmentDoc}`;
export const GetDownloadInfosDocument = gql`
    query getDownloadInfos($paging: OffsetPaging!, $filter: DownloadInfoFilter!, $sorting: [DownloadInfoSort!]!) {
  downloadInfos(paging: $paging, filter: $filter, sorting: $sorting) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    nodes {
      ...leanDownloadInfo
    }
  }
}
    ${LeanDownloadInfoFragmentDoc}`;
export const GetEditRulesDocument = gql`
    query getEditRules {
  editRules {
    list(filter: null, pager: null) {
      ...fullEditRules
    }
  }
}
    ${FullEditRulesFragmentDoc}`;
export const GetFolderStructuresDocument = gql`
    query getFolderStructures($type: Int!) {
  folderStructure {
    list(filter: {typeEqual: $type}, pager: null) {
      sid
      objectType
      sid
      version
      insertTime
      updateTime
      status
      userSid
      type
      parentSid
      systemId
      name
    }
  }
}
    `;
export const GetFootagesDocument = gql`
    query getFootages($paging: OffsetPaging!, $filter: FootageFilter!, $sorting: [FootageSort!]!) {
  footages(paging: $paging, filter: $filter, sorting: $sorting) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    nodes {
      ...leanFootage
    }
  }
}
    ${LeanFootageFragmentDoc}`;
export const GetFootagesByBoardIdDocument = gql`
    query getFootagesByBoardId($paging: OffsetPaging!, $filter: FootageFilter!, $sorting: [FootageSort!]!, $boardId: String!) {
  getFootagesByBoardId(
    paging: $paging
    filter: $filter
    sorting: $sorting
    boardId: $boardId
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    nodes {
      ...leanFootage
    }
  }
}
    ${LeanFootageFragmentDoc}`;
export const GetFootageWithClipSequenceFavoritesDocument = gql`
    query getFootageWithClipSequenceFavorites($id: String!) {
  footageWithClipSequenceFavorites(id: $id) {
    ...leanFootage
  }
}
    ${LeanFootageFragmentDoc}`;
export const GetFootageTranscriptDocument = gql`
    query getFootageTranscript($id: String!) {
  footageWithClipSequenceFavorites(id: $id) {
    ...transcriptFootage
  }
}
    ${TranscriptFootageFragmentDoc}`;
export const CreateFootageDocument = gql`
    mutation createFootage($input: CreateOneFootageInput!) {
  createOneFootage(input: $input) {
    ...leanFootage
  }
}
    ${LeanFootageFragmentDoc}`;
export const UpdateFootageDocument = gql`
    mutation updateFootage($input: UpdateOneFootageInput!) {
  updateOneFootage(input: $input) {
    ...leanFootage
  }
}
    ${LeanFootageFragmentDoc}`;
export const GenerateFootageUploaderUrlDocument = gql`
    mutation generateFootageUploaderUrl($id: String!) {
  generateUploadUrl(id: $id)
}
    `;
export const DeleteFootageDocument = gql`
    mutation deleteFootage($input: DeleteOneFootageInput!) {
  deleteOneFootage(input: $input) {
    id
  }
}
    `;
export const UpdateClipSequenceDocument = gql`
    mutation updateClipSequence($footageId: String!, $clipId: String!, $id: String!, $update: ClipSequenceUpdate!) {
  updateClipSequence(
    footageId: $footageId
    clipId: $clipId
    id: $id
    update: $update
  ) {
    id
    title
    languageCode
    type
    status
    externalSequenceId
    ratio
    favorite
  }
}
    `;
export const DeleteClipSequenceDocument = gql`
    mutation deleteClipSequence($footageId: String!, $clipId: String!, $id: String!) {
  deleteClipSequence(footageId: $footageId, clipId: $clipId, id: $id) {
    id
  }
}
    `;
export const CloneClipSequenceDocument = gql`
    mutation cloneClipSequence($footageId: String!, $clipId: String!, $id: String!, $input: ClipSequenceCloneInput!) {
  cloneClipSequence(
    footageId: $footageId
    clipId: $clipId
    id: $id
    input: $input
  ) {
    id
  }
}
    `;
export const ReplaceExampleClipSequenceDocument = gql`
    mutation replaceExampleClipSequence($footageId: String!, $clipId: String!, $id: String!) {
  replaceExampleClipSequence(footageId: $footageId, clipId: $clipId, id: $id) {
    id
    externalSequenceId
  }
}
    `;
export const TranslateClipSequenceDocument = gql`
    mutation translateClipSequence($footageId: String!, $clipId: String!, $id: String!, $input: ClipSequenceTranslateInput!) {
  translateClipSequence(
    footageId: $footageId
    clipId: $clipId
    id: $id
    input: $input
  ) {
    id
  }
}
    `;
export const RenameClipSequenceDocument = gql`
    mutation renameClipSequence($footageId: String!, $clipId: String!, $id: String!, $input: ClipSequenceRenameInput!) {
  renameClipSequence(
    footageId: $footageId
    clipId: $clipId
    id: $id
    input: $input
  ) {
    id
  }
}
    `;
export const AddClipSequenceFavoriteDocument = gql`
    mutation addClipSequenceFavorite($footageId: String!, $clipId: String!, $id: String!) {
  addClipSequenceFavorite(footageId: $footageId, clipId: $clipId, id: $id) {
    id
    favorite
  }
}
    `;
export const DeleteClipSequenceFavoriteDocument = gql`
    mutation deleteClipSequenceFavorite($footageId: String!, $clipId: String!, $id: String!) {
  deleteClipSequenceFavorite(footageId: $footageId, clipId: $clipId, id: $id) {
    id
    favorite
  }
}
    `;
export const InteractClipSequenceDocument = gql`
    mutation interactClipSequence($footageId: String!, $externalSequenceId: String!, $sequenceInteraction: SequenceInteraction!) {
  interactClipSequence(
    footageId: $footageId
    externalSequenceId: $externalSequenceId
    sequenceInteraction: $sequenceInteraction
  ) {
    ...clipSequence
  }
}
    ${ClipSequenceFragmentDoc}`;
export const SplitFootageByUserTimestampsDocument = gql`
    mutation splitFootageByUserTimestamps($input: ClipByTimestampsInput!) {
  splitFootageByUserTimestamps(input: $input)
}
    `;
export const GetPlansDocument = gql`
    query getPlans($filter: PlanFilter) {
  plan {
    list(filter: $filter, pager: null) {
      ...fullPlan
    }
  }
}
    ${FullPlanFragmentDoc}`;
export const GetPlanDocument = gql`
    query getPlan {
  plan(sid: null) {
    ...fullPlan
  }
}
    ${FullPlanFragmentDoc}`;
export const SelectPlanDocument = gql`
    mutation selectPlan($planSid: String!, $chargeType: Int!) {
  plan(sid: $planSid) {
    select(subscriptionDetailts: {chargeType: $chargeType}) {
      ...fullSubscription
    }
  }
}
    ${FullSubscriptionFragmentDoc}`;
export const GetPresetsDocument = gql`
    query getPresets {
  preset {
    list(filter: null, pager: null) {
      ...fullPreset
    }
  }
}
    ${FullPresetFragmentDoc}`;
export const CreatePresetDocument = gql`
    mutation createPreset($name: String, $assets: [AssetUsageAdd!], $colors: [ColorAdd!], $defaultVisualPackage: String, $exampleAsset: Boolean, $headerFontFamily: String, $headerBoldVariant: String, $headerRegularVariant: String, $defaultVideoType: String, $editRules: EditRulesAdd) {
  preset {
    add(
      values: {name: $name, assets: $assets, colors: $colors, defaultVisualPackage: $defaultVisualPackage, exampleAsset: $exampleAsset, headerFontFamily: $headerFontFamily, headerBoldVariant: $headerBoldVariant, headerRegularVariant: $headerRegularVariant, defaultVideoType: $defaultVideoType, editRules: $editRules}
    ) {
      ...fullPreset
    }
  }
}
    ${FullPresetFragmentDoc}`;
export const UpdatePresetDocument = gql`
    mutation updatePreset($sid: String!, $values: PresetUpdate) {
  preset {
    update(sid: $sid, values: $values) {
      ...fullPreset
    }
  }
}
    ${FullPresetFragmentDoc}`;
export const DeletePresetDocument = gql`
    mutation deletePreset($sid: String!) {
  preset {
    remove(sid: $sid)
  }
}
    `;
export const SetDefaultPresetDocument = gql`
    mutation setDefaultPreset($sid: String!) {
  preset(sid: $sid) {
    setDefault {
      ...fullPreset
    }
  }
}
    ${FullPresetFragmentDoc}`;
export const GetSequencesDocument = gql`
    query getSequences($filter: SequenceFilter!, $pager: PagerAdd!) {
  sequence {
    list(filter: $filter, pager: $pager) {
      ...leanSequence
    }
  }
}
    ${LeanSequenceFragmentDoc}`;
export const GetSequenceDocument = gql`
    query getSequence($sequenceSid: String!) {
  sequence(sid: $sequenceSid) {
    ...fullSequence
  }
}
    ${FullSequenceFragmentDoc}`;
export const GetSequencesByFootageIdDocument = gql`
    query getSequencesByFootageId($footageId: String) {
  sequence {
    list(filter: {footageSidEqual: $footageId}) {
      ...leanSequence
    }
  }
}
    ${LeanSequenceFragmentDoc}`;
export const GetSequenceProcessingStatusPropsDocument = gql`
    query getSequenceProcessingStatusProps($sequenceSid: String!) {
  sequence(sid: $sequenceSid) {
    sid
    status
    chapters {
      cuePointType
      faceDetected
    }
    editRules {
      useSpeakers
    }
  }
}
    `;
export const CreateSequenceDocument = gql`
    mutation createSequence($values: SequenceAdd!) {
  sequence {
    add(values: $values) {
      ...fullSequence
    }
  }
}
    ${FullSequenceFragmentDoc}`;
export const UpdateSequenceDocument = gql`
    mutation updateSequence($sid: String!, $values: SequenceUpdate!) {
  sequence {
    update(sid: $sid, values: $values) {
      ...fullSequence
    }
  }
}
    ${FullSequenceFragmentDoc}`;
export const ApplyPresetToSequenceDocument = gql`
    mutation applyPresetToSequence($userSid: String!, $sequenceSid: String!, $presetSid: String!) {
  sequence {
    updatePreset(
      userSid: $userSid
      sequenceSid: $sequenceSid
      presetSid: $presetSid
    ) {
      sid
    }
  }
}
    `;
export const ValidateInputsDocument = gql`
    mutation validateInputs($sequenceSid: String!) {
  sequence(sid: $sequenceSid) {
    validateInputs {
      ...fullSequence
    }
  }
}
    ${FullSequenceFragmentDoc}`;
export const ReorderSequenceChaptersDocument = gql`
    mutation reorderSequenceChapters($sequenceSid: String!, $chapters: [ChapterOrder!]!) {
  sequence(sid: $sequenceSid) {
    reorderScenes(scenes: $chapters) {
      ...fullSequence
    }
  }
}
    ${FullSequenceFragmentDoc}`;
export const AddChapterDocument = gql`
    mutation addChapter($sequenceSid: String!, $chapter: ChapterAdd!) {
  sequence(sid: $sequenceSid) {
    addChapter(chapter: $chapter) {
      ...fullChapter
    }
  }
}
    ${FullChapterFragmentDoc}`;
export const CreateSequenceFromTemplateDocument = gql`
    mutation createSequenceFromTemplate {
  sequence {
    createFromTemplate {
      ...fullSequence
    }
  }
}
    ${FullSequenceFragmentDoc}`;
export const RenameSequenceDocument = gql`
    mutation renameSequence($sequenceSid: String!, $title: String) {
  sequence {
    update(sid: $sequenceSid, values: {title: $title}) {
      sid
      title
    }
  }
}
    `;
export const DeleteSequenceDocument = gql`
    mutation deleteSequence($sequenceSid: String!) {
  sequence {
    remove(sid: $sequenceSid)
  }
}
    `;
export const DuplicateSequenceDocument = gql`
    mutation duplicateSequence($sequenceSid: String!, $userSid: String!, $aspectRatio: String!, $languageCode: String) {
  sequence {
    clone(
      sid: $sequenceSid
      userSid: $userSid
      aspectRatio: $aspectRatio
      languageCode: $languageCode
    ) {
      sid
    }
  }
}
    `;
export const GetSequenceCaptionsDocument = gql`
    query getSequenceCaptions($sequenceSid: String!) {
  closedCaption {
    listWords(sequenceSid: $sequenceSid, chapterSid: null) {
      word
      startTime
      endTime
      newLine
      highlight
      flags
      chapterSid
    }
  }
}
    `;
export const GetV2SequenceCaptionsDocument = gql`
    query getV2SequenceCaptions($sequenceSid: String!, $chapterSid: String) {
  closedCaptions(query: {sequenceSid: $sequenceSid, chapterSid: $chapterSid}) {
    syncWithTranscript
    contentVersion
  }
}
    `;
export const RegenerateSequenceCaptionsDocument = gql`
    mutation regenerateSequenceCaptions($sequenceSid: String!) {
  regenerateClosedCaptions(sequenceSid: $sequenceSid, chapterSid: null) {
    words {
      word
      startTime
      endTime
      newLine
      highlight
      flags
      chapterSid
    }
  }
}
    `;
export const UnsyncClosedCaptionsWithTranscriptDocument = gql`
    mutation unsyncClosedCaptionsWithTranscript($sequenceSid: String!) {
  unsyncClosedCaptionsWithTranscript(sequenceSid: $sequenceSid) {
    syncWithTranscript
  }
}
    `;
export const GetShopperDocument = gql`
    query getShopper {
  shopper(sid: null) {
    ...fullShopper
  }
}
    ${FullShopperFragmentDoc}`;
export const GetSpeakerCuePointsDocument = gql`
    query getSpeakerCuePoints($sequenceSid: String) {
  speakerCuePoint {
    list(filter: {sequenceSidEqual: $sequenceSid}, pager: null) {
      ...fullSpeakerCuePoint
    }
  }
}
    ${FullSpeakerCuePointFragmentDoc}`;
export const UpdateSpeakerCuePointDocument = gql`
    mutation updateSpeakerCuePoint($sid: String!, $sequenceSid: String!, $values: SpeakerCuePointUpdate!) {
  speakerCuePoint(sequenceSid: $sequenceSid) {
    update(sid: $sid, values: $values) {
      sid
    }
  }
}
    `;
export const RemoveSpeakerCuePointDocument = gql`
    mutation removeSpeakerCuePoint($sid: String!, $sequenceSid: String!) {
  speakerCuePoint(sequenceSid: $sequenceSid) {
    remove(sid: $sid)
  }
}
    `;
export const ActivateSpeakerCuePointDocument = gql`
    mutation activateSpeakerCuePoint($sid: String!, $sequenceSid: String!) {
  speakerCuePoint(sequenceSid: $sequenceSid, sid: $sid) {
    activate
  }
}
    `;
export const DeactivateSpeakerCuePointDocument = gql`
    mutation deactivateSpeakerCuePoint($sid: String!, $sequenceSid: String!) {
  speakerCuePoint(sequenceSid: $sequenceSid, sid: $sid) {
    deactivate
  }
}
    `;
export const GetSubscriptionDocument = gql`
    query getSubscription {
  subscription(sid: null) {
    ...fullSubscription
  }
}
    ${FullSubscriptionFragmentDoc}`;
export const GetUserDocument = gql`
    query getUser {
  user(sid: null) {
    ...fullUser
  }
}
    ${FullUserFragmentDoc}`;
export const CreateUserDocument = gql`
    mutation createUser($email: String!, $signupCampaign: String) {
  user {
    add(values: {email: $email, signupCampaign: $signupCampaign}) {
      ...fullUser
    }
  }
}
    ${FullUserFragmentDoc}`;
export const UpdateUserDocument = gql`
    mutation updateUser($userSid: String!, $department: String, $userPurpose: String, $orgName: String, $orgUrl: String, $firstName: String, $lastName: String, $onboardingFinished: Boolean, $signupCampaign: String) {
  user {
    update(
      sid: $userSid
      values: {department: $department, userPurpose: $userPurpose, orgName: $orgName, orgUrl: $orgUrl, firstName: $firstName, lastName: $lastName, onboardingFinished: $onboardingFinished, signupCampaign: $signupCampaign}
    ) {
      ...fullUser
    }
  }
}
    ${FullUserFragmentDoc}`;
export const LoginUserDocument = gql`
    query loginUser($email: String!, $password: String!) {
  user {
    login(email: $email, password: $password)
  }
}
    `;
export const LoginUserOAuthDocument = gql`
    query loginUserOAuth($provider: String!, $providerToken: String!, $signupCampaign: String) {
  user {
    verifyLogin(
      token: $providerToken
      provider: $provider
      signupCampaign: $signupCampaign
    )
  }
}
    `;
export const UpdateUserPasswordDocument = gql`
    query updateUserPassword($email: String!, $password: String!, $token: String!) {
  user {
    setPassword(email: $email, password: $password, token: $token)
  }
}
    `;
export const ResetUserPasswordDocument = gql`
    mutation resetUserPassword($email: String!) {
  user {
    requestResetPassword(email: $email)
  }
}
    `;
export const GetVideoTypesDocument = gql`
    query getVideoTypes($filter: VideoTypeFilter, $pager: PagerAdd) {
  videoType {
    list(filter: $filter, pager: $pager) {
      ...fullVideoType
    }
  }
}
    ${FullVideoTypeFragmentDoc}`;
export const GetWordsByExternalAssetIdDocument = gql`
    query getWordsByExternalAssetId($footageId: String!, $externalAssetSid: String!) {
  getWordsByExternalAssetId(
    footageId: $footageId
    externalAssetSid: $externalAssetSid
  ) {
    words {
      word
      startTime
      endTime
      confidence
      alt
      version
      highlight
    }
    durationMs
  }
}
    `;
export const UpdateBulkOfWordsInTranscriptDocument = gql`
    mutation updateBulkOfWordsInTranscript($footageId: String!, $input: BulkOfWordsUpdate!) {
  updateBulkOfWordsInTranscript(footageId: $footageId, update: $input) {
    words {
      word
      startTime
      endTime
      version
      highlight
    }
    text
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    getAssets(variables?: GetAssetsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetAssetsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAssetsQuery>(GetAssetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAssets', 'query');
    },
    getAsset(variables?: GetAssetQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetAssetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAssetQuery>(GetAssetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAsset', 'query');
    },
    createAsset(variables: CreateAssetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateAssetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAssetMutation>(CreateAssetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAsset', 'mutation');
    },
    updateAsset(variables: UpdateAssetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateAssetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAssetMutation>(UpdateAssetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAsset', 'mutation');
    },
    getBoards(variables: GetBoardsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetBoardsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBoardsQuery>(GetBoardsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBoards', 'query');
    },
    createBoard(variables: CreateBoardMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateBoardMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateBoardMutation>(CreateBoardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createBoard', 'mutation');
    },
    updateBoard(variables: UpdateBoardMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateBoardMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateBoardMutation>(UpdateBoardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateBoard', 'mutation');
    },
    deleteBoard(variables: DeleteBoardMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteBoardMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteBoardMutation>(DeleteBoardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteBoard', 'mutation');
    },
    moveFootageToBoard(variables: MoveFootageToBoardMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MoveFootageToBoardMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MoveFootageToBoardMutation>(MoveFootageToBoardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'moveFootageToBoard', 'mutation');
    },
    removeFootageFromBoard(variables: RemoveFootageFromBoardMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveFootageFromBoardMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveFootageFromBoardMutation>(RemoveFootageFromBoardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeFootageFromBoard', 'mutation');
    },
    updateWords(variables: UpdateWordsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateWordsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateWordsMutation>(UpdateWordsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateWords', 'mutation');
    },
    getCropDetails(variables: GetCropDetailsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetCropDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCropDetailsQuery>(GetCropDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCropDetails', 'query');
    },
    updateAssetCropData(variables: UpdateAssetCropDataMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateAssetCropDataMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAssetCropDataMutation>(UpdateAssetCropDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAssetCropData', 'mutation');
    },
    updateBackgroundDesign(variables: UpdateBackgroundDesignMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateBackgroundDesignMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateBackgroundDesignMutation>(UpdateBackgroundDesignDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateBackgroundDesign', 'mutation');
    },
    getBalance(variables?: GetBalanceQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetBalanceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBalanceQuery>(GetBalanceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBalance', 'query');
    },
    getDownloadInfo(variables: GetDownloadInfoQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetDownloadInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDownloadInfoQuery>(GetDownloadInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getDownloadInfo', 'query');
    },
    getDownloadInfos(variables: GetDownloadInfosQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetDownloadInfosQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDownloadInfosQuery>(GetDownloadInfosDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getDownloadInfos', 'query');
    },
    getEditRules(variables?: GetEditRulesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetEditRulesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetEditRulesQuery>(GetEditRulesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getEditRules', 'query');
    },
    getFolderStructures(variables: GetFolderStructuresQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetFolderStructuresQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetFolderStructuresQuery>(GetFolderStructuresDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getFolderStructures', 'query');
    },
    getFootages(variables: GetFootagesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetFootagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetFootagesQuery>(GetFootagesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getFootages', 'query');
    },
    getFootagesByBoardId(variables: GetFootagesByBoardIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetFootagesByBoardIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetFootagesByBoardIdQuery>(GetFootagesByBoardIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getFootagesByBoardId', 'query');
    },
    getFootageWithClipSequenceFavorites(variables: GetFootageWithClipSequenceFavoritesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetFootageWithClipSequenceFavoritesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetFootageWithClipSequenceFavoritesQuery>(GetFootageWithClipSequenceFavoritesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getFootageWithClipSequenceFavorites', 'query');
    },
    getFootageTranscript(variables: GetFootageTranscriptQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetFootageTranscriptQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetFootageTranscriptQuery>(GetFootageTranscriptDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getFootageTranscript', 'query');
    },
    createFootage(variables: CreateFootageMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateFootageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateFootageMutation>(CreateFootageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createFootage', 'mutation');
    },
    updateFootage(variables: UpdateFootageMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateFootageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateFootageMutation>(UpdateFootageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateFootage', 'mutation');
    },
    generateFootageUploaderUrl(variables: GenerateFootageUploaderUrlMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GenerateFootageUploaderUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateFootageUploaderUrlMutation>(GenerateFootageUploaderUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateFootageUploaderUrl', 'mutation');
    },
    deleteFootage(variables: DeleteFootageMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteFootageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteFootageMutation>(DeleteFootageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteFootage', 'mutation');
    },
    updateClipSequence(variables: UpdateClipSequenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateClipSequenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateClipSequenceMutation>(UpdateClipSequenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateClipSequence', 'mutation');
    },
    deleteClipSequence(variables: DeleteClipSequenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteClipSequenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteClipSequenceMutation>(DeleteClipSequenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteClipSequence', 'mutation');
    },
    cloneClipSequence(variables: CloneClipSequenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CloneClipSequenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CloneClipSequenceMutation>(CloneClipSequenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'cloneClipSequence', 'mutation');
    },
    replaceExampleClipSequence(variables: ReplaceExampleClipSequenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ReplaceExampleClipSequenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReplaceExampleClipSequenceMutation>(ReplaceExampleClipSequenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'replaceExampleClipSequence', 'mutation');
    },
    translateClipSequence(variables: TranslateClipSequenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<TranslateClipSequenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TranslateClipSequenceMutation>(TranslateClipSequenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'translateClipSequence', 'mutation');
    },
    renameClipSequence(variables: RenameClipSequenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RenameClipSequenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RenameClipSequenceMutation>(RenameClipSequenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'renameClipSequence', 'mutation');
    },
    addClipSequenceFavorite(variables: AddClipSequenceFavoriteMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddClipSequenceFavoriteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddClipSequenceFavoriteMutation>(AddClipSequenceFavoriteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addClipSequenceFavorite', 'mutation');
    },
    deleteClipSequenceFavorite(variables: DeleteClipSequenceFavoriteMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteClipSequenceFavoriteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteClipSequenceFavoriteMutation>(DeleteClipSequenceFavoriteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteClipSequenceFavorite', 'mutation');
    },
    interactClipSequence(variables: InteractClipSequenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InteractClipSequenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InteractClipSequenceMutation>(InteractClipSequenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'interactClipSequence', 'mutation');
    },
    splitFootageByUserTimestamps(variables: SplitFootageByUserTimestampsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SplitFootageByUserTimestampsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SplitFootageByUserTimestampsMutation>(SplitFootageByUserTimestampsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'splitFootageByUserTimestamps', 'mutation');
    },
    getPlans(variables?: GetPlansQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPlansQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPlansQuery>(GetPlansDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPlans', 'query');
    },
    getPlan(variables?: GetPlanQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPlanQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPlanQuery>(GetPlanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPlan', 'query');
    },
    selectPlan(variables: SelectPlanMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SelectPlanMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SelectPlanMutation>(SelectPlanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'selectPlan', 'mutation');
    },
    getPresets(variables?: GetPresetsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPresetsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPresetsQuery>(GetPresetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPresets', 'query');
    },
    createPreset(variables?: CreatePresetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreatePresetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePresetMutation>(CreatePresetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createPreset', 'mutation');
    },
    updatePreset(variables: UpdatePresetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdatePresetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePresetMutation>(UpdatePresetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePreset', 'mutation');
    },
    deletePreset(variables: DeletePresetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeletePresetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePresetMutation>(DeletePresetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deletePreset', 'mutation');
    },
    setDefaultPreset(variables: SetDefaultPresetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SetDefaultPresetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetDefaultPresetMutation>(SetDefaultPresetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setDefaultPreset', 'mutation');
    },
    getSequences(variables: GetSequencesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetSequencesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSequencesQuery>(GetSequencesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSequences', 'query');
    },
    getSequence(variables: GetSequenceQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetSequenceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSequenceQuery>(GetSequenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSequence', 'query');
    },
    getSequencesByFootageId(variables?: GetSequencesByFootageIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetSequencesByFootageIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSequencesByFootageIdQuery>(GetSequencesByFootageIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSequencesByFootageId', 'query');
    },
    getSequenceProcessingStatusProps(variables: GetSequenceProcessingStatusPropsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetSequenceProcessingStatusPropsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSequenceProcessingStatusPropsQuery>(GetSequenceProcessingStatusPropsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSequenceProcessingStatusProps', 'query');
    },
    createSequence(variables: CreateSequenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateSequenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSequenceMutation>(CreateSequenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createSequence', 'mutation');
    },
    updateSequence(variables: UpdateSequenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateSequenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSequenceMutation>(UpdateSequenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateSequence', 'mutation');
    },
    applyPresetToSequence(variables: ApplyPresetToSequenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ApplyPresetToSequenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplyPresetToSequenceMutation>(ApplyPresetToSequenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'applyPresetToSequence', 'mutation');
    },
    validateInputs(variables: ValidateInputsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ValidateInputsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ValidateInputsMutation>(ValidateInputsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'validateInputs', 'mutation');
    },
    reorderSequenceChapters(variables: ReorderSequenceChaptersMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ReorderSequenceChaptersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReorderSequenceChaptersMutation>(ReorderSequenceChaptersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reorderSequenceChapters', 'mutation');
    },
    addChapter(variables: AddChapterMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddChapterMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddChapterMutation>(AddChapterDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addChapter', 'mutation');
    },
    createSequenceFromTemplate(variables?: CreateSequenceFromTemplateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateSequenceFromTemplateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSequenceFromTemplateMutation>(CreateSequenceFromTemplateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createSequenceFromTemplate', 'mutation');
    },
    renameSequence(variables: RenameSequenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RenameSequenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RenameSequenceMutation>(RenameSequenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'renameSequence', 'mutation');
    },
    deleteSequence(variables: DeleteSequenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteSequenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteSequenceMutation>(DeleteSequenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteSequence', 'mutation');
    },
    duplicateSequence(variables: DuplicateSequenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DuplicateSequenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DuplicateSequenceMutation>(DuplicateSequenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'duplicateSequence', 'mutation');
    },
    getSequenceCaptions(variables: GetSequenceCaptionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetSequenceCaptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSequenceCaptionsQuery>(GetSequenceCaptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSequenceCaptions', 'query');
    },
    getV2SequenceCaptions(variables: GetV2SequenceCaptionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetV2SequenceCaptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetV2SequenceCaptionsQuery>(GetV2SequenceCaptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getV2SequenceCaptions', 'query');
    },
    regenerateSequenceCaptions(variables: RegenerateSequenceCaptionsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RegenerateSequenceCaptionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegenerateSequenceCaptionsMutation>(RegenerateSequenceCaptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'regenerateSequenceCaptions', 'mutation');
    },
    unsyncClosedCaptionsWithTranscript(variables: UnsyncClosedCaptionsWithTranscriptMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UnsyncClosedCaptionsWithTranscriptMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnsyncClosedCaptionsWithTranscriptMutation>(UnsyncClosedCaptionsWithTranscriptDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unsyncClosedCaptionsWithTranscript', 'mutation');
    },
    getShopper(variables?: GetShopperQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetShopperQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetShopperQuery>(GetShopperDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getShopper', 'query');
    },
    getSpeakerCuePoints(variables?: GetSpeakerCuePointsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetSpeakerCuePointsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSpeakerCuePointsQuery>(GetSpeakerCuePointsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSpeakerCuePoints', 'query');
    },
    updateSpeakerCuePoint(variables: UpdateSpeakerCuePointMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateSpeakerCuePointMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSpeakerCuePointMutation>(UpdateSpeakerCuePointDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateSpeakerCuePoint', 'mutation');
    },
    removeSpeakerCuePoint(variables: RemoveSpeakerCuePointMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveSpeakerCuePointMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveSpeakerCuePointMutation>(RemoveSpeakerCuePointDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeSpeakerCuePoint', 'mutation');
    },
    activateSpeakerCuePoint(variables: ActivateSpeakerCuePointMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ActivateSpeakerCuePointMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivateSpeakerCuePointMutation>(ActivateSpeakerCuePointDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'activateSpeakerCuePoint', 'mutation');
    },
    deactivateSpeakerCuePoint(variables: DeactivateSpeakerCuePointMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeactivateSpeakerCuePointMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeactivateSpeakerCuePointMutation>(DeactivateSpeakerCuePointDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deactivateSpeakerCuePoint', 'mutation');
    },
    getSubscription(variables?: GetSubscriptionQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetSubscriptionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSubscriptionQuery>(GetSubscriptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSubscription', 'query');
    },
    getUser(variables?: GetUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserQuery>(GetUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUser', 'query');
    },
    createUser(variables: CreateUserMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateUserMutation>(CreateUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createUser', 'mutation');
    },
    updateUser(variables: UpdateUserMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserMutation>(UpdateUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUser', 'mutation');
    },
    loginUser(variables: LoginUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<LoginUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginUserQuery>(LoginUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'loginUser', 'query');
    },
    loginUserOAuth(variables: LoginUserOAuthQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<LoginUserOAuthQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginUserOAuthQuery>(LoginUserOAuthDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'loginUserOAuth', 'query');
    },
    updateUserPassword(variables: UpdateUserPasswordQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateUserPasswordQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserPasswordQuery>(UpdateUserPasswordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserPassword', 'query');
    },
    resetUserPassword(variables: ResetUserPasswordMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ResetUserPasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ResetUserPasswordMutation>(ResetUserPasswordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'resetUserPassword', 'mutation');
    },
    getVideoTypes(variables?: GetVideoTypesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetVideoTypesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetVideoTypesQuery>(GetVideoTypesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getVideoTypes', 'query');
    },
    getWordsByExternalAssetId(variables: GetWordsByExternalAssetIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetWordsByExternalAssetIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetWordsByExternalAssetIdQuery>(GetWordsByExternalAssetIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getWordsByExternalAssetId', 'query');
    },
    updateBulkOfWordsInTranscript(variables: UpdateBulkOfWordsInTranscriptMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateBulkOfWordsInTranscriptMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateBulkOfWordsInTranscriptMutation>(UpdateBulkOfWordsInTranscriptDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateBulkOfWordsInTranscript', 'mutation');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;